export default {
    // Page taskbar on the navbar (spec 2026-10-03 §7) — mirrors taskbar in th.js
    taskbar: {
        pin: "Pin tab",
        unpin: "Unpin tab",
        close: "Close tab",
        close_others: "Close other tabs",
        close_all: "Close all tabs",
        scroll_left: "Scroll left",
        scroll_right: "Scroll right"
    },
    // Sidebar ☰ toggler tooltip (spec 2026-10-07 T3) — mirrors sidebar in th.js
    sidebar: {
        expand: "Expand menu",
        collapse: "Collapse menu"
    },
    errors: {
        // account categories tree (bo-api 2026-10-26; Msg = errors.account.*)
        account: {
            bad_body: "The request is invalid",
            parent_not_found: "Parent category not found (it may have been deleted)",
            parent_cycle: "A category cannot be moved under itself or one of its sub-categories",
            parent_type_mismatch: "The parent must be of the same type (income/expense)",
            type_change_has_children: "Cannot change the type while the category has sub-categories",
            delete_has_children: "Cannot delete: the category still has sub-categories — move or delete them first",
            platform_on_income: "Income categories cannot be bound to a platform",
            platform_invalid: "Invalid platform",
            duplicate_name: "A category with this name already exists at this level",
        },
        // spec 2026-10-14 — recipient edit / tracking retry
        tracking_number_invalid: "Enter a tracking number (up to 45 characters)",
        bad_request: "The request is invalid",
        order_not_found: "Order not found",
        packing_not_found: "Packing round not found",
        order_has_tracking: "This order already has a tracking number",
        order_status_not_editable: "Only orders awaiting cut-off or collection can be edited",
        recipient_phone_invalid: "Recipient phone is invalid",
        recipient_postcode_invalid: "Postcode must be 5 digits",
        too_many_orders: "At most 100 orders per request",
        recipient_required: "Please fill in this field",
        order_already_returned: "Order already returned",
        no_orders: "Order not found",
        db_connection_failed: "Cannot connect to the database. Please try again.",
        db_query_failed: "Database Error",
        db_fetch_failed: "Database Error",
        permission_denied: "Access Denied",
        invalid_param: "Invalid Parameter",
        invalid_parameters: "Invalid Parameters",
        internal: "Server Error",
        payment_method_not_found: "Payment method not found",
        // BO-Packing.go:269 has sent this key all along with no translation.
        payment_method_type_not_found: "Payment type not found",
        // Overlapping seller cut (design 2026-10-04 §4.2, Redis idempotency 120s)
        cutoff_in_progress: "A cut is already running, please wait",
        tracking_in_progress: "Tracking numbers for this round are already being generated, please wait and refresh",
        // bo-api #931: round lock held by a booking pass or another change
        tracking_busy: "Tracking numbers for this round are being generated or changed, please try again shortly",
        inventory_not_found: "Product not exist in Inventory",
		orders:{
			not_found:"Order not found",
			map_product:"Product not sync to inventory",
			invalid_date_range: "Daterange can't over 31 day",
		},
        fix_status: {
            disallowed_source_status: "Source status not allowed — check submitted values",
            // Skipped rows are not errors — the job still succeeded.
            skipped_return_in_transit: "Skipped {count} order(s) with a live return (latest #{order}) — the parcel is on its way back, and forcing 'Completed' would stamp the completion date the commission report reads",
            // Do NOT use {count} here — it is bound to skipped_returning, which
            // the backend deliberately does not increment for this case.
            skipped_changed_underneath: "Skipped an order that changed while the job ran (latest #{order}) — the row was read, then someone else moved it before the write, so it was left alone",
        },
        user: {
            duplicate: "Duplicate User information",
            duplicate_username: "Duplicate Username information",
            duplicate_email: "Duplicate email information",
            blcok_delete_by_self: "Can't delete data by yourself.",
            fail: "Error update user information",
            email_wrong_format: "Wrong email format"
        },
        auth: {
            login_fail: "Login Fail",
            block: "User has been blocked",
            login_success: "Login Success",
            logout_success: "Log out Success",
            unauthoriezed: "No permission",
            reset_invalid_token: "token invalid",
            reset_token_expired: "token reset_token_expired",
            forgot_password_fail: "forgot password failed",
            reset_password_fail: "reset password failed",
            username_wrong_format: "Wrong username format",
            password_wrong_format: "Wrong password format",
            token: "Invalid Token",
            password: "Invalid password",
            password_confirm: "Invalid confirm password",
            // LINE login / LINE link — keys match the `msg` the API returns
            // (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §2).
            // Must stay in step with th.js: a key present in one file only
            // renders as the raw key string for the other locale.
            line_disabled:
                "Sign in with LINE is not enabled yet — please contact IT",
            line_state_invalid:
                "This sign-in attempt has expired or was already used. Please try again.",
            line_code_invalid:
                "The confirmation from LINE was not valid. Please try again.",
            line_verify_failed:
                "Could not verify with LINE. Please try again in a moment.",
            // 403 — the full sentence, because this is the only message that
            // tells the user what to do next.
            line_not_linked:
                "This LINE account is not linked to a Backoffice user — sign in with your password and link it on your profile page first.",
            line_already_linked:
                "This LINE account is already linked to another user",
            line_already_linked_self:
                "Your account is already linked to a different LINE account. Unlink it first.",
            // 429 — per-IP cap on authorize-url/callback (bo-api #785)
            line_too_many: "Too many LINE attempts, please wait a moment",
            // The user pressed cancel on LINE's consent screen (spec §6 ข้อ 7)
            // — not an error, and no API call is made.
            line_cancelled: "LINE sign-in was cancelled"
        },
        profile: {
            change_profile_failed: "Change profile failed",
            change_password_failed: "Change password failed",
            password_confirm_not_match: "Error confirm password",
            password_confirm_wrong_format: "Wrogn password format.",
            password_old_wrong: "Wrong old password"
        },
        wms: {
            inventory_create_fails: "Create inventory failed",
            inventory: {
                balance_not_enough: "Product not enought"
            },
            return_main: {
                return_not_configured:
                    "The source warehouse is not set up yet - please contact IT",
                return_not_configured_detail:
                    "For IT: the return warehouse is not configured. Set app.storage_for_order_return_good in the API config.yml and restart the service.",
                dest_not_configured:
                    "The destination warehouse is not set up yet - please contact IT",
                dest_not_configured_detail:
                    "For IT: the destination for good returned stock is not configured. Set app.storage_for_return_good_destination in the API config.yml and restart the service.",
                same_storage: "Source and destination warehouse are the same",
                empty_list: "No items selected",
                duplicate_product: "Duplicate product in the request"
            }
        },
        wh: { inventory: { not_found: "Inventory row not found or already deleted" } }, // delete guard 404 (bo-api #842)
        packing: {
            invalid_order_status: "Invalid Order Status",
            goods_is_added: "Goods already added"
        },
        upload: {
            presign_failed: "Upload presign failed",
            file_too_large: "File too large (max 5MB)"
        },
        catalog: {
            product_code_taken: "Product code already exists",
            coupon_code_taken: "Coupon code already exists",
            manual_sku_needs_code: "A manual-stock SKU must have a SKU code.",
            manual_sku_quantity_negative: "Manual stock quantity cannot be negative."
        },
        sku: {
            duplicate_code: "Duplicate SKU code",
            code_required: "SKU code is required",
            invalid_quantity: "Stock quantity cannot be negative"
        },
        product: {
            fixed_price_required: "Fixed price must be greater than 0",
            option_group_empty: "Each option group must have at least one value",
            no_skus: "At least one SKU is required"
        },
        api: {
            network: "Cannot reach the server. Check your connection and try again.",
            server: "Something went wrong. Please try again or contact an administrator.",
            unknown: "An error occurred. Please try again.",
            invalid_id: "The selected item is invalid.",
            invalid_body: "Invalid data. Please check the form and try again.",
            name_th_required: "Thai name is required.",
            code_required: "Product code is required.",
            price_gt0: "Price must be greater than 0.",
            sku_price_gt0: "SKU price must be greater than 0.",
            discount_value_gt0: "Percent discount value must be greater than 0.",
            category_has_products: "This category still has products. Reassign them before deleting.",
            category_name_dup: "A category with this name already exists in the same parent.",
            coupon_template_in_use: "This template has active member coupons and cannot be deactivated.",
            not_found: "The selected item was not found (it may have been removed)."
        },
        campaign: {
            invalid_date_range: "Invalid date range",
            no_targets: "Select at least 1 product",
            invalid_value: "Invalid discount value",
            not_found: "Flash sale not found",
            product_ids_invalid: "Select 1–200 products",
            product_not_in_campaign: "This product is not in the flash sale",
            name_required: "Please enter a campaign name"
        },
        promotion: {
            no_slots: "Add at least 1 slot",
            no_options: "Each slot needs at least 1 option",
            invalid_ref: "Invalid option reference",
            invalid_date_range: "Invalid date range"
        },
        cart: {
            promotion_ended: "Promotion has ended",
            option_out_of_stock: "This option is out of stock",
            incomplete_selection: "Please pick one option per slot"
        }
    },
    bc_user: "User",
    bc_change_profile: "User information",
    bc_change_password: "Change password",
    bc_admin: "Admin",
    bc_platform_connect: "Platform Connect",

    profile: {
        forgot_password_success: "A password reset link has been sent to your email",
        reset_password_success: "Password reset successfully",
        profile: "Profile",
        info: "UserInfomation",
        name: "Name",
        lname: "Surname",
        phone: "Phone",
        email: "E-Mail",
        change_password: "Change Password",
        password_old: "Old Password",
        password_new: "New Password",
        password_confirm: "Confirm Password",
        change_profile_success: "Change profile successed",
        change_password_success: "Change password successed",
        // LINE link card on the profile page
        // (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §5)
        line_title: "LINE account",
        line_not_linked: "No LINE account linked yet",
        line_linked: "Linked",
        line_connect: "Connect LINE",
        line_unlink: "Disconnect",
        line_unlink_confirm:
            "Disconnect your LINE account? You will still be able to sign in with your password.",
        line_linked_at: "Linked on",
        line_link_success: "LINE account linked",
        line_unlink_success: "LINE account disconnected",
        line_disabled: "Not enabled yet"
    },
    coupon: "Coupon",
    menu: {
        user: "User",
        member: "Member",
        admin: "Administrator",
        admin_product: "Product and promotion",
        admin_product_v2: "Platform Product V2",
        admin_skurandom: "Random SKU Products",
        admin_platform_connect: "Platform Connect",
        sale_channel: "Sale Channel",
        product: "Product",
        team: "Team",
        order_status: "Status",
        po: "Purchase Order",
        coupon: "Coupon",
        coupon_log: "Coupon Log",
        app_catalog: "Products",
        app_catalog_categories: "Product Categories",
        app_catalog_products: "Manage Products",
        app_catalog_promotions: "Flash sale",
        app_catalog_bundles: "Bundles",
        app_catalog_coupons: "Coupons",
        app_catalog_platform_category_map: "Platform Category Mapping",
        app_catalog_storefront: "Storefront Settings",
        app_catalog_storefront_home: "Storefront Home",
        app_catalog_storefront_collections: "Web collections",
        app_catalog_shipping_tiers: "Shipping Fees",
        app_catalog_wms_products: "WMS Products",
        // #301 shared stock — SKUs whose stock cannot follow the warehouse
        app_catalog_stock_unmatched: "Unmapped SKUs (WMS)",
        store_settings: "Store Settings",
        seller: "Seller",
        seller_orders: "Seller Orders",
        seller_payment_report: "Payment Report",
        issue_report: "Report Issue",
        releases: "Releases",
		member_coins_report: "Coin Liability",
        pinned_section: "Pinned Menu"
    },
    payment_report: {
        col_provider: "Provider / type",
        col_refund: "Refund",
        provider_2c2p: "2C2P",
        provider_123: "123 Service",
        group_card: "Credit/debit card",
        group_qr: "QR",
        group_wallet: "Wallet",
        group_banking: "Internet / mobile banking",
        group_counter: "Counter",
        group_other: "Other",
        refund_pending: "Refund pending",
        refund_refunded: "Refunded",
        col_pay_channel: "Paid via",
        col_tran_ref: "2C2P ref",
        title: "2C2P Payment Report",
        filter_date_from: "Date From",
        filter_date_to: "Date To",
        filter_channel: "Channel",
        filter_status: "Status",
        all: "All",
        channel_shop: "Storefront",
        channel_member: "Member (LIFF)",
        channel_app: "Application",
        status_success: "Success",
        status_in_progress: "In Progress",
        status_failed: "Failed",
        btn_search: "Search",
        btn_export: "Export CSV",
        col_invoice: "Invoice No",
        col_channel: "Channel",
        col_member: "Member",
        col_recipient: "Recipient",
        col_amount: "Amount",
        col_status: "Status",
        col_resp_code: "Resp Code",
        col_resp_desc: "Resp Desc",
        col_backend_resp_code: "Backend Code",
        col_backend_resp_desc: "Backend Desc",
        col_attempt: "Attempt",
        col_req_time: "Req Time",
        col_paid_time: "Paid Time",
        total_count: "Total Rows",
        total_amount: "Total Amount",
        no_data: "No data",
        page_range: "Showing {from}–{to} of {total}",
        load_error: "Failed to load data"
    },
    seller_orders: {
        channel_shop: "Web Store",
        channel_member: "Member",
        channel_app: "Application",
        all: "All",
        filter_date_from: "Date From",
        filter_date_to: "Date To",
        filter_status: "Status",
        filter_search: "Search",
        search_placeholder: "Order ID / phone / recipient name",
        btn_search: "Search",
        btn_view: "View",
        btn_cut_off: "Cut-off",
        col_order: "Order",
        col_channel: "Channel",
        col_status: "Status",
        col_payment_status: "Payment",
        col_amount: "Amount",
        col_placed_at: "Placed At",
        col_bo: "BO Order",
        col_actions: "Actions",
        col_image: "Image",
        col_product: "Product",
        col_qty: "Qty",
        col_unit_price: "Unit Price",
        col_line_total: "Total",
        col_invoice: "Invoice No",
        total_count: "Total",
        no_data: "No data",
        load_error: "Failed to load data",
        detail_title: "Order Detail",
        detail_order: "Order Info",
        detail_items: "Items",
        detail_address: "Shipping Address",
        detail_payment: "Payment Info",
        pay_success: "Paid",
        pay_in_progress: "In Progress",
        pay_failed: "Failed",
        pay_none: "Unpaid",
        status_100: "Awaiting Payment",
        status_111: "Awaiting Shipment",
        status_112: "Awaiting Collection",
        status_121: "In Transit",
        status_122: "Delivered",
        status_130: "Completed",
        status_140: "Cancelled",
        cutoff_title: "Channel Pack Cut-off",
        cutoff_channel: "Channel (eligible count)",
        cutoff_payment_type: "Payment type",
        cutoff_shipping_provider: "Shipping Provider (0 = all)",
        cutoff_back_days: "Back Days",
        cutoff_zero_hint: "Use 0 to include all",
        btn_cancel: "Cancel",
        btn_confirm_cut: "Confirm Cut-off",
        cutoff_success_title: "Cut-off Done",
        cutoff_success_text: "Created packing round #{id} with {cnt} orders ({channel})",
        cutoff_error: "Cut-off failed",
        // Cross-channel packing round (design 2026-10-04 §6.6) — mirrors th.js
        filter_payment_type: "Payment type",
        col_payment_type: "Payment type",
        col_recipient: "Recipient",
        col_packing_round: "Packing round",
        chip_web: "Web",
        chip_member: "Member",
        chip_app: "App",
        chip_total: "Total",
        chip_unassigned: "No channel",
        chip_unassigned_hint: "Orders with no sale channel — they are still included in the round",
        chip_ambiguous: "Channels share one mapping; only the total is shown",
        cutoff_title_all: "Cut a packing round — web + member + app",
        cutoff_scope_note: "One round covers every channel (web, member, app). No channel or carrier to pick.",
        cutoff_back_days_label: "Look back (days)",
        cutoff_table_channel: "Channel",
        cutoff_table_count: "Orders",
        cutoff_total: "Total to cut",
        cutoff_none: "No orders are ready to cut in the selected window",
        cutoff_confirm_text: "Cut a packing round of {cnt} orders? They move to the pack room and cannot be undone from this page.",
        cutoff_success_all: "Round #{id} created with {cnt} orders (web {web} / member {member} / app {app}) · Generating Thailand Post tracking numbers",
        cutoff_warn_no_wms: "{cnt} orders have no warehouse mapping — check the unmapped-SKU page",
        btn_go_packing: "Open pack room",
        preview_error: "Could not load the ready-to-cut counts",
        // status tabs + filter panel (design 2026-10-05 §5.5) — pair with th.js
        tab_all: "All",
        tab_to_ship: "To ship",
        tab_shipping: "Shipping",
        tab_completed: "Completed",
        tab_cancelled: "Cancelled",
        tab_returns: "Returns",
        btn_filter: "Filters",
        filter_title: "Filters",
        filter_clear_all: "Clear all",
        filter_apply: "Apply",
        filter_reset: "Reset filters",
        found_n: "{n} orders found",
        period_all: "Period: all time",
        period_hint: "The list and the ready-to-cut counts are taken over this period",
        f_sub_status: "Order status",
        f_date_type: "Date type",
        date_created: "Order date",
        date_paid: "Paid date",
        date_shipping: "Last shipping update",
        f_order_q: "Order no. / tracking no.",
        f_customer_q: "Customer name / phone",
        f_product_q: "Product / code / SKU",
        f_channels: "Channel",
        f_pay_state: "Payment status",
        f_shipping: "Carrier",
        f_packing: "Packing round",
        pay_state_paid: "Paid",
        pay_state_unpaid: "Unpaid",
        pay_state_cod: "COD",
        packing_none: "Not in a round",
        packing_in: "In a round",
        f_wms_unmapped: "Only orders without warehouse mapping",
        chip_chat: "Chat",
        status_114: "Partially shipped",
        status_115: "Awaiting carrier pickup",
        status_141: "Returned",
        status_142: "Claim",
        status_143: "Returning",
        chip_scope_hint: "Counts only orders already in the backoffice within the look-back window — may be lower than the tab count",
        empty_tab: "No orders in this tab",
        empty_filtered: "No orders match the filters",
        wms_truncated: "Showing the first 2,000 unmapped orders only",
        // Owner 2026-10-15: tracking column, 2C2P card label, inline order detail.
        col_tracking: "Tracking no.",
        copy: "Copy",
        copied: "Copied {value}",
        copy_failed: "Copy failed",
        pay_type_card_2c2p: "Credit/Debit card (2C2P)",
        // Owner 2026-10-26: the real 2C2P channel details (payment.channel).
        pay_ch_card: "Card",
        pay_ch_issuer: "Issuer",
        pay_ch_approval: "Approval code",
        pay_ch_tran_ref: "2C2P ref",
        pay_ch_reference: "Reference No.",
        pay_ch_time: "Paid at (2C2P)",
        pay_ch_result: "2C2P result",
        pay_ch_codes: "Channel codes",
        detail_retry: "Retry",
        detail_customer_note: "Customer note",
        detail_shipping: "Shipping",
        detail_carrier_status: "Carrier status",
        detail_paid_at: "Paid at",
        detail_amount_items: "Items",
        detail_discount: "Discount",
        detail_shipping_cost: "Shipping",
        detail_no_items: "No items",
        detail_wms_items: "Pack list (warehouse)",
        detail_no_wms_items: "No pack list yet (order not in the backoffice yet, or not mapped to the warehouse)",
        detail_timeline: "Timeline",
        detail_hide: "Hide details",
        tl_created: "Order placed",
        tl_paid: "Paid",
        tl_cancelled: "Cancelled",
        // spec 2026-10-16 seller-order-cancel-actor-reason §5: who cancelled + why, seller cancel
        cancel_by_customer: "Cancelled by customer",
        cancel_by_staff: "Cancelled by staff",
        cancel_by_staff_named: "Cancelled by staff ({name})",
        cancel_by_system: "Auto-cancelled",
        cancel_block_title: "Cancellation",
        cancel_actor: "Cancelled by",
        cancel_type: "Type",
        cancel_reason: "Reason",
        cancel_time: "Time",
        cancel_btn: "Cancel order",
        cancel_dialog_title: "Cancel order {order}",
        cancel_type_label: "Cancel type",
        cancel_reason_placeholder: "-- Cancel reason --",
        cancel_note_label: "Cancel reason",
        cancel_note_placeholder: "Reason (staff only, never shown to the customer)",
        cancel_note_too_long: "Reason is longer than 255 characters",
        cancel_confirm_title: "Cancel this order?",
        cancel_confirm_text: "Order {order} will be cancelled (with its linked Backoffice orders, if any). This cannot be undone.",
        cancel_confirm_btn: "Confirm cancel",
        cancel_close: "Close",
        cancel_success: "Order cancelled",
        cancel_error: "Could not cancel the order",
        cancel_text_auto_expired_24h: "Not paid within 24 hours",
        cancel_text_auto_max_attempts: "Too many failed payment attempts",
        cancel_text_payment_timeout: "Payment timed out",
        cancel_text_payment_failed: "Payment failed",
        cancel_text_staff_cancel_customer_request: "Customer asked to cancel",
        cancel_text_staff_cancel_store: "Cancelled by the store",
        cancel_text_staff_cancel_shipping: "Shipping problem",
        cancel_text_staff_cancel_payment: "Payment problem",
        cancel_text_staff_cancel_other: "Cancelled by staff"
    },
    // BO order overview (route BOOrdersOverview, staff only #441) — spec 2026-10-07 §6.7
    orders_new: {
        title: "Order overview",
        tab_all: "All",
        tab_unpaid: "Unpaid",
        tab_to_ship: "To ship",
        tab_shipping: "Shipping",
        tab_completed: "Completed",
        tab_cancelled: "Cancelled",
        tab_returns: "Returns",
        btn_filter: "Filters",
        filter_title: "Filters",
        filter_clear_all: "Clear all",
        filter_apply: "Apply",
        filter_cancel: "Cancel",
        filter_reset: "Reset filters",
        found_n: "{n} orders found",
        period: "Period: {from} – {to}",
        f_sub_status: "Order status",
        f_date: "Date range",
        date_created: "Created date",
        date_payment: "Paid date",
        f_keyword: "Order no. / phone / name / tracking no.",
        kw_order: "Order no.",
        kw_phone: "Phone",
        kw_tracking: "Tracking no.",
        kw_name: "Recipient name",
        f_user: "Staff",
        f_platform: "Platform",
        f_sale_channel: "Sales channel",
        f_sale_channel_type: "Channel type",
        f_payment_type: "Payment type",
        f_packing: "Packing status",
        platform_default: "MadameFin + MDFStore (default)",
        packing_all: "All",
        packing_closed: "Closed",
        packing_open: "Not closed",
        packing_not_opened: "Awaiting packing",
        all: "All",
        view: "View details",
        col_platform: "Platform",
        range_too_long: "Date range must be 35 days or less, start before end",
        date_ignored_hint: "Keyword search ignores the date range",
        truncated: "Showing the first {n} orders only — narrow the date range",
        empty_tab: "No orders in this tab",
        empty_filtered: "No orders match the filters",
        load_error: "Could not load orders",
        platform_all: "All platforms",
        selection: "Showing: {platform} · {tab}",
        platform_load_error: "Could not load this platform",
        partial_load: "Some platforms failed to load: {names} — the All row excludes them",
        truncated_platforms: "Row cap reached for {names} — narrow the date range",
        page_size: "Rows per page",
        page_size_option: "{n} rows",
        menu: "Actions",
        act_change_shipping: "Change shipping provider",
        act_change_tracking: "Edit tracking number",
        act_cancel: "Cancel order",
        copy: "Copy",
        copied: "Copied: {value}",
        copy_failed: "Could not copy",
        // §14.4 R31 round 6: inline order detail
        detail_hide: "Hide details",
        items: "Items",
        wms_items: "Items to pack (WMS)",
        payment_proof: "Payment proof",
        no_items: "No items",
        no_wms_items: "Nothing to pack",
        detail_retry: "Retry",
        recipient: "Recipient",
        shipping: "Shipping",
        payment: "Payment",
        amount_items: "Items",
        amount_pay: "To pay",
        created_by: "by",
        shipping_cost: "Shipping fee",
        cancel_reason: "Cancel reason",
        // §15.3 R36 round 7: slip preview + in-place payment check
        payment_check: "Payment check",
        no_slip: "No payment proof",
        confirm_payment_ok: "Confirm payment is correct?",
        confirm_payment_fail: "Confirm payment is incorrect? (order will be cancelled)",
        preview_slip: "View full size",
        // Shopee cancel reconcile §11 F1
        cancel_requested: "Cancel requested (pending)",
        platform_status_stale: "Last status heard from the platform — may be older than the real one",
        // §19 R44/R45 round 11: packing info in the detail + fulfilment stage columns
        pk_opened_by: "Packing opened by",
        pk_opened_at: "Opened at",
        pk_closed_at: "Closed at",
        pk_line: "Packing line",
        stage_wait_cutoff: "Awaiting cut-off",
        stage_wait_open: "Awaiting packing",
        stage_packing: "Packing",
        stage_wait_pickup: "Awaiting pickup",
        stage_in_transit: "In transit",
        f_stage: "Stage",
        // §20 R47–R49: tracking timeline button + modal in the detail
        tracking_view: "View tracking",
        tracking_title: "Tracking timeline",
        tracking_updated: "Last updated {at}",
        tracking_loading: "Loading tracking…",
        tracking_empty: "No tracking events yet",
        tracking_error: "Could not load tracking",
        tracking_latest: "Latest"
    },
    checkout_settings: {
        title: "Order Policy",
        subtitle: "Checkout rules for storefront customers (www + member + app).",
        cod_max_pending_label: "Max open COD orders per member",
        cod_max_pending_help: "How many cash-on-delivery orders a member may have open at once — orders not yet received (awaiting payment / awaiting shipment / packing / partially shipped / awaiting pickup / in transit), also counted by the same phone number. Delivered, completed, cancelled and returned orders do not count. At the limit the COD option is greyed out with the reason on the website and LINE; the mobile app does not grey it out yet — it shows the refusal message when the customer places the order. The customer can always pay another way (0 = unlimited, default 3).",
        otp_daily_cap_label: "Max OTP SMS per day (whole system)",
        otp_daily_cap_help: "Hard ceiling on the total number of OTP SMS the entire system will send per day, across all phone numbers and IPs (0 = unlimited). A last-resort cost cap against SMS-bombing; when reached, further OTP requests are blocked until the next day. Default 500.",
        cod_reject_threshold_label: "Max COD delivery refusals",
        cod_reject_threshold_help: "Block cash-on-delivery for a phone once it has this many refused (returned) deliveries (0 = disabled, default 3). Prepaid checkout still works. Admins clear the history to unblock under Member Management.",
        points_per_100_label: "Points earned per 100 THB",
        points_rate_custom_toggle: "Set a custom rate",
        points_rate_unset_label: "Not set — uses the member tier's default earn rate.",
        points_per_100_help: "Loyalty points a member earns for every 100 THB paid, calculated on the actual amount (e.g. set 100 → an order of 150 THB earns 150 points). Applies to orders completed after this setting is saved. Not set = uses the member tier's default rate; 0 = points disabled system-wide.",
        btn_save: "Save",
        saved: "Settings saved"
    },
    cashback_settings: {
        title: "Cash Back",
        subtitle: "Set the shop-wide cash back percentage; a bundle promotion may override it with its own.",
        enabled_label: "Enable Cash Back",
        enabled_help: "While off, no cash back is calculated for anyone. The percentage you set is still stored, so turning it on later resumes with the same value.",
        default_percent_label: "Shop cash back percentage",
        default_percent_help: "The default applied to every promotion that does not set its own (0.00–100.00, two decimals).",
        hint: "A promotion with its own percentage REPLACES this default (it is not added on top). No coins are granted yet — this is configuration only until the coin system is switched on.",
        btn_save: "Save",
        saved: "Cash back settings saved",
        promo_label: "Cash Back %",
        promo_hint: "0 = use the shop default. Above 0 = use this value INSTEAD of the shop default (not on top of it).",
        badge: "Cash Back",
        effective_off: "Cash back is off — nothing is granted to customers yet.",
        effective_promo: "Effective: {percent}% (this promotion's own value)",
        effective_default: "Effective: {percent}% (the shop default)"
    },
    app_version_settings: {
        title: "App version / force update",
        subtitle: "Set the minimum app version customers must update to, and the latest version to recommend, per Android / iOS",
        android: "Android",
        ios: "iOS",
        min_label: "Minimum version (forced)",
        min_help: "Below this, customers must update before they can use the app. Empty = no force.",
        latest_label: "Latest version (recommended)",
        latest_help: "Below this, customers get a dismissible update prompt. Empty = no prompt.",
        store_url_label: "Store link (Play Store / App Store)",
        message_th_label: "Update message (Thai)",
        message_en_label: "Update message (English)",
        btn_save: "Save",
        confirm_raise_min: "Customers on a version below {versions} will not be able to use the app until they update. Continue?",
        saved: "App version settings saved",
        hint: "Use x.y.z only (build numbers are ignored) · empty = off · only set after the supporting app version is live in the store · no App Store link = iOS is never forced",
        placeholder_example: "e.g. {example}",
        load_failed: "Could not load the app version settings, so they cannot be edited or saved (to avoid wiping the stored values by accident).",
        retry: "Retry",
        err: {
            invalid_version: "Invalid version format, use x.y.z e.g. 1.5.0",
            min_gt_latest: "Minimum version must not be higher than the latest version",
            store_url_https: "The link must start with https://",
            message_too_long: "Message is longer than 300 characters"
        }
    },
    coin_terms: {
        title: "Coin wording",
        subtitle: "The coin wording customers read — unit name, short note and full terms. Edit it here; no deploy required.",
        name_th_label: "Unit name (Thai)",
        name_en_label: "Unit name (English)",
        name_help: "What this unit is called to customers, e.g. coin / point.",
        note_th_label: "Short note (Thai)",
        note_en_label: "Short note (English)",
        note_help: "Shown under the coin box at checkout and on the coin page — keep it to one readable line.",
        terms_th_label: "Full terms (Thai)",
        terms_en_label: "Full terms (English)",
        terms_help: "Plain text only (no HTML). Every line break starts a new paragraph.",
        placeholder_hint: "Two placeholders are available; the system substitutes the live numbers before customers see the text — {tok_months} = coin lifetime in months, {tok_max} = maximum share that may be paid with coins (%). A misspelt name is shown with its braces exactly as typed. Use \"Preview\" to see the real values.",
        version_line: "Version {version} · last edited {date}",
        version_never: "Never edited — the built-in default wording is in use.",
        btn_preview: "Preview",
        btn_save: "Save wording",
        saved: "Coin wording saved",
        no_change: "Nothing was edited, so nothing was saved.",
        hint: "The version number is bumped automatically when the full terms change. Only the boxes you edited are sent; untouched boxes keep their stored value.",
        preview_title: "What the customer sees",
        preview_th: "Thai",
        preview_en: "English",
        preview_name_head: "Unit name",
        preview_note_head: "Short note",
        preview_terms_head: "Full terms",
        preview_empty: "No text yet",
        preview_close: "Close",
        err_form: "Some fields are not acceptable. Fix the ones marked in red below.",
        err_bad_text: "The server rejected this text — the unit name must not be empty, each field must stay within its length limit, and HTML tags are not allowed.",
        err: {
            empty: "The unit name is required.",
            too_long: "This text is longer than the limit.",
            tag: "HTML tags (e.g. <b>, <script>) are not allowed — use plain text only.",
            not_text: "The value received is not text. Please reload this page."
        }
    },
    mdfstore_channel: {
        title: "MDFStore Sale Channel",
        subtitle: "Map each MDFStore order source to a sale channel. Orders synced from the storefront web, member system, and app are tagged with the matching channel in Backoffice.",
        source_web: "Web Storefront",
        source_web_help: "Sale channel for orders placed on the storefront website (www).",
        source_member: "Member System",
        source_member_help: "Sale channel for orders placed in the member system.",
        source_app: "Application",
        source_app_help: "Sale channel for orders placed in the mobile app.",
        select_placeholder: "Select sale channel",
        no_options: "No MDFStore sale channels found. Create one under Sale Channel with platform \"MDFStore\" first.",
        btn_save: "Save",
        saved: "Sale channel mapping saved"
    },
    cod_rejections: {
        menu: "COD Refusal History",
        title: "COD Delivery-Refusal History",
        subtitle: "Phone numbers with a history of refused cash-on-delivery parcels (returned) — blocked at {threshold} refusals.",
        btn_refresh: "Refresh",
        col_phone: "Phone",
        col_member: "Member",
        col_count: "Refusals",
        col_last: "Last refused",
        col_status: "Status",
        col_action: "Action",
        col_invoice: "Order No.",
        col_created: "Ordered",
        col_rejected: "Refused",
        guest: "Guest",
        blocked: "Blocked",
        ok: "OK",
        btn_clear: "Clear history",
        clear_title: "Clear history / unblock",
        clear_msg: "Clear the delivery-refusal history for {phone}? This number will be able to place COD orders again (past records are kept for audit).",
        clear_success: "History cleared",
        empty: "No phone numbers with a delivery-refusal history yet."
    },
    storefront: {
        hero_title: "Hero Carousel",
        hero_subtitle: "Slides shown on the storefront homepage (www + member).",
        popup_title: "First-visit Popup",
        popup_subtitle: "Popup shown to first-time visitors.",
        btn_add_slide: "Add Slide",
        edit_slide: "Edit Slide",
        no_slides: "No slides yet",
        col_order: "Order",
        col_image: "Image",
        col_caption_th: "Caption (TH)",
        col_caption_en: "Caption (EN)",
        col_link: "Link URL",
        col_enabled: "Enabled",
        popup_enabled: "Enabled",
        show_on_www: "Show on Shop (www)",
        show_on_member: "Show on Member",
        field_image_required: "Please upload an image",
        save_success: "Saved successfully",
        delete_title: "Confirm delete?",
        delete_msg: "This slide will be removed permanently.",
        delete_popup_msg: "This popup will be removed permanently.",
        delete_success: "Deleted successfully",
        btn_delete: "Delete",
        btn_cancel: "Cancel",
        btn_add_popup: "Add Popup",
        edit_popup: "Edit Popup",
        no_popups: "No popups yet",
        col_title: "Title",
        col_active: "Active",
        activate_success: "Active popup updated"
    },
    storefront_home: {
        title: "Home Page Content",
        subtitle: "Edit every text, image and link on the storefront homepage. Each section saves independently.",
        save: "Save",
        saved: "Saved",
        save_failed: "Save failed",
        add_item: "Add item",
        remove_item: "Remove",
        move_up: "Move up",
        move_down: "Move down",
        sec_topbar: "Top bar",
        sec_promobar: "Promo bar",
        sec_header: "Header (logo/nav)",
        sec_hero: "Hero",
        sec_campaigns: "Campaigns",
        sec_bestsellers: "Top 5 Bestsellers",
        sec_banner1: "Campaign banner",
        sec_new_arrival: "New Arrival",
        sec_new_arrival2: "New Arrival strip 2",
        sec_essence: "The Essence of Style",
        sec_collections: "Featured Collections",
        sec_footer: "Footer",
        f_text: "Text",
        f_title: "Title",
        f_subtitle: "Subtitle",
        f_copy: "Copy",
        f_eyebrow: "Eyebrow",
        f_details: "Details (multiline)",
        f_price: "Price line",
        f_cta_label: "Button label",
        f_cta_link: "Button link",
        f_image: "Image",
        f_image_left: "Left image",
        f_image_product: "Product image",
        f_image_app: "App banner image",
        f_image_left_app: "App image (left)",
        f_image_product_app: "App image (product)",
        app_image_hint: "For the mobile app only (different ratio from web). The web image above is not affected.",
        f_link: "Link",
        f_label: "Label",
        f_label_en: "Label (EN)",
        f_label_th: "Label (Thai)",
        f_title_en: "Title (EN)",
        f_title_th: "Title (Thai)",
        label_th_hint: "Optional — the standard translation is used when one exists",
        f_logo: "Logo text",
        f_amount: "Discount amount",
        f_code: "Code / note",
        f_theme: "Theme",
        f_platform: "Platform",
        f_product: "Product",
        theme_dark: "Dark",
        theme_light: "Light",
        theme_gift: "Gift",
        search_product: "Type to search products",
        max_products: "Max 5 products",
        nav_items: "Nav items",
        socials: "Social links",
        newsletter: "Newsletter",
        newsletter_title: "Newsletter title",
        newsletter_subtitle: "Newsletter subtitle",
        newsletter_placeholder: "Input placeholder",
        newsletter_cta: "Subscribe button",
        col_links: "Link columns",
        col_shop: "Shop column",
        col_about: "About column",
        col_help: "Help column",
        brand: "Brand name",
        copyright: "Copyright",
        card: "Card",
        slot: "Slot",
        bestseller_hint: "Pick up to 5 products; order matters (slot 1 = first).",
        image_stores_key: "Only the object key is stored; preview uses the CDN URL.",
        updated_meta: "Last updated {time} by user #{by}"
    },
    // www collections + discovery sets (spec 2026-10-13-www-nav-i18n-collections §5.2)
    storefront_collection: {
        title: "Web collections",
        subtitle: "Curate the collections and discovery sets shown on the website at /collections and /discovery-sets",
        tab_collections: "Collections",
        tab_discovery: "Discovery Sets",
        create: "Create collection",
        create_title: "Create collection",
        edit_title: "Edit collection",
        empty: "No collections yet",
        col: {
            order: "Order",
            cover: "Cover",
            name: "Name (TH / EN)",
            slug: "Slug",
            items: "Items",
            status: "Status",
            updated: "Last updated",
            actions: "Actions"
        },
        f: {
            name_th: "Name (Thai)",
            name_en: "Name (EN)",
            slug: "Slug",
            description_th: "Description (Thai)",
            description_en: "Description (EN)",
            cover: "Cover image",
            items: "Products / bundles",
            is_active: "Active",
            add_product: "Add product",
            add_bundle: "Add bundle",
            search_product: "Search products (code / name)",
            pick_bundle: "Pick a bundle"
        },
        slug_hint: "a-z, 0-9 and - only, e.g. glam-collection (suggested from the EN name)",
        items_hint: "List order = order on the website. Unavailable items are not shown on the website.",
        items_counter: "{count}/{max}",
        no_items: "No items yet",
        type_product: "Product",
        type_bundle: "Bundle",
        unavailable: "Unavailable",
        active: "On",
        inactive: "Off",
        page_link: "Web page",
        copy_url: "Copy link",
        copied: "Link copied",
        open_page: "Open web page",
        edit: "Edit",
        delete: "Delete",
        move_up: "Move up",
        move_down: "Move down",
        remove: "Remove",
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        confirm_delete: "Delete collection \"{name}\"? The link /collections/{slug} will stop working.",
        saved: "Saved — the website updates within 1 minute",
        deleted: "Collection deleted",
        discovery_hint: "A single record shown on /discovery-sets; it has no slug.",
        err: {
            slug_taken: "This slug is already in use",
            slug_reserved: "The slug \"discovery-sets\" is reserved for the Discovery Sets page",
            schema_missing: "Run SQL 2026-10-13-storefront-collection.sql first",
            stale: "Someone else changed this record — the latest data has been loaded, please review and save again",
            too_many_items: "Up to 60 items",
            forbidden: "Only admins can edit this",
            load: "Could not load data",
            copy_failed: "Could not copy",
            fix_fields: "Please fix the fields marked in red"
        },
        rule: {
            required: "Required",
            max_length: "Too long",
            format: "a-z, 0-9 and - (2–60 chars), not starting or ending with -",
            reserved: "This slug is reserved",
            taken: "This slug is already in use",
            too_many: "Up to 60 items",
            range: "Invalid value",
            invalid: "Invalid value"
        }
    },
    app_catalog: {
        btn_add_category: "Add Category",
        btn_add_product: "Add Product",
        btn_add_campaign: "Create flash sale",
        // แฟลชเซล page (spec 2026-10-05-flash-sale-campaign-page §6.3)
        flash_sale_new_title: "New flash sale",
        flash_sale_edit_breadcrumb: "Edit flash sale",
        flash_sale_edit_title: "Edit flash sale : {id}",
        flash_sale_info: "Campaign details",
        flash_sale_name: "Campaign name",
        flash_sale_period: "Active period",
        flash_sale_period_hint: "Thailand time (GMT+7)",
        flash_sale_discount_type: "Discount type",
        flash_sale_products: "Products ({n})",
        flash_sale_add_products: "Add products",
        flash_sale_save_first: "Save the campaign before adding products",
        flash_sale_products_empty: "No products in this flash sale yet",
        flash_sale_selected: "{n} selected",
        flash_sale_clear_selection: "Clear selection",
        flash_sale_in_campaign: "Already added",
        flash_sale_add_result: "Added {added} (skipped {skipped} already in)",
        flash_sale_remove_confirm: "Remove this product from the flash sale?",
        flash_sale_col_normal_price: "Normal price",
        flash_sale_col_sale_price: "Flash sale price",
        flash_sale_col_remaining: "Remaining",
        flash_sale_col_products: "Products",
        flash_sale_flash_conflict: "⚡ SKU flash overrides {n} SKU",
        flash_sale_flash_shopee: "⚡ Shopee price {price} applies instead",
        flash_sale_flash_manual: "⚡ Manual flash {price} applies instead",
        flash_sale_overlap: "Overlaps: {name} #{id}",
        flash_sale_overlap_hint: "The deepest discount wins",
        flash_sale_overlap_warn: "{n} products are in another flash sale at the same time",
        flash_sale_need_products: "Add products before activating",
        flash_sale_unsaved_confirm: "Leave without saving?",
        flash_sale_sold_out: "Sold out",
        flash_sale_sku_closed: "SKU closed",
        flash_sale_not_found: "Flash sale not found",
        flash_sale_col_sku: "SKU",
        flash_sale_leave: "Leave",
        flash_sale_remove: "Remove",
        flash_sale_view_skus: "Show SKUs",
        flash_sale_name_hint: "Click the name to see SKUs",
        flash_sale_view: "View",
        flash_sale_app_disabled: "Not on sale",
        flash_sale_search_placeholder: "Search name / code",
        flash_sale_back_to_list: "Back to list",
        flash_sale_image_hint: "Click the image to see SKUs",
        phase_draft: "Draft",
        phase_upcoming: "Upcoming",
        phase_ongoing: "Ongoing",
        phase_expired: "Expired",
        phase_ended: "Ended",
        btn_add_coupon_template: "Create Coupon Template",
        image_upload_hint: "Click or drag file here (JPG/PNG, max 5MB)",
        delete_title: "Confirm delete?",
        delete_msg: "This action cannot be undone.",
        delete_success: "Deleted successfully",
        deactivate_title: "Confirm deactivation?",
        deactivate_msg: "This coupon template will be deactivated and can no longer be used.",
        deactivate_success: "Deactivated successfully",
        btn_delete: "Delete",
        btn_deactivate: "Deactivate",
        btn_cancel: "Cancel",
        save_success: "Saved successfully",
        field_required: "This field is required",
        no_data: "No data",
        select_anchor_first: "Select an anchor product first",
        status_draft: "Draft",
        status_active: "Active",
        status_ended: "Ended",
        discount_type_percent: "Percent",
        discount_type_fixed: "Fixed Amount",
        discount_type_shipping_free: "Free Shipping",
        campaign_kind_percent: "% Off",
        campaign_kind_fixed: "Fixed Amount Off",
        edit_category: "Edit Category",
        edit_product: "Edit Product",
        edit_campaign: "Edit Campaign",
        // Edit-page titles WITH the record id (owner 2026-10-05). Separate keys
        // from edit_* above: edit_product is also the kebab item label on the
        // products list, where an id would be noise. Placeholder: {id}.
        edit_category_title: "Edit category : {id}",
        edit_product_title: "Edit product : {id}",
        edit_campaign_title: "Edit promotion : {id}",
        edit_bundle_title: "Edit bundle : {id}",
        edit_coupon_template: "Edit Coupon Template",
        col_image: "Image",
        // /seller/products large-image preview (owner 2026-10-15) · placeholder: {name}
        image_preview_open: "View large image: {name}",
        image_preview_close: "Close",
        image_preview_loading: "Loading image…",
        image_preview_error: "Could not load the image",
        col_name_th: "Name (TH)",
        col_name_en: "Name (EN)",
        col_sort_order: "Order",
        // category channel visibility (spec 2026-10-05 §6)
        col_show_web: "Web",
        col_show_member: "Member",
        col_show_app: "App",
        visibility_label: "Show on",
        visibility_hint: "Switch off to hide a category from the menu on every channel. Its products stay purchasable.",
        visibility_hidden_all: "Hidden everywhere",
        visibility_saved: "Visibility saved",
        visibility_failed: "Could not save visibility",
        visibility_not_ready: "Not available yet (database update pending)",
        // single switch (owner follow-up 2026-10-05)
        col_show: "Show",
        visibility_hidden: "Hidden",
        visibility_mixed: "Set per channel",
        col_code: "Code",
        col_price: "Price",
        col_app_enable: "Sale status",
        col_app_tag: "Tag",
        col_cod: "COD",
        col_visibility: "Visible",
        col_detail: "Detail",
        col_category: "Category",
        col_app_discount: "Discount",
        col_discount_start: "Discount Start",
        col_discount_end: "Discount End",
        col_kind: "Kind",
        col_value: "Value",
        col_starts_at: "Starts At",
        col_ends_at: "Ends At",
        col_date_range: "Date Range",
        col_targets: "Target Products",
        search_products: "Search products",
        select_category: "Select category",
        section_basic_info: "Basic Info",
        section_images: "Images",
        section_skus: "SKUs",
        section_discount: "Discount",
        sku_code: "SKU Code",
        sku_name: "SKU Name",
        // #246 + #257 the SKU CODE is generated from the man_pn of the WMS
        // products picked in the dialog (joined with "+") and is never typed by
        // hand. man_pn is the code the BE auto-mapper can parse back into a
        // wms_map. (#257 moved the target from sku_name to sku_code; the name is
        // free text again.)
        sku_wms_edit: "Edit SKU code from WMS products",
        sku_wms_modal_title: "Select WMS products for this SKU",
        sku_wms_select_placeholder: "Search WMS product (product code man_pn / name)",
        sku_wms_add: "Add to list",
        sku_wms_remove: "Remove from list",
        sku_wms_confirm: "Confirm",
        sku_wms_cancel: "Cancel",
        sku_wms_empty: "No WMS product selected — the SKU code will be empty",
        sku_wms_qty: "Qty",
        sku_wms_qty_hint: "Units picked per SKU — the SKU code repeats each product code once per unit (2 = A+A)",
        sku_wms_duplicate: "Already in the list — quantity is now {n}",
        sku_wms_qty_max: "At most {max} units per WMS product",
        sku_wms_load_failed: "Failed to load the WMS product list",
        sku_wms_preview: "Generated SKU code (product codes joined with +)",
        // #257 mdfpf_product_sku.sku_code is varchar(100) — confirm is refused above it
        sku_code_too_long: "The generated SKU code is longer than {max} characters — map fewer warehouse units",
        sku_wms_single_source: "Map WMS products here only — the Platform product page is no longer used for this.",
        sku_price: "Price",
        sku_quantity: "Qty",
        add_sku: "Add SKU",
        sku_images: "SKU Images",
        manage_images: "Manage",
        promo_bundle_title: "Promotion Bundles",
        btn_add_bundle: "Add Bundle",
        edit_bundle: "Edit Bundle",
        promo_kind: "Type",
        promo_kind_sku: "From SKUs",
        promo_kind_wms: "From WMS products",
        promo_price_mode: "Price mode",
        promo_price_sum: "Sum of options",
        promo_price_fixed: "Fixed price",
        promo_fixed_price: "Fixed price",
        image_mode_label: "Hero image display",
        image_mode_main: "Show main image",
        image_mode_sku: "Show image by SKU",
        image_mode_hint: "Main image: the hero stays fixed on the bundle cover even when a customer selects an option. Image by SKU: the hero follows the selected option's image.",
        market_label: "Market",
        market_domestic: "Domestic",
        market_international: "International",
        market_both: "Both markets",
        market_hint: "Controls which market's customers can see this promotion (default: domestic)",
        bonus_points_label: "Bonus points",
        bonus_points_hint: "Extra loyalty points per bundle purchased (0 = fall back to SKU-level bonus)",
        market_filter_all: "All markets",
        slot: "Slot",
        add_slot: "Add Slot",
        duplicate_slot: "Duplicate slot",
        bulk_flash_label: "Set flash sale for all options:",
        bulk_flash_apply: "Apply to all",
        bulk_flash_applied: "Applied flash sale to {count} options",
        bulk_flash_empty: "Set a flash price or window first",
        slot_label: "Slot label",
        option: "Option",
        add_option: "Add Option",
        option_label: "Option label",
        option_image: "Image",
        option_upload_image: "Upload",
        option_change_image: "Change",
        option_remove_image: "Remove",
        option_price: "Price",
        option_display_name: "Display name",
        option_flash_price: "Flash price",
        option_flash_window: "Flash window",
        search_wms_product: "Search WMS product",
        anchor_product: "Anchor product",
        coupon_code: "Code",
        coupon_discount_type: "Discount Type",
        coupon_discount_value: "Discount Value",
        coupon_max_discount: "Max Discount",
        coupon_min_purchase: "Min Purchase",
        coupon_expiry_days: "Expiry Days",
        coupon_valid_from: "Valid From",
        coupon_valid_to: "Valid To",
        coupon_eligibility: "Eligibility",
        eligibility_any: "Any member",
        eligibility_new_member: "New member (welcome)",
        eligibility_birthday: "Birthday",
        eligibility_level_up: "Level up",
        eligibility_manual: "Manual",
        eligibility_public_code: "Public code (customer types it)",
        public_code_hint: "Customers type this code at checkout · upper-case A-Z 0-9",
        col_issued_quota: "Issued/Quota",
        err_public_code_invalid: "A public code must be 4-20 characters of A-Z or 0-9",
        err_public_code_expiry_days: "A public code needs expiry days of at least 1",
        err_public_code_discount_value: "Discount value must be greater than 0",
        err_public_code_points_cost: "A public code cannot cost points (points cost must be 0)",
        err_public_code_valid_window: "'Valid To' must be after 'Valid From'",
        err_public_code_taken: "An active public code with this code already exists",
        err_public_code_conflicts_campaign: "This code clashes with a live campaign coupon code",
        coupon_points_cost: "Points Cost",
        coupon_max_use_per_member: "Max Use Per Member",
        coupon_total_quota: "Total Quota",
        coupon_is_active: "Active",
        enabled: "Enabled",
        disabled: "Disabled",
        deactivate_coupon_confirm: "Deactivate this coupon?",
        campaign_delete_warning: "This action cannot be undone.",
        sku_stock_source: "Stock source",
        sku_stock_auto: "Auto (sync)",
        sku_stock_manual: "Manual",
        sku_stock_auto_hint: "Synced automatically from platform",
        // #257 the flash-sale columns stay hidden until the product uses them
        sku_show_flash: "Show flash sale",
        sku_flash_price: "Flash price (SKU)",
        sku_flash_window: "Flash window (SKU)",
        sku_bonus_points: "Bonus points",
        product_price_mode: "Price Mode",
        product_price_per_sku: "Per-SKU Price",
        product_price_fixed: "Fixed Price",
        product_fixed_price_hint: "This price applies to all SKUs",
        section_option_groups: "Product Options",
        add_option_group: "+ Add Option Group",
        option_group_name: "Option Group Name",
        option_group_values: "Option Values",
        generate_sku_matrix: "Generate SKU Matrix",
        matrix_regenerate_confirm: "Existing SKUs found. Regenerate? (SKUs that don't match new options will be removed.)",
        option_group_placeholder: "e.g. Color, Size",
        option_value_placeholder: "e.g. Red, Black",
        section_bundle_images: "Bundle Images",
        wms_product_title: "WMS Products",
        wms_product_sku: "SKU",
        wms_product_barcode: "SKU Code",
        wms_product_stock: "Storefront stock",
        wms_product_stock_saved: "Stock saved",
        wms_product_import_btn: "Import from Backoffice",
        wms_product_import_title: "Import from Backoffice",
        wms_product_import_confirm: "Import",
        wms_product_import_success: "Products imported successfully",
        wms_product_search_placeholder: "Search name / barcode",
        wms_product_search_btn: "Search",
        wms_product_refresh: "Refresh",
        wms_product_sync_btn: "Sync",
        wms_product_sync_success: "Sync completed successfully",
        // 2026-10-03 — the "Import from Backoffice" dialog lists the whole
        // warehouse, paged.
        wms_product_price: "Price",
        wms_product_imported: "Imported",
        wms_product_total: "{count} items in total",
        section_giveaways: "Giveaways",
        add_giveaway: "Add giveaway",
        giveaway_qty: "Qty",
        flash_badge: "Flash",
        flash_only_filter: "Flash only",
        // mdf-bo-api#583 — a SKU saved with only HALF its wms_map: the SKU code is
        // a combo (A+B) but not every warehouse code resolved, so the product
        // badges as mapped while the packing room under-picks it.
        wms_unmatched_badge: "WMS incomplete",
        wms_unmatched_column: "WMS",
        wms_unmatched_filter: "Only WMS incomplete",
        wms_unmatched_filter_hint: "filters this page only",
        // Owner rule 2026-10-15: a SKU with no option name is incomplete and may not be sold
        incomplete_sku_badge: "Incomplete (no option name)",
        incomplete_sku_tooltip: "{n} SKU(s) have no option name — the storefront hides them and the product cannot be put on sale until they are named",
        incomplete_sku_filter: "Only incomplete (no option name)",
        sku_name_required: "Please name the option before putting it on sale",
        wms_unmatched_tooltip_sku: "{code}: {missing} of {expected} warehouse codes missing",
        wms_unmatched_tooltip_parts: "not in WMS: {parts}",
        wms_unmatched_tooltip_unknown: "which code is unknown — open the editor for this SKU",
        wms_unmatched_tooltip_more: "and {count} more",
        // ---- #301 shared stock (spec 2026-10-01 §8/§11) ----
        // A fully mapped SKU's quantity is recomputed from WMS every 20 s, so it
        // cannot be edited here (anything typed is overwritten within the minute);
        // a partially mapped SKU keeps its hand-set number exactly as before.
        sku_quantity_from_wms: "from WMS",
        sku_quantity_from_wms_hint: "This quantity comes from the warehouse (WMS) automatically — change it in WMS.",
        sku_quantity_from_wms_hint_detail: "Computed from WMS (on hand {available} − reserved {pending}) — change it in WMS",
        sku_quantity_manual_hint: "This SKU is not mapped to a warehouse item; the quantity is set by hand.",
        sku_quantity_ignored: "The quantity was ignored for {n} WMS-sourced SKU(s) ({codes}) — that number comes from the warehouse.",
        stock_unmatched_title: "Unmapped SKUs (WMS)",
        stock_unmatched_count: "{n} SKU(s) still use a hand-set quantity",
        stock_unmatched_hint: "These SKUs do not take their stock from the warehouse (WMS); their quantity stays at the hand-set value until the mapping is complete.",
        stock_unmatched_empty: "No SKU with an incomplete WMS mapping",
        stock_unmatched_load_failed: "Could not load the list — check that the /catalog/stock/unmatched API is deployed.",
        stock_unmatched_col_product: "Product",
        stock_unmatched_col_reason: "Reason",
        stock_unmatched_col_missing: "Missing warehouse codes",
        stock_unmatched_col_message: "Detail",
        stock_unmatched_missing_count: "{n} missing",
        stock_unmatched_code_unmapped: "Not mapped to WMS",
        stock_unmatched_code_unmatched: "Mapped, but the warehouse item is missing",
        stock_unmatched_code_unknown: "Reason unknown",
        stock_unmatched_banner: "{n} missing warehouse code(s) on this page",
        stock_unmatched_banner_link: "See the full list",
        stock_unmatched_truncated: "The scan stopped at its row cap, so the count below is a lower bound — map the SKUs listed here and reload.",
        sync_to_bo_btn: "Sync to Backoffice",
        sync_to_bo_success: "Storefront products pushed to Backoffice",
        sync_to_bo_in_progress: "A sync is already in progress, please wait",
        sync_to_bo_log_title: "Sync history",
        sync_to_bo_log_hint: "Click to view the sync log",
        // ---- seller UI revamp 2026-10-03 (design §5 i18n table) ----
        // docs/specs/2026-10-03-seller-ui-revamp-design.md §5. Appended as one block
        // so the two FE halves of this change cannot collide in this file.
        // This block must hold exactly the same keys as the th.js one.
        col_sale_status: "Sale status",
        sale_status_ready: "Ready to sell",
        sale_status_not_ready: "Not ready",
        sale_status_hint_disabled: "Selling is turned off",
        sale_status_hint_no_stock: "No sellable stock",
        col_toggle: "On / Off",
        sale_on: "Selling on",
        sale_off: "Selling off",
        // under the sale-status switch on the product edit page (ProductEdit.vue)
        sale_enable_hint: "When off, the product is hidden in the app and web and cannot be bought",
        toggle_on_success: "Selling turned on",
        toggle_off_success: "Selling turned off",
        toggle_failed: "Could not change the sale status",
        flash_active_tooltip: "Flash sale running",
        action_preview: "Open storefront",
        expand_skus_empty: "No SKUs yet",
        expand_load_failed: "Could not load the details",
        bundle_options_empty: "No options yet",
        col_available_qty: "Available",
        // ---- inline price / quantity edit (pencil) 2026-10-03 ----
        // docs/specs/2026-10-03-seller-inline-price-qty-edit-design.md §4.
        // Appended as one block; must hold exactly the same keys as th.js.
        col_sellable_qty: "Sellable qty",
        // product-list column header, explicit line break (2026-10-15)
        col_sellable_qty_header: "Sellable qty",
        inline_edit_price: "Edit price",
        inline_edit_qty: "Edit quantity",
        inline_save: "Save",
        inline_cancel: "Cancel",
        inline_saved: "Saved",
        inline_save_failed: "Could not save",
        inline_price_invalid: "Price must be greater than 0",
        inline_qty_invalid: "Quantity must be 0 or more",
        inline_qty_wms_refused: "This SKU's quantity comes from WMS and cannot be edited here",
        inline_price_fixed_hint: "This product uses one price for every SKU — edit it on the product page",
        inline_price_flash_hint: "A Shopee flash sale is running — the base price applies after it ends",
        inline_hint_edit_in_rows: "Use the pencil, then edit each SKU below",
        // owner bo-stg 2026-10-03: the qty pencil opened an editor with no editable cell
        inline_qty_all_wms: "Every quantity comes from WMS — change it in the warehouse system, or unmap the SKUs on the product page",
        inline_qty_from_wms_hint: "This quantity comes from WMS — change it in the warehouse system, or unmap WMS on the product page to set it by hand",
    },
    shipping_tier: {
        title: "Shipping Fee Ladder",
        btn_add: "Add Tier",
        edit_title: "Edit Tier",
        col_range: "Subtotal Range",
        col_min: "Min Subtotal",
        col_fee: "Fee (฿)",
        col_active: "Active",
        label_min: "Min Subtotal (฿)",
        label_fee: "Fee (฿)",
        label_active: "Active",
        save_success: "Saved successfully",
        delete_title: "Confirm delete?",
        delete_msg: "This action cannot be undone.",
        delete_success: "Deleted successfully",
        no_data: "No data",
        field_required: "This field is required",
        err_min_negative: "Min subtotal must be 0 or more",
        err_fee_negative: "Fee must be 0 or more",
        err_dup_min: "A tier with this min subtotal already exists",
        err_floor_protected: "The ฿0 floor tier cannot be deleted",
        ge_prefix: "≥ ",
        range_to: " – ",
        arrow: " → "
    },
    auth: {
        unverify: "User not verfy",
        block: "User has been blocked",
        signin: "Signin",
        signout: "Signout",
        username: "Username",
        email: "E-Mail",
        password: "Password",
        forgetpassword: "Forgot Password",
        resetpassword: "Reset Password",
        confirm_reset_password: "Confirm reset password ",
        forgot_password_success: "Forgot password successfully",
        reset_password_success: "Reset password successfully",
        // "Login with LINE" button on /login
        // (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §5)
        or: "or",
        line_signin: "Sign in with LINE",
        line_connecting: "Connecting to LINE…"
    },

    name: "Name",
    description: "Description",
    location_x: "Location (X)",
    location_y: "Location (Y)",
    group_name: "Group name",
    email: "E-Mail",
    email_optional: "E-Mail (Optional)",
    created: "Create Date",
    payment_at: "Payment Date",
    search: "Search",
    save: "Save",
    back: "Back",
    new: "New",
    status: "Status",
    download: "Download",
    downloadall: "Download All",
    product_search: "Product Search",
    welcome: "Welcome",
    myprofile: "Profile",
    changepassword: "Change Password",
    // สวิตช์ภาษาในเมนูผู้ใช้ (spec 2026-10-06 bo-language-toggle-user-menu L4) — คู่กับอีกไฟล์
    // Data-entry forms — spec 2026-10-07-bo-form-draft-clear-design.md §3 F3
    form_draft: {
        clear: "Clear form",
        clear_confirm_title: "Clear the form?",
        clear_confirm_text: "Everything entered on this page will be removed",
        cleared: "Form cleared",
    },
    // Shopee cancel reconcile §11 F2/F3 (BO orders page, admin)
    shopee_census: {
        btn_check: "Check with Shopee",
        hint: "Asks Shopee about orders BO has cancelled or with a cancel request, by created date in the range above",
        checking: "Asking Shopee … (7 days ≈ 15 seconds)",
        range_missing: "Pick a date range before checking with Shopee",
        range_too_long_title: "Date range too long",
        range_too_long_text: "Check with Shopee covers at most {max} days at a time (now {days} days)",
        load_error: "Could not check with Shopee",
        title: "Shopee check {from} – {to}",
        total: "{n} orders checked",
        reopen: "Last Shopee check",
        show_all: "Show all",
        empty: "Nothing to review",
        empty_all: "No orders in this range",
        not_on_page: "Order #{id} is not on the current page",
        col_order: "Order",
        col_bo_status: "BO status",
        col_platform_status_bo: "Shopee in BO",
        col_platform_status_now: "Shopee now",
        col_packing: "Packing",
        col_cancel_by: "Cancelled by",
        col_class: "Result",
        cancel_by_staff: "BO staff #{id}",
        download_csv: "Download CSV",
        csv_failed: "Could not download the CSV",
        selected_n: "{n} selected",
        repair_dry: "Repair selected (check first)",
        repair_too_many: "At most {max} orders per repair",
        dry_title: "Check before repair (nothing changed yet)",
        done_title: "Repair result",
        will_apply: "Will repair {n}",
        applied_n: "Repaired {n}",
        skipped_n: "Skipped {n}",
        nothing_to_apply: "Nothing can be repaired",
        repair_confirm_btn: "Confirm repair of {n}",
        repair_confirm_title: "Repair {n} orders?",
        repair_confirm_text: "BO statuses will follow Shopee's current status. There is no undo button",
        apply_error: "Repair failed",
        back: "Back to the check",
        close: "Close",
        action_uncancel: "Un-cancel",
        action_cancel: "Cancel as on Shopee",
        action_platform_status_only: "Update Shopee status",
        action_other: "Other",
        class_ok_cancelled: "Matches (cancelled)",
        class_ok_live: "Matches",
        class_stale_cancel_live: "BO cancelled, Shopee moved on",
        class_stale_cancel_live_staff: "Cancelled by BO staff, Shopee moved on",
        class_pending_request: "Cancel request pending",
        class_pending_request_bo_cancelled: "Cancel request pending (BO cancelled)",
        class_missing_cancel: "Shopee cancelled, BO does not know",
        class_unpaid_or_gone: "Not found / unpaid",
        class_other: "Other",
        class_fetch_error: "Could not fetch",
        skip_skipped_packing: "Already in a packing round — check by hand",
        skip_skipped_return_episode: "Has a return history",
        skip_skipped_shopee_cancelled_before: "Shopee cancelled this order before",
        skip_skipped_row_changed: "Order changed during repair — check again",
        skip_skipped_cancel_not_by_platform: "Cancelled by staff or another source — not repaired automatically",
        skip_skipped_platform_cancel_already_recorded: "Shopee cancellation already recorded",
        skip_not_found: "Order not found",
        skip_fetch_error: "Could not ask Shopee",
        skip_internal_error: "Internal error",
        skip_now_class: "Now: {cls}",
        skip_unknown: "Skipped ({reason})",
    },
    // /wms/product enable/disable a WMS product — spec 2026-10-07-wms-product-active-design.md §3 F4 · bo-fn #416 — pairs with th.js
    wms_product_active: {
        active_filter: "Status",
        active: "Active",
        inactive: "Disabled",
        active_all: "All",
        col_active: "Active",
        inactive_badge: "Disabled",
        menu: "Menu",
        confirm_disable: "Disable {name}?",
        confirm_disable_text: "The product disappears from every stock / packing page (history is kept)",
        confirm_enable: "Enable {name}?",
        confirm_enable_text: "The product shows again on every stock / packing page",
        stock_left: "{n} pcs still in stock",
        toggled_on: "Product enabled",
        toggled_off: "Product disabled",
        toggle_failed: "Could not change the product status",
        scan_inactive: "This product is disabled",
        column_missing: "Disabling products is not available yet (the is_active column SQL has not been run). Please contact an administrator.",
        // #424 §8 F8: suffix on an order-entry SKU mapped to a disabled WMS product
        order_option_disabled: "Disabled",
    },
    // API Msg codes (bo-api #834) that older pages translate with $t(err.response.data.Msg)
    WMS_PRODUCT_INACTIVE: "@:wms_product_active.scan_inactive",
    WMS_PRODUCT_ACTIVE_COLUMN_MISSING: "@:wms_product_active.column_missing",
    // API Msg: DELETE /wms/inventory/:id refuses a row whose balance <> 0 (spec 2026-10-07-wms-inventory-delete-guard)
    WMS_INVENTORY_BALANCE_NOT_ZERO: "Cannot delete: this row still has stock. Move or withdraw it first",
    language: {
        toggle_label: "Switch language",
    },
    menu_pref: {
        title: "Menu Settings",
        list_title: "Sidebar Menus",
        description: "Choose which menus appear in the sidebar. Pinned menus are always shown.",
        col_menu: "Menu",
        col_show: "Show",
        col_pin: "Pin",
        note_root_only: "Show/Pin can only be set for top-level menus — sub-menus follow their parent menu.",
        empty: "No menus available.",
        saved: "Menu settings saved",
        save_failed: "Failed to save menu settings",
        product_wait_ship: "Products Awaiting Shipment",
        express: "Express",
        express_list: "Express List",
        express_form: "Express Form"
    },
	page_notfound: "Sorry Page not found.",
	page_notfound_desc: "Plase check URL again.",
	actions: "Action",
    data: "Data",
    to: "To",
    of: "From",
    row_select: "Selected",
    yes: "Yes",
    no: "No",
    ok: "Ok",
    cancel: "Cancel",
    confirm_cancel: "Confrim Cancel",
    upload_file: "Upload file",
    add: "Add",
    action: "Action",
    amount: "Amount",
    note: "Note",
    select: "Select",
    date: "Date",
    date_type: "Date Type",
    created_date: "Created Date",
    created_at: "Created",
    created_by: "Created By",
    total: "Total",
    close: "Close",
    edit: "Edit",
    delete: "Delete",
    birthday: "Birthday",
    birthday_set: "Set birthday",
    birthday_clear: "Clear birthday",
    birthday_modal_title: "Select birthday (Buddhist year)",
    birthday_modal_hint: "Day / Month / Year (BE) — saved internally as Gregorian year.",
    birthday_invalid: "Invalid birthday",
    day: "Day",
    month: "Month",
    year_be: "Year (BE)",
    please_select: "Please select",
    please_select_payment_method_type: "Please select payment method",
    please_select_sale_channel_type: "Please select sale channel",
    please_select_shipping_provider_type: "Please select shipping provider",
	create: "Create",
	confirm: "Confirm",
	packing_regen_tracking: "Re-generate tracking",
	packing_regen_tracking_confirm: "Generate tracking numbers for orders without one in packing round",
	packing_regen_tracking_success: "Tracking generated",
	packing_regen_tracking_result: "Generated tracking for {count} order(s) without a number",
	create_success: "Create success",
	delete_confirm: "Confirm delete",
	delete_confirm_text: "Please confirm delete ",
	delete_confirm_question: "Do you want to delete this information ? ",
	delete_success: "Delete successed",
	delete_fail: "Delete Failed",
	edit_success: "Editing successed",
	edit_fail: "Editing failed",
    update_success: "Updating successed",
    update_failed: "Update failed",
    phone_invalid: "Invalid phone number (10 digits starting with 0)",
    update_fail: "Updating failed",
    enabled: "Enabled",
    disabled: "Disabled",
    refresh: "Refresh",

    // Inventory
    inventory_transfer: "Pickup from Main",
    inventory_transfer_to_line: "Pickup to Line",
    inventory_out: "Out",
    inventory_in: "In",
    phone: "Phone",

    // =================================================================
    // WMS Module
    // =================================================================
    wms: {
        name: "Inventory System",
        menu: {
            inventory_dashboard: "Dashboard",
            inventory: "Inventory",
            inventory_list: "Inventory List",
            inventory_list_detail: "Inventory List By Stock",
            inventory_history: "Inventory History",
			inventory_history_product_list: "Product History",
			inventory_history_storage_list: "Storage History",
            inventory_summary_packing: "Packing Summary",
            partner: "Manufacturer",
            product: "Product",
            product_v2: "Product V2 (Stock Sync)",
            available_product: "Available Product",
            storage: "Storage",
            promotion: "Promotion",
            return_warehouse: "Return Warehouse",
            // Pair of wms.menu.inventory_to_line in th.js — see the note there.
            inventory_to_line: "Pickup to Line",
            // #437 รายงานสินค้าที่ส่งแล้วแต่ยังไม่ตัดสต็อก
            shipped_no_deduct: "Shipped without stock deduction",
        },

        return_move_title: "Move to Retail Pack Room",
        return_move_qty: "Quantity to move",
        return_available: "Available in return warehouse",
        return_move_success: "Moved to retail pack room",
        return_move_exceed: "Quantity exceeds available balance",
        return_move_main_button: "Move good items to destination warehouse",
        return_move_main_title: "Move good items to destination warehouse",
        return_move_main_src: "Source warehouse",
        return_move_main_dest: "Destination warehouse",
        return_move_main_notice: "These figures are the current balance of the whole {storage}. They are not limited by the report date filter, so they will usually differ from the table behind this dialog.",
        return_move_main_total: "Total",
        return_move_main_selected: "Selected",
        return_move_main_empty: "Nothing left in the return warehouse",
        return_move_main_confirm: "Confirm move to destination warehouse",
        return_move_main_success: "Moved into the destination warehouse",
        return_move_main_none: "Nothing was moved - the balance of every selected item had already gone",
        return_move_main_result_title: "Move result",
        return_move_main_result_note: "The quantities below are what was actually moved. They may differ from what you selected if the balance changed in the meantime.",
        return_move_main_moved: "Quantity moved",
        return_move_main_moved_ok: "Moved",
        return_move_main_skipped: "Skipped — balance already 0",
        return_move_main_select_all: "Select all",
        return_move_main_clear_all: "Clear selection",
        return_move_main_all_selected_hint: "Every item is selected, so per-item ticking is hidden. Use \"Clear selection\" to pick items one by one again.",

        created_at: "Date",
        staff: "Staff",
        bill_number: "Bill Number",
        bill_image: "Bill Image",

        inventory_main: "Main Inventory",
        inventory_src: "Source",
        inventory_dst: "Destination",
        inventoryin_list: "In",
        inventoryout_list: "Out",
        inventorytransfer_list: "Transfer",
        // Prodcut
        product_name: "Product Name",
        partner: "Manufacturer",
        package_name: "Unit name",
        barcode: "Barcode",
        product_width: "Width",
        product_height: "Height",
        product_depth: "Depth",
        product_weight: "Weight",
        product_pn: "SKU",

        // Partner
        company_name: "Company Name",
        address: "Address",
        contact_name: "Contact",
        contact_tel: "Telephone",

        // Inventory
        inventory_in: "In",
        inventory_out: "Out",

        amount: "Amount",
        cost: "Cost",
        // the /admin/product_platform button that recomputes every SKU's cost
        recompute_cost: "Recompute SKU cost",
        recompute_cost_done: "Scanned {scanned} SKUs · updated {updated} · missing {missing}",
        // skipped: true = the API has no cost column to write to, so nothing was
        // computed. Showing "scanned 0 SKUs" instead reads as an empty catalogue.
        recompute_cost_skipped: "The SKU cost migration has not been run yet (the columns do not exist)",
        note: "Note",
        product: "Product",
        corporate: "Corporate",
        storage: "Storage",
        balance: "Balance",
        overall_amount: "Overall Amount",
        overall_cost: "Overall Cost",
        taxid: "TAX ID",
        tel: "Phone",
        email: "E-Mail",
        storage_name: "Storage Name",
        storage_desc: "Storage Description",
        x: "X",
        y: "Y",

        width: "Width (cm)",
        height: "Height (cm)",
        depth: "Depth (cm)",
        weight: "Weight (g)",

        // Available Product
        product_id: "Product ID",
        stock: "Stock",
        packing: "Packing",
        packing_detail: "Packing Detail",
        packing_total_orders: "Total Orders",
        packing_total_quantity: "Total Quantity",
        packing_by_platform: "By Platform",
        packing_by_sale_channel: "By Sale Channel",
        packing_order_count: "Orders",
        packing_quantity: "Quantity",
        platform: "Platform",
        sale_channel: "Sale Channel",
        stock_sync_status: "Stock Sync",
        stock_alarm_status: "Stock Alarm",
        stock_sync_threshold: "Sync Threshold",
        stock_sync_percentage: "Sync %",
        stock_alarm_threshold: "Alarm Threshold",
        stock_settings: "Stock Settings",

        // Packing Order Drill-down
        packing_orders_title: "Packing Orders",
        packing_orders_subtitle: "Order List",
        packing_orders_empty: "No orders found",
        packing_orders_order_number: "Order Number",
        packing_orders_order_id: "Order ID",
        packing_orders_platform_order_id: "Platform Order ID",
        packing_orders_created_at: "Order Date",
        packing_orders_recipient: "Recipient",
        packing_orders_status: "Status",
        packing_orders_tracking: "Tracking Number",
        packing_orders_product_qty: "This Product Qty",
        packing_orders_view_order: "View Order",
    },

    // =================================================================
    // Backoffice Module
    // =================================================================

    backoffice: "Backoffice",
    orders: "Orders",
    products: "Product",
    packings: "Packing",
    order_return: "Return",
    payments: "Payment",
    reports: "Report",
    customer_information: "Customer Information",
    customer: "Customer",
    platform_connect: "Platform Connect",
    product_information: "Product Information",
    seller_note: "Seller Note",
    order_form: "New Order",
    order_status: "Status",
    order_number: "Order Number",
    order_user: "Staff",
    order_detail: "Order Detail",
    order_form: "New Order",
    order_count: "Order Count",


    order_status_unpaid: "Unpaid",
    order_status_awaiting_shipment: "Awaiting Shipment",
    order_status_awaitingcollection: "Awaiting Collection",
    order_status_partiallyshipping: "Partially Shipping:",
    order_status_awaiting_transit: "Awaiting Transit",
    order_status_intransit: "Intransit",
    order_status_delivered: "Delivered",
    order_status_completed: "Completed",
    order_status_cancelled: "Cancelled",
    order_status_returned: "Returned",
    order_status_claimed: "Claimed",
    order_status_returning : "Returning",
    order_status_intransit_completed : "Intransit, Completed",

    return_in_transit_tab: "Return in transit",
    return_started_at: "Return started",
    return_source: "Source",
    return_source_spx: "SPX",
    return_source_thaipost: "Thai Post",
    return_source_lazada: "Lazada",
    return_source_manual: "Manual",
    return_source_unknown: "Unknown",
    return_age_days: "{n} days",

    // #189 simulate fulfillment (staging, MDFStore orders)
    sim_delivered: "Simulate: Delivered",
    sim_failed: "Simulate: Delivery failed",
    sim_returned: "Simulate: Returned",
    sim_confirm_title: "Confirm status simulation (staging)?",
    sim_success: "Simulation applied",
    platform_mdfstore: "MDFStore",

    payment_slip: "Payment SLIP",
    payment_channel: "Payment Channel",
    payment_method: "Payment Channel",
    payment_check: "Payment Check",

    platform: "Platform",
    sale_channel: "Sale Channel",
    sale_channel_type: "Sale channel type",
    recipient_name: "Name",
    recipent_address: "Address",
    recipent_district: "District",
    recipent_city: "City",
    recipent_province: "Province",
    recipent_zipcode: "Zipcode",
    recipient_phone: "Phone",

    report_by_team: "Report By Team",
    report_by_sale_channel: "Report By Sale Channel",
    report_by_user: "Report By Staff",
    report_by_product: "Report By Product",
    report_by_user_product: "Report By Staff And Product",
    report_by_sale_channel_and_product: "Report Cost/Profit By Product",
    report_wms_summary: "WMS Summary Report",
    report_wms_product_summary: "WMS Product Summary Report",
    report_wms_field_summary: "WMS Field Summary Report",
    report_commission: "Agent Commission Report",
    report_order_return: "Order Return Report",

    // Cost report (#265 · bo-api #594 §7.4)
    report_product_cost: "Cost report",
    cost_report: {
        view_platform: "By platform",
        view_channel: "By sale channel",
        unknown_channel: "Unspecified",
        unknown_product: "Unknown product",
        unknown_sku: "Unknown SKU",
        orders: "Orders",
        qty: "Quantity",
        sales: "Sales",
        cost: "Cost",
        margin: "Margin",
        margin_pct: "Margin %",
        expense: "Expense",
        net_profit: "Net profit",
        expense_note: "Expenses from the account book bound to the platform (unbound expenses are not included)",
        missing_cost_sku: "SKUs without cost",
        cost_missing: "Cost incomplete",
        unit_price: "Unit price",
        unit_cost: "Unit cost",
        export: "Export Excel",
        too_many_lines: "More than 50,000 lines — narrow the date range",
        all: "All",
        // keys beyond §7.4 — column headers and the two disclaimers §11.5 /
        // §11.8 tell us to print on the screen itself
        name: "Name",
        sku_code: "SKU code",
        seller_sku: "Seller SKU",
        platform_product_id: "Platform product id",
        search: "Search",
        // the blocking modal shown while a report / export request is in flight
        loading: "Loading data…",
        // §13.7 — round 2 reverses this sentence: cost is a snapshot now
        cost_note: "Cost is the value snapshotted when the order was created. To apply a corrected cost to past orders, press \"Recompute order cost\"",
        sales_note: "Sales = unit price × quantity of the order lines (order-level discounts and shipping are not included)",
        cost_columns_missing: "The order cost columns are not installed (sql/2026-09-23-order-item-cost-snapshot.sql) — every cost shows 0",
        // §13.7 — the recompute-order-cost button and the dynamic-SKU tag
        backfill: "Recompute order cost (selected range)",
        backfill_confirm: "Recompute order cost from {from} to {to} using current costs? Past reports in this range will change",
        backfill_done: "Scanned {scanned} lines · updated {updated} · incomplete {missing} · unresolved {unresolved}",
        dynamic_sku_note: "Lines without a SKU (manual / MT orders) are grouped into one row — see the orders sheet for detail",
        sku_from_order: "SKU from the order",
        yes: "Yes",
        // errors — the key IS the code the API sends in Msg (bo-api #594 §6.1);
        // the operator must never be shown the raw code.
        errors: {
            cost_report_bad_view: "Invalid view — choose platform or sale channel",
            // the BE's 400 for a missing / unparsable time_from or time_to; the
            // FE's own rangeErrorCode reaches for this same key.
            cost_report_bad_range: "Invalid date range",
            // 7, not the API's 92: this screen caps the range at a week
            // (COST_REPORT_MAX_DAYS) and refuses anything wider before it is sent.
            cost_report_range_too_wide: "Date range exceeds 7 days",
            cost_report_too_many_lines: "More than 50,000 lines — narrow the date range",
            product_cost_forbidden: "You are not allowed to see cost data",
            unknown: "Could not load the cost report"
        }
    },

    time_from: "Start",
    time_to: "End",
    all: "All",
    type: "Type",
    bank: "Bank",
    bank_account: "Account Number",
    bank_branch: "Branch",
    detail: "Detail",
    product: "Product",
    price: "Procie",
    image: "Image",
    tag: "Tags",
    quantity: "Quantity",
    product_form: "Product Manage",
    product_code: "Product Code",
    product_category: "Product Category",
    is_comboset: "Is Comboset",
    visibility: "Visibility",
    visibility_all: "All",
    visibility_company_only: "Company only",
    visibility_agent_only: "Agent only",
    price_tiers: "Price Tiers",
    price_tiers_hint: "Bulk pricing — not applied to agent users",
    tier_min_qty: "Min Qty",
    tier_price: "Price / unit",
    add_tier: "Add Tier",
    bulk_discount: "Bulk discount",
    status_required: "Please select a status",
    variable_duplicate: "Duplicate Variable name",
    option_duplicate: "Duplicate Option name",
    tier_min_qty_invalid: "Min Qty must be a positive integer",
    tier_price_invalid: "Price must be greater than 0",
    tier_min_qty_duplicate: "Min Qty duplicated with another tier",
    app_section: "App (Shopping Page)",
    app_enable: "Show in App",
    app_tag: "App Tag",
    app_discount: "App Discount (THB)",
    app_discount_start: "Discount Start",
    app_discount_end: "Discount End",
    // #17 filter/status labels on Admin/ProductTables.vue
    product_status_active: "Active",
    product_status_inactive: "Inactive",
    app_filter_on: "Sold in app",
    app_filter_off: "Not sold in app",
    team: "Team",
    department: "Department",
    fname: "Name",
    lname: "Lastname",
    nick_name: "Nickname",
    password_old: "Old password",
    password: "Password",
    password_confirm: "Confirm Password",
    password_not_match: "Password not match",
    // Top-level running_from / running_to. th.js has had these since the coupon
    // list was written; en.js never did, so CouponTables.vue's $t('running_from')
    // rendered the literal string "running_from" as a column header for anyone
    // using English — vue-i18n falls back to the key, not to the other language.
    // (The coupon_event block further down has its OWN running_from; that one is
    // the create form's field label and is a different string.)
    running_from: "Running from",
    running_to: "Running to",
    packing_number: "Packing Number",
    packing_user: "Packing Staff",
    packing_date: "Packing Date",
    line_packing: "Line Packing",
    please_select_sale_channel: "Please select sale channel",
    please_select_payment_method: "Please select payment channel",
    payment_success: "Payment success",
    payment_fail: "Payment fail",
    shipping: "Shipping",
    shipping_provider: "Shipping Provider",
    shipping_provider_special: "Special delivery (company truck)",
    shipping_provider_special_hint: "Parcel ships on the company truck; no external carrier tracking",
    barcode: "Barcode",
    scanbarcode: "Click to scan Barcode",
    packing_all_scanned: "All items scanned",
    barcode_type: "Barcode type",
    barcode_type_tracking: "Tracking Number",
    barcode_type_platform_order_id: "Platform Order ID",
    product_pn: "Product Code",
    tracking_number: "Tracking Number",
    order_information: "Order Information",
    product_image: "Product Image",
    product_name: "Product Name",
    product_pickup: "Quantity",
    cancel_confirm: "Confirm cancel",
    cancel_confirm_question: "Cancel order ",
    cancel_order_success: "Cancel order success",
    please_select_cancel_reason: "Please select cancel reason",
    please_input_cancel_reason: "Plase input cancel reason",

    shipping_return: "Shipping Return",

    user_group: "User Group",

    // Report
    order_amount: "Order Amount",
    payment_amount: "Payment Amount",
    payment_amount_net: "Summary",
    product_amount: "Product Amount",
    discount: "Discount",
    payment_method_type: "Payment method type",
    sort_type: "Sort type",
    change_tracking_success: "Change tracking success",
    change_shipping_success: "Change shipping success",
	price_per_unit:"Price per unit",
    member: {
        line_user_id: "LINE User ID",
        birthday: "Birthday",
        sex: "Gender",
        total_spending: "Total Spending",
        address: "Address",
        province: "Province",
        district: "District",
        subdistrict: "Subdistrict",
        postcode: "Postcode",
        coupons: "Coupons",
        coupon_code: "Coupon Code",
        coupon_status: "Status",
        used: "Used",
        unused: "Unused",
        created_at: "Created",
        used_at: "Used At",
        no_coupons: "No coupons found",
        error_loading_coupons: "Error loading coupons"
    },
    webcam_recording: "Webcam Recording",
    waiting_for_packaging: "Waiting for Packaging",
    camera_settings: "Camera Settings",
    select_camera: "Select Camera",
    connect_camera: "Connect Camera",
    camera_connected: "Camera Connected",
    camera_disconnected: "Camera Disconnected",
    preview_webcam: "Preview Webcam",
    hide_preview: "Hide Preview",
    no_camera_found: "No camera found",
    unable_to_access_camera: "Unable to access camera",
    scanning_barcode: "Scanning Barcode...",
    barcode_scanned: "Barcode Scanned",
    add_product_success: "Product added successfully",
    product_not_found: "Product not found in order",
    all_items_packed: "All items packed. You can complete the order.",
    packing_complete: "Packing Complete",
    complete_order: "Complete Order",
    confirm_complete_order: "Are you sure you want to complete this order?",
    order_completed_success: "Order marked as completed successfully",
    order_completed_fail: "Failed to mark order as completed",
    return_to_packaging: "Return to Packaging",
    camera_device: "Camera Device",
    video_quality: "Video Quality",

    // =================================================================
    // Platform Statement Module
    // =================================================================
    platform_statement: {
        export_fail: "Export failed",
        name: "Platform Statement",
        menu: "Platform Statement",
        list: "Statement List",
        upload: "Upload Statement",
        detail: "Statement Detail",
        summary: "Summary Report",

        statement_number: "Statement Number",
        statement_date: "Statement Date",
        settlement_date: "Settlement Date",
        platform: "Platform",
        platform_shop_id: "Shop ID",

        total_orders: "Total Orders",
        total_sales_amount: "Total Sales",
        total_platform_fee: "Platform Fee",
        total_commission: "Commission",
        total_shipping_fee: "Shipping Fee",
        total_other_fee: "Other Fees",
        net_amount: "Net Amount",

        platform_order_id: "Platform Order ID",
        related_order_id: "Related Order ID",
        order_date: "Order Date",
        order_created_time: "Order Created Time",
        order_settled_time: "Order Settled Time",
        transaction_type: "Transaction Type",
        currency: "Currency",
        order_amount: "Order Amount",
        total_revenue: "Total Revenue",

        // Seller Discounts
        subtotal_after_seller_discounts: "Subtotal After Seller Discounts",
        subtotal_before_discounts: "Subtotal Before Discounts",
        seller_discounts: "Seller Discounts",

        // Refunds
        refund_subtotal_after_seller_discounts: "Refund Subtotal After Seller Discounts",
        refund_subtotal_before_seller_discounts: "Refund Subtotal Before Seller Discounts",
        refund_of_seller_discounts: "Refund of Seller Discounts",

        // Fees
        platform_fee: "Platform Fee",
        commission: "Commission",
        transaction_fee: "Transaction Fee",
        credit_card_installment_fee: "Credit Card Installment Fee",
        payment_fee: "Payment Fee",

        // Shipping
        shipping_fee: "Shipping Fee",
        seller_shipping_fee: "Seller Shipping Fee",
        actual_shipping_fee: "Actual Shipping Fee",
        platform_shipping_fee_discount: "Platform Shipping Fee Discount",
        customer_shipping_fee: "Customer Shipping Fee",
        refund_customer_shipping_fee: "Refund Customer Shipping Fee",
        actual_return_shipping_fee: "Actual Return Shipping Fee",
        shipping_fee_subsidy: "Shipping Fee Subsidy",
        seller_shipping_fee_discount: "Seller Shipping Fee Discount",

        // Affiliate
        affiliate_commission: "Affiliate Commission",
        affiliate_commission_before_pit: "Affiliate Commission Before PIT",
        personal_income_tax_withheld: "Personal Income Tax Withheld",
        affiliate_partner_commission: "Affiliate Partner Commission",
        affiliate_shop_ads_commission: "Affiliate Shop Ads Commission",
        affiliate_commission_deposit: "Affiliate Commission Deposit",
        affiliate_commission_refund: "Affiliate Commission Refund",

        // Service Fees
        sfp_service_fee: "SFP Service Fee",
        live_specials_service_fee: "Live Specials Service Fee",
        voucher_xtra_service_fee: "Voucher Xtra Service Fee",
        eams_program_service_fee: "EAMS Program Service Fee",
        brand_crazy_deals_flash_sale_fee: "Brand Crazy Deals Flash Sale Fee",
        bonus_cashback_service_fee: "Bonus Cashback Service Fee",
        tiktok_paylater_program_fee: "TikTok PayLater Program Fee",
        commerce_growth_fee: "Commerce Growth Fee",
        infrastructure_fee: "Infrastructure Fee",
        campaign_resource_fee: "Campaign Resource Fee",
        other_fee: "Other Fees",

        // Adjustment
        adjustment: "Adjustment",
        adjustment_amount: "Adjustment Amount",

        // Customer Payment
        customer_payment: "Customer Payment",
        customer_refund: "Customer Refund",

        // Vouchers
        seller_co_funded_voucher_discount: "Seller Co-Funded Voucher Discount",
        refund_of_seller_co_funded_voucher: "Refund of Seller Co-Funded Voucher",
        platform_discounts: "Platform Discounts",
        refund_of_platform_discounts: "Refund of Platform Discounts",
        platform_co_funded_voucher_discounts: "Platform Co-Funded Voucher Discounts",
        refund_of_platform_co_funded_voucher: "Refund of Platform Co-Funded Voucher",

        // Additional Info
        estimated_package_weight: "Estimated Package Weight",
        actual_package_weight: "Actual Package Weight",
        shopping_center_items: "Shopping Center Items",
        customer_bank_for_payment: "Customer Bank for Payment",
        product_name: "Product Name",
        quantity: "Quantity",
        sku: "SKU",

        upload_file: "Upload Excel File",
        select_platform: "Select Platform",
        drag_drop_file: "Drag & drop file here or click to browse",
        supported_formats: "Supported formats: .xlsx, .xls",
        max_file_size: "Maximum file size: 50MB",

        upload_success: "Statement uploaded successfully",
        upload_fail: "Failed to upload statement",
        delete_success: "Statement deleted successfully",
        delete_fail: "Failed to delete statement",
        delete_confirm: "Delete Statement",
        delete_confirm_text: "Are you sure you want to delete this statement?",

        export_excel: "Export Excel",
        export_pdf: "Export PDF",
        generate_report: "Generate Report",

        search_by_statement_number: "Search by Statement Number",
        filter_by_platform: "Filter by Platform",
        filter_by_date: "Filter by Date",

        uploaded_by: "Uploaded By",
        uploaded_at: "Uploaded At",
        uploaded_filename: "Uploaded File Name",

        financial_summary: "Financial Summary",
        order_details: "Order Details",

        type_order: "Order",
        type_refund: "Refund",
        type_adjustment: "Adjustment",

        all_platforms: "All Platforms",

        no_data: "No data found",
        loading: "Loading...",

        date_range: "Date Range",
        from_date: "From Date",
        to_date: "To Date",

        total_statements: "Total Statements",
        total_fees: "Total Fees",
        fee_percentage: "Fee Percentage",

        // Breakdown sections
        revenue_breakdown: "Revenue Breakdown",
        fee_breakdown: "Fee Breakdown",
        adjustment_breakdown: "Adjustment Breakdown",

        // Fee breakdown items
        total_transaction_fee: "Total Transaction Fee",
        total_affiliate_commission: "Total Affiliate Commission",
        total_affiliate_shop_ads: "Total Affiliate Shop Ads",
        total_service_fees: "Total Service Fees",

        // Adjustment breakdown items
        total_adjustment: "Total Adjustment",
        shipping_fee_adjustment: "Shipping Fee Adjustment",
        logistics_reimbursement: "Logistics Reimbursement",
        platform_compensation: "Platform Compensation",
        platform_penalty: "Platform Penalty",
        other_adjustments: "Other Adjustments",

        view_details: "View Details",
        back_to_list: "Back to List",
    },

    // =================================================================
    // Account Module
    // =================================================================
    account: {
        name: "Accounting",
        menu: {
            items: "Categories",
            records: "Transactions",
            reports: "Reports"
        },

        // Item fields
        item_name: "Category Name",
        create_item: "Create Category",
        edit_item: "Edit Category",

        // Tree + platform (2026-10-26)
        parent: "Parent category",
        parent_none: "None (top level)",
        parent_hint: "Only categories of the same type can be parents",
        platform: "Platform",
        platform_none: "Not bound to a platform",
        platform_inherited: "Inherited",
        platform_inherited_from: "Inherited from {path}: {platform}",
        platform_hint: "Expenses bound to a platform (incl. sub-categories) are deducted in that platform's cost report — unbound expenses are not counted",
        platform_income_na: "Income categories cannot be bound to a platform",
        add_sub: "Add sub-category",
        path: "Category (full path)",
        search_category: "Type to search any level",

        // Record fields
        create_record: "Create Transaction",
        edit_record: "Edit Transaction",
        transaction_date: "Transaction Date",
        amount: "Amount",
        reference_no: "Reference No.",
        created_by: "Created By",

        // Types
        type: "Type",
        income: "Income",
        expense: "Expense",
        all: "All",

        // Status
        active: "Active",
        inactive: "Inactive",

        // Common
        category: "Category",
        description: "Description",
        date_range: "Date Range",
        date_from: "From",
        date_to: "To",
        transactions: "Transactions",
        user_name: "User",

        // Reports
        report_by_item: "By Category",
        report_by_user: "By User",
        total_income: "Total Income",
        total_expense: "Total Expense",
        net_amount: "Net Amount",
        balance: "Balance",
        total_amount: "Total Amount",
        count: "Count",
        chart_by_date: "Chart by Date",
        no_data: "No data",

        // Batch creation
        batch_create: "Batch Create",
        add_row: "Add Row",
        duplicate_row: "Duplicate Row",
        total_rows: "Total Rows",
        channel: "Channel",

        // Errors
        error_required_fields: "Please fill in all required fields",
        error_name_required: "Category name is required",

        // Attachments
        attachments: "Attachments",
        attach_file: "Attach file",
        upload: "Upload",
        download: "Download",
        no_attachments: "No attachments yet",
        select_files: "Select files (max 10MB each)",
        file_too_large: "File exceeds 10MB",
        files_pending: "Files to upload",
        uploaded_files: "Uploaded files",
        uploading: "Uploading...",
        view: "View"
    },

    // Dashboard Menu
    menu_dashboard: "Dashboard",
    menu_dashboard_team: "Dashboard Status",
    menu_dashboard_platform: "Dashboard Platform",

    // Dashboard V2
    dashboard_v2: "Dashboard Platform",
    dashboard_by_platform_channel: "Dashboard Platform",
    by_platform: "By Platform",
    by_channel: "By Channel",
    by_user: "By User",
    by_packer: "By Packer",
    top_products: "Top Products",
    top_wms_products: "Top WMS Products",
    total_orders: "Total Orders",
    total_amount: "Total Amount",
    total_pay_amount: "Total Pay Amount",
    platform: "Platform",
    channel: "Channel",
    user: "User",
    user_type: "User Type",
    packer: "Packer",
    wms_product: "WMS Product",
    quantity: "Quantity",
    refresh: "Refresh",
    close: "Close",
    show_chart: "Show Chart",
    tab_by_platform: "By Platform",
    tab_by_channel: "By Channel",
    tab_by_user: "By User",
    tab_top_products: "Top Products",
    tab_top_wms: "Top WMS",
    tab_by_packer: "By Packer",
    tab_by_packer_storage: "By Packer Storage",
    chart_by_platform: "Sales by Platform",
    chart_by_channel: "Sales by Channel",
    chart_by_user: "Sales by User",
    chart_top_products: "Top Selling Products",
    chart_top_wms: "Top WMS Products",
    chart_by_packer: "Sales by Packer",
    count_all: "Total Count",
    export: "Export",
    // #223 — /admin/product's two export buttons. ROOT leaves: export_excel also
    // exists inside five namespaces, never at root, so these shadow nothing.
    export_excel: "Export Excel",
    export_json: "Export JSON",
    export_none: "Nothing to export",
    export_done: "Exported {count} items",
    export_cell_limit_warning:
        "Some rows exceed Excel's single-cell limit and were omitted — use JSON export for: {codes}",
    show_status_columns: "Show Status",
    hide_status_columns: "Hide Status",
    save_image: "Save Image",
    chart_by_count: "Chart by Count",
    chart_by_amount: "Chart by Amount",

    reprocess: {
        title: "Reprocess Orders (refresh tracking)",
        status_filter: "Status",
        platform: "Platform",
        platform_all: "All",
        created_range: "Created date",
        order_id: "Order ID",
        carrier: "Carrier",
        tracking: "Tracking",
        order_status: "Order status",
        shipping_status: "Shipping status",
        updated_at: "Updated at",
        action: "Action",
        refresh: "Refresh",
        refresh_selected: "Refresh selected",
        refresh_ok: "Refreshed",
        bulk_done: "Bulk refresh complete",
        total: "Total",
        process_all: "Process all matching",
        batch_title: "Bulk refresh progress",
        batch_confirm_title: "Process all matching orders?",
        batch_confirm_text: "The backend will iterate every order matching the current filter — may take several minutes.",
        batch_total: "Total",
        batch_processed: "Processed",
        batch_remaining: "Remaining",
        batch_success: "Success",
        batch_fail: "Failed",
        batch_running: "Running",
        batch_current: "Order",
        batch_done: "Completed",
        batch_errors: "Recent errors (first 50)",
        track_count_btn: "Thaipost quota",
        track_count_title: "Thaipost daily quota",
        track_count_used: "Used",
        track_count_remaining: "Remaining",
        track_count_limit: "Limit",
        track_count_date: "Date",
        track_count_updated: "Updated",
        track_count_empty: "No data yet — trigger at least one refresh first",
        fix_status: {
            title: "Fix Order Status",
            subtitle: "Change selected or filter-matching orders to 'Completed' (130)",
            scope_selected: "Selected only",
            scope_filtered: "All matching current filter",
            source_statuses_label: "Allowed source statuses",
            preview: "Will change {count} order(s) to 'Completed' (130)",
            submit: "Confirm and submit",
            confirm: "Confirm status fix?",
        },
        thaipost_subscribe: {
            title: "Subscribe Tracking (Thaipost)",
            subtitle: "Only orders where shipping_provider=Thaipost with a tracking number",
            scope_selected: "Selected only",
            scope_filtered: "All matching current filter",
            preview: "Will subscribe {count} tracking(s)",
            submit: "Confirm and submit",
            confirm: "Confirm subscribe?",
        },
        job: {
            in_progress: "Processing...",
            finished: "Finished",
            counters: {
                total: "Total",
                done: "Processed",
                succeeded: "Succeeded",
                skipped: "Skipped",
                failed: "Failed",
            },
        },
    },
    member_admin: {
        title: "Member Management",
        list_title: "Members",
        member_type: "Member type",
        member_type_all: "All",
        member_type_company: "Company",
        member_type_agent: "Agent",
        member_type_platform: "Platform",
        detail: "Member Detail",
        search_placeholder: "Search by name / phone / email",
        fname: "Name",
        phone: "Phone",
        total_spending: "Total Spending",
        in_transit_spending: "In Transit",
        success_spending: "Success",
        return_cancel_spending: "Return+Cancel",
        create_title: "Create member",
        create_subtitle: "Add a new member manually. Phone must be unique.",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        birthday: "Birthday",
        age: "Age",
        sex: "Sex",
        sex_male: "Male",
        sex_female: "Female",
        status_not_verify: "Not verified",
        status_normal: "Normal",
        status_verified: "Verified",
        status_block: "Block",
        status_registered_by_admin: "Registered by admin",
        personal_info: "Personal info",
        line_user_id: "LINE user ID",
        liff_level: "LIFF level",
        points_balance: "Points balance",
        address: "Address",
        address_search: "Subdistrict / District / Province / Postcode",
        subdistrict: "Subdistrict",
        district: "District",
        province: "Province",
        postcode: "Postcode",
        required_phone: "Phone is required",
        required_fname: "First name is required",
        email_invalid: "Invalid email format",
        address_required: "Address is required (use the search box to fill subdistrict / district / province / postcode)",
        export_excel: "Export Excel",
        export_failed: "Export failed",
        birthday_range: "Birthday (DD/MM)",
        birthday_from: "From (DD/MM)",
        birthday_to: "To (DD/MM)",
        birthday_md_hint: "MM-DD",
        birthday_clear: "Clear birthday",
        spending_min: "Spending min",
        spending_max: "Spending max",
        spending_unset_hint: "0 = no filter",
        spending_clear: "Clear spending",
        order_count: "Orders",
        order_count_min: "Order count min",
        order_count_max: "Order count max",
        order_count_clear: "Clear order count",
        created_range: "Created date",
        created_from: "From",
        created_to: "To",
        created_clear: "Clear created date",
        address_add: "Add address",
        address_create_title: "Add shipping address",
        address_edit_title: "Edit shipping address",
        address_search_hint: "Start typing subdistrict / district / province / postcode",
        set_default: "Set as default address",
        calc_spending: "Calculate spending",
        calc_spending_title: "Recalculate member total_spending",
        calc_spending_hint: "Sums pay_amount over non-cancelled/returned/claim orders in the selected window and writes the result back to each member.",
        calc_spending_run: "Run",
        calc_spending_done: "Calculation complete",
        calc_started: "Calculation started",
        calc_already_running: "Calculation already running — showing progress",
        calc_processing_date: "Processing date",
        calc_matching: "Looking up matching members",
        calc_phones_seen: "phones",
        calc_of: "of",
        calc_updating: "Updating members",
        calc_error: "Calculation failed",
        calc_duration: "Elapsed",
        calc_running_hide: "Running…",
        calc_spending_window: "Window",
        calc_spending_updated: "Members updated",
        calc_spending_total: "Total spent",
        calc_date_from: "Date from",
        calc_date_to: "Date to",
        order_detail: "Order detail",
        order_date_from: "Created from",
        order_date_to: "to",
        order_date_range: "Order created date range",
        recipient_name: "Recipient",
        recipient_phone: "Recipient phone",
        recipient_address: "Shipping address",
        sale_channel: "Sale channel",
        os_unpaid: "Unpaid",
        os_awaiting_shipment: "Awaiting shipment",
        os_awaiting_collection: "Awaiting collection",
        os_partially_shipping: "Partially shipping",
        os_awaiting_transit: "Awaiting transit",
        os_in_transit: "In transit",
        os_delivered: "Delivered",
        os_completed: "Completed",
        os_cancelled: "Cancelled",
        os_returned: "Returned",
        os_claim: "Claim",
        os_returning: "Returning",
        match_phone: "Matching phone",
        orders_hint: "Pick a date range and click Search to load orders matching this member's phone within that window.",
        payment_status: "Payment",
        tracking: "Tracking",
        total: "Total",
        platform: "Platform",
        created: "Created",
        amount: "Amount",
        pay_amount: "Pay amount",
        shipping_cost: "Shipping",
        discount: "Discount",
        platform_discount: "Platform discount",
        promotions: "Promotions",
        no_promotions: "No promotion data.",
        promotion_amount: "Promotion amount",
        product: "Product",
        quantity: "Qty",
        original_price: "Original price",
        sale_price: "Sale price",
        seller_discount: "Seller discount",
        wms_products: "WMS products",
        no_wms_products: "No WMS product data.",
        wms_product_name: "Product name",
        barcode: "Barcode",
        pickup_quantity: "Pickup qty",
        default: "Default",
        tabs: {
            profile: "Profile",
            addresses: "Addresses",
            points: "Points",
            coupons: "Coupons",
            redemptions: "Redemptions",
            orders: "Orders",
            notifications: "Notifications",
            sessions: "Sessions",
            events: "Events",
            pdpa: "PDPA",
            legacy: "Legacy Link",
            affiliate: "Affiliate",
        }
    },
    member_coins: {
        tab: "Coin",
        balance: "Coin balance",
        lifetime_earned: "Lifetime coins earned",
        adjust_btn: "Adjust coin",
        adjust_title: "Adjust member coin",
        adjust_hint: "Enter a positive amount to grant coin or a negative amount to take it back. A reason is always required and is kept in the log together with the operator name.",
        adjust_coins: "Coin amount (+ grant / - deduct)",
        adjust_preview: "Balance after (estimate)",
        adjust_note: "Reason",
        adjust_note_placeholder: "e.g. compensation for a late delivery",
        adjust_success: "Coin adjusted",
        no_rows: "No coin history",
        col_type: "Type",
        col_coins: "Coin",
        col_balance_after: "Balance after",
        col_ref: "Reference",
        col_note: "Note",
        col_expires_at: "Expires",
        col_created_at: "Created",
        type_earn: "Earned",
        type_burn: "Spent",
        type_refund: "Refunded",
        type_clawback: "Clawback",
        type_expire: "Expired",
        type_adjust: "Manual adjust",
        type_unknown: "Unknown type",
        err: {
            coins_nan: "Enter the coin amount as a whole number",
            coins_zero: "The coin amount cannot be 0",
            coins_range: "The coin amount cannot exceed 100,000 per entry",
            note_too_short: "Enter a reason of at least 3 characters",
            bad_adjust: "The server rejected this entry. Check the coin amount and the reason.",
            insufficient: "The coin balance is not enough for this deduction"
        },
        liability: {
            title: "Coin liability",
            month: "Month",
            export: "Export Excel",
            top_title: "Top 20 members by coin balance",
            no_data: "No data for this month",
            members_with_balance: "Members holding coin",
            expiring_next_month: "Coin expiring next month",
            col_rank: "#",
            col_member: "Member",
            col_name: "Name",
            col_coin_balance: "Coin balance",
            opened_balance: "Opening balance",
            earn: "Earned",
            burn: "Spent",
            refund: "Refunded",
            clawback: "Clawback",
            expire: "Expired",
            adjust: "Manual adjust",
            closing_balance: "Closing balance"
        }
    },
    member_level: {
        title: "Member Levels",
        btn_add: "Add Level",
        edit_title: "Edit Level",
        no_data: "No levels",
        col_code: "Code",
        col_name: "Name",
        col_min: "Min lifetime spending",
        col_rate: "Earn rate",
        col_members: "Members",
        col_free_shipping: "Free shipping",
        col_discount: "Discount (%)",
        col_color: "Color",
        pts_per_100: "pts / 100฿",
        label_code: "Code",
        label_name_th: "Name (TH)",
        label_name_en: "Name (EN)",
        label_min: "Min lifetime spending (฿)",
        label_rate: "Points per 100฿",
        hint_rate: "e.g. 4 = earn 4 points per 100฿ paid",
        label_free_shipping: "Free shipping",
        label_discount: "Discount (%)",
        hint_discount: "Per-tier extra discount (0–100) — not enforced at checkout yet (display only)",
        label_color: "Color",
        label_icon: "Icon",
        label_benefits: "Benefits (JSON)",
        hint_base_locked: "The base level threshold is fixed at 0",
        field_required: "Required",
        err_code: "Lowercase letters, numbers, underscore (max 32)",
        err_dup_min: "A level with this minimum already exists",
        err_benefits_json: "Benefits must be valid JSON",
        err_base_protected: "The base level cannot be deleted",
        delete_title: "Delete level?",
        delete_msg: "Members on this level will be reassigned automatically",
        delete_success: "Level deleted",
        save_success: "Saved",
        col_coin: "Coin (%)",
        col_privileges: "Privileges",
        label_coin: "Coin (%)",
        hint_coin: "Coin cashback rate for this tier (0–100) — 0 = not set, the store default applies · a bundle promotion outranks the tier",
        hint_coin_unset: "Not set — the store default applies",
        privilege_count_hint: "{active} of {total} active",
        label_privileges: "Privileges (list)",
        hint_privileges: "List order = the order customers see · every row needs Thai text · switch a row off to hide it without deleting",
        hint_benefits_legacy: "Legacy format (being retired) — what customers see now comes from the privilege list above",
        privilege_empty: "No privileges on this tier yet",
        privilege_icon: "Icon",
        privilege_label_th: "Text (TH)",
        privilege_label_en: "Text (EN)",
        privilege_active: "Active",
        privilege_remove: "Remove this row",
        privilege_move_up: "Move up",
        privilege_move_down: "Move down",
        btn_add_privilege: "Add privilege",
        privilege_diff: "On save: {added} added · {updated} changed · {removed} removed",
        privilege_icon_truck: "Shipping",
        privilege_icon_gift: "Gift",
        privilege_icon_star: "Star",
        privilege_icon_crown: "Crown",
        privilege_icon_headset: "Support",
        privilege_icon_cake: "Birthday",
        privilege_icon_percent: "Discount",
        privilege_icon_coin: "Coin",
        warn_unknown_icon: "One icon is not in the known set — it saves, but customers will see a neutral icon instead",
        err_cashback_percent: "Coin (%) must be between 0 and 100",
        err_cashback_range: "Coin (%) must be between 0 and 100",
        err_cashback_nan: "Coin (%) must be a number",
        err_privilege_label: "Every privilege needs Thai text"
    },
    kol: {
        created_by: "By",
        name: "KOL Management",
        menu: {
            staff: "Staff",
            creators: "Creators",
            assignments: "Assignments",
            product_sends: "Send Product",
            reports: "Reports",
            payout_batches: "Payout Batches"
        },
        staff: "Staff",
        staff_name: "Staff",
        creator_name: "Creator Name",
        nickname: "Nickname",
        code: "Code",
        channel_link: "Channel Link",
        follower_count: "Followers",
        line_contact: "Line Contact",
        tax_id: "Tax ID",
        bank_account: "Bank Account",
        bank_name: "Bank Name",
        address: "Address",
        brief_date: "Brief Date",
        clip_type: "Clip Type",
        clip_count: "Clip Count",
        script_detail: "Script Detail",
        hashtags: "Hashtags",
        cart_product: "Cart Product",
        quantity: "Quantity",
        color_variant: "Color Variant",
        order_number: "Order Number",
        tracking_number: "Tracking Number",
        product_received_date: "Product Received",
        status: "Status",
        review_status: "Review Status",
        quality_grade: "Quality Grade",
        commercial_usage: "Commercial Usage",
        post_date: "Post Date",
        original_file_link: "Original File",
        link_fb: "Facebook Link",
        link_lemon8: "Lemon8 Link",
        link_ig: "Instagram Link",
        link_tiktok: "TikTok Link",
        gencode: "Gencode",
        duration_days: "Duration (Days)",
        expiry_date: "Expiry Date",
        ads_tiktok: "TikTok Ads",
        payment_amount: "Payment Amount",
        tax_type: "Tax Type",
        payment_status: "Payment Status",
        payment_date: "Payment Date",
        note: "Note",
        total_assignments: "Total Assignments",
        total_payment: "Total Payment",
        total_pending: "Pending",
        total_completed: "Completed",
        status_pending: "Pending",
        status_briefed: "Briefed",
        status_product_sent: "Product Sent",
        status_posted: "Posted",
        status_completed: "Completed",
        payment_unpaid: "Unpaid",
        payment_paid: "Paid",
        create_staff: "Create Staff",
        edit_staff: "Edit Staff",
        create_creator: "Create Creator",
        edit_creator: "Edit Creator",
        create_assignment: "Create Assignment",
        edit_assignment: "Edit Assignment",
        select_staff: "Select Staff",
        creator_name: "Creator",
        select_creator: "Select Creator",
        select_status: "Select Status",
        brief_date_from: "Brief Date From",
        brief_date_to: "Brief Date To",
        brief_info: "Brief Info",
        shipping_info: "Shipping",
        content_info: "Content",
        payment_info: "Payment",
        change_status: "Change Status",
        mark_paid: "Mark as Paid",
        confirm_mark_paid: "Confirm Mark as Paid",
        status: {
            pending: "Pending",
            briefed: "Briefed",
            product_sent: "Product Sent",
            posted: "Posted",
            completed: "Completed",
        },
        payment: {
            paid: "Paid",
            unpaid: "Unpaid",
            no_payment: "Free",
        },
        tab: {
            brief_info: "Brief Info",
            shipping: "Shipping",
            content: "Content",
            payment: "Payment",
        },
        tax: {
            none: "None",
        },
        timeline: "Timeline",
        load_products: "Load Products",
        export_excel: "Export Excel",
        timeline_action: {
            created: "Created",
            status_change: "Status Changed",
            payment_change: "Payment Status Changed",
            updated: "Updated",
        },
        payout_batch_detail: "Payout batch detail",
        payout_progress: "Progress",
        payout_last_updated: "Last updated",
        payout_paid_at: "Paid at",
        payout_paid_by: "Paid by",
        payout_pay_item: "Record payment",
        payout_unpay_item: "Reverse payment",
        payout_view_slip: "View slip",
        payout_view_id_card: "ID Card",
        payout_view_bookbank: "Bookbank",
        payout_documents: "Documents",
        payout_upload_doc: "Upload document",
        payout_create_from_filter: "Create from filter",
        payout_filter_creator: "Creator",
        payout_filter_payment_status: "Payment status",
        payout_filter_date_range: "Job date range",
        payout_status_paid: "Paid",
        payout_status_unpaid: "Unpaid",
    },

    usage: {
        title: "Stock Usage",
        date_from: "Date from",
        date_to: "Date to",
        product_name: "Product name",
        barcode: "Barcode",
        balance: "Current stock",
        usage_quantity: "Usage qty",
        order_count: "Orders",
        window: "Window",
        days: "days",
        total_orders: "Total orders",
        export_excel: "Export Excel",
        error_required: "Please pick a date range",
        error_order: "Date to must be on or after Date from",
        error_too_long: "Date range must not exceed 31 days",
        processing: "Processing…",
        processing_hint: "Aggregating orders. This may take a moment for long ranges.",
    },

    forecast: {
        title: "Stock Forecast",
        days: "Days",
        refresh: "Refresh",
        product_name: "Product",
        barcode: "Barcode",
        current_stock: "Current Stock",
        usage: "Usage",
        daily_avg: "Daily Avg",
        days_can_sale: "Days Can Sale",
        show_zero: "Show zero usage",
        export_excel: "Export Excel",
        status: "Status",
        status_ok: "OK",
        status_low: "Low",
        status_critical: "Critical",
        status_out: "Out of Stock"
    },

    agent_commission: {
        name: "Agent Commission",
        menu: {
            settings: "Commission Profiles",
            rounds: "Commission Rounds",
            round_detail: "Round Detail",
            remittance: "COD Remittance Import",
        },
        settings_title: "Agent Commission Rate Settings",
        profiles_title: "Commission Profiles",
        new_profile: "New Profile",
        profile_name: "Profile Name",
        set_default: "Set as default",
        default_badge: "Default",
        agent_count: "Agents",
        select_profile_hint: "Select a profile from the list, or create a new one",
        empty_profiles: "No profiles yet",
        delete_profile_confirm: "Confirm delete this profile",
        cannot_delete_default: "Cannot delete the default profile",
        cannot_delete_in_use: "Cannot delete: agents are still linked to this profile",
        agents_tab: "Agents",
        agent_profile: "Commission Profile",
        use_default: "Use default (Default)",
        empty_agents_list: "No agents",
        remittance_title: "COD Remittance Import",
        upload: "Upload File",
        carrier: "Carrier",
        file_hint_xls: "Accepts .xlsx and .csv (save .xls as .xlsx before uploading)",
        remittance: {
            total: "Total",
            matched: "Matched",
            unmatched: "Unmatched",
            duplicates_skipped: "Duplicates skipped",
            processing: "Processing",
            failed: "Failed",
            done: "Done",
            match: "Match",
            unmatch: "Unmatch",
            match_dialog_title: "Match Order",
            select_order: "Enter order ID",
            match_success: "Matched successfully",
            tracking: "Tracking",
            cod_amount: "COD Amount",
            transfer_amount: "Transfer Amount",
            transfer_date: "Transfer Date",
            no_unmatched: "No unmatched rows",
            history: "Import History",
            no_batches: "No import history yet",
            file_name: "File Name",
        },
        payment_type_cod: "Cash on Delivery (COD)",
        payment_type_transfer: "Bank Transfer",
        rounds_title: "Agent Commission Rounds",
        tier: {
            min_amount: "Min Sales",
            max_amount: "Max Sales",
            max_amount_hint: "Leave blank = no limit",
            percent: "Percent (%)",
            add_tier: "Add Tier",
            save_tiers: "Save Settings",
        },
        round: {
            code: "Round Code (YYYY-MM)",
            period: "Period",
            period_start: "Start",
            period_end: "End",
            status: "Status",
            total_sales: "Total Sales",
            total_commission: "Total Commission",
            agent_count: "Agents",
            order_count: "Orders",
            created_at: "Created At",
            note: "Note",
            select_month: "Select month",
            preview: "Preview",
            create: "Create Round",
            delete: "Delete / Reopen",
            confirm_delete: "Confirm delete this round",
            confirm_delete_msg: "Deleting will unassign all orders in this round. Orders will re-enter the pool for a future round. Continue?",
            status_closed: "Closed",
            preview_title: "Preview Calculation",
        },
        agent: {
            agent_name: "Agent Name",
            total_sales: "Total Sales",
            tier_percent: "Tier %",
            commission_amount: "Commission",
            order_count: "Orders",
            view_orders: "View Orders",
        },
        order: {
            order_number: "Order Number",
            pay_amount: "Amount",
            completed_at: "Completed At",
            created_at: "Created At",
            order_status: "Status",
            view_order: "View Order",
            payment_type: "Payment Type",
        },
        validation: {
            percent_range: "Percent must be between 0 and 100",
            min_required: "Min sales amount is required",
            overlapping: "Sales ranges must not overlap",
            not_ascending: "Min sales must be in ascending order",
            code_required: "Please select a month",
            name_required: "Please enter a profile name",
        },
        empty_tiers: "No commission tiers configured",
        empty_rounds: "No commission rounds yet",
        empty_agents: "No agents in this round",
        empty_orders: "No orders",
        save_success: "Saved successfully",
        create_success: "Round created successfully",
        delete_success: "Round deleted successfully",
        permission_label: "ค่าคอมตัวแทน / Agent Commission",
    },
    issue_report: {
        component: {
            MEMBER: "MEMBER — Member system (mdf-member-fn + API)",
            APP: "APP",
            WEB: "WEB",
            BO: "BO",
        },
        component_desc: {
            MEMBER: "Member system / member pages and the backing API used together",
            APP: "Mobile app",
            WEB: "Storefront web",
            BO: "Backoffice",
        },
        kind: {
            bug: "Bug",
            feature: "Feature",
        },
        severity: {
            low: "Low",
            medium: "Medium",
            high: "High",
        },
        work_status: {
            pending_review: "Pending review",
            in_progress: "In progress",
            done: "Resolved",
            cancelled: "Cancelled",
        },
        form: {
            title: "Report an Issue / Request a Feature",
            breadcrumb: "Report Issue",
            my_reports: "My Reports",
            kind: "Type",
            component: "Component",
            subject: "Subject",
            subject_placeholder: "Short summary of the issue or feature",
            description: "Description",
            description_placeholder: "Describe the problem, steps to reproduce, or what you need",
            severity: "Severity",
            screenshot: "Screenshot (optional)",
            attachments: "Screenshots (optional)",
            add_attachments: "Add images",
            attach_limit: "PNG/JPEG/WebP/GIF, up to 5MB each",
            attach_limit_reached: "You can attach up to 10 images",
            file_type_invalid: "Unsupported file type",
            wait_upload: "Please wait for the uploads to finish",
            upload_screenshot: "Upload screenshot",
            uploading: "Uploading...",
            remove: "Remove",
            cancel: "Cancel",
            submit: "Submit Report",
            success: "Report submitted. Our team will review it.",
            submit_error: "Could not submit the report. Please try again.",
            subject_required: "Subject is required",
            description_required: "Description is required",
            component_required: "Please select a component",
            file_too_large: "File too large (max 5MB)",
            upload_failed: "Screenshot upload failed",
        },
        list: {
            title: "My Reports",
            breadcrumb: "My Reports",
            report_button: "Report Issue",
            sync_now: "Sync now",
            sync_success: "Synced (created {created}, updated {touched})",
            sync_error: "Could not sync. Please try again.",
            scope_mine: "Mine",
            scope_all: "All",
            col_created_at: "Reported At",
            col_title: "Subject",
            col_reporter: "Reporter",
            col_component: "Component",
            col_severity: "Severity",
            col_work_status: "Status",
            col_attachments: "Images",
            col_github: "GitHub",
            resolved_in: "Resolved in {version}",
            no_data: "No reports yet",
            load_error: "Could not load reports",
            total_count: "Total",
        },
    },
    release: {
        title: "Releases",
        subtitle:
            "Version history across API, App, Web and Backoffice — newest first. Highlighted chips changed since the previous release.",
        breadcrumb: "Releases",
        no_data: "No releases yet",
        no_fixes: "No linked issues",
        component: {
            api: "API",
            app: "APP",
            web: "WEB",
            bo: "BO",
        },
        component_desc: {
            api: "Backoffice API (mdf-bo-api)",
            app: "MadameFin mobile app (Flutter)",
            web: "Storefront web (mdf-www)",
            bo: "Backoffice (mdf-bo-fn)",
        },
    },
    sync: {
        modal: {
            title_order: "Sync {platform} Orders",
            title_product: "Sync {platform} Products",
            status: {
                queued: "Queued",
                running: "Syncing",
                done: "Done",
                failed: "Failed",
            },
            progress: "{done} / {total} items",
            progress_indeterminate: "{done} items synced",
            failed_count: "{failed} failed",
            view_orders: "View Orders",
            view_products: "View Products",
            close: "Close",
            busy: "A sync is already running",
        },
        log: {
            button: "Sync Log",
            title: "Sync Log",
            breadcrumb: "Sync Log",
            filter_platform: "Platform",
            filter_type: "Type",
            filter_status: "Status",
            filter_date_from: "From",
            filter_date_to: "To",
            all: "All",
            search: "Search",
            type_order: "Order",
            type_product: "Product",
            col_created_at: "Created At",
            col_platform: "Platform",
            col_type: "Type",
            col_shop: "Shop",
            col_created_by: "Created By",
            col_status: "Status",
            col_progress: "Progress",
            col_error: "Error",
            col_duration: "Duration",
            no_data: "No sync jobs found",
            load_error: "Failed to load sync jobs",
            total_count: "Total",
        },
    },
    // NOTE: ต้องไม่ชื่อ `platform` — มี key ระดับบนสุด `platform: "แพลตฟอร์ม"` อยู่ก่อนแล้ว
    // ถ้าตั้งชื่อซ้ำ object นี้จะทับ string (key หลังชนะ) แล้ว $t('platform') ทั่วระบบ
    // จะคืน object ออกมาแทนคำแปล (โผล่เป็น JSON ก้อนใหญ่ / header เป็น undefined)
    platform_integration: {
        makro: {
            title: "Makro PRO",
            instance_url: "Instance URL",
            api_key: "API Key",
            shop_id: "Shop ID",
            shop_name: "Shop Name",
            configured: "Configured",
            not_configured: "Not configured",
            credentialsConfigInfo: "Set credentials in config.yml (platform.mirakl)",
            test_connection: "Test Connection",
            test_ok: "Connected: {shop}",
            test_fail: "Connection failed: {reason}",
            offer_hint: "Makro offers come from Makro-platform products on the product page (map WMS there)",
            push_offers: "Push stock/price",
            push_fail: "Push stock/price failed",
            offer_sku: "Offer SKU",
            push_offer: "Push single offer",
            offer_sku_required: "Offer SKU is required",
            push_offer_ok: "Offer pushed to Makro",
            push_offer_fail: "Offer push failed",
        },
        // amaze — Amaze (amaze-x) Seller Open API, Phase 0 (status card + test + sync)
        amaze: {
            title: "Amaze",
            configured: "Connected",
            not_configured: "Not configured",
            env: "Environment",
            env_uat: "UAT",
            env_prod: "Production",
            shop_name: "Shop Name",
            amaze_id: "Amaze ID",
            account: "Account",
            credentialsConfigInfo: "Set credentials in config.yml (platform.amaze)",
            test_connection: "Test Connection",
            test_ok: "Connected: {shop}",
            test_fail: "Connection failed: {reason}",
            sync_order: "Sync Order",
            sync_product: "Sync Product",
            date_format_detected: "Date format: {format}",
            rate_limit: "Limit: {rps} req/s",
            rate_limit_hint:
                "This limit applies to this container only — it is not the combined budget (Amaze limits per IP).",
            last_order_poll: "Last order poll: {time}",
            last_product_poll: "Last product poll: {time}",
            poller_never: "never polled",
            poller_unknown: "unknown (status unavailable)",
            poller_stalled: "The poller in the Webhook service may have stopped",
        },
    },
    shipping_config: {
        menu: "Shipping Config",
        title: "Shipping Configuration by Sale Channel",
        permission_label: "ตั้งค่าการจัดส่ง / Shipping Config",
        col_sale_channel: "Sale Channel",
        col_default: "Default",
        col_map: "Mapping (Payment → Provider)",
        col_updated: "Last Updated",
        edit: "Edit",
        add_channel: "Add Channel",
        default_section: "Default",
        map_section: "Payment Method → Shipping Provider Mapping",
        add_row: "Add Row",
        payment_method: "Payment Method",
        provider: "Shipping Provider",
        none: "Not set",
        dup_payment_err: "Duplicate payment method in mapping",
        save: "Save",
        cancel: "Cancel",
        save_success: "Shipping configuration saved successfully",
    },
    modern_trade: {
        name: "Modern Trade",
        permission_label: "Modern Trade",
        common: {
            no_barcode: "No barcode",
        },
        lot_form: {
            title: "Enter Lot and expiry",
            hint: "Partial receipts are allowed — leave out products not received this round. Every row needs a lot, expiry date and quantity. Expiry must be on or after {date}.",
            to_receive: "To receive",
            entered: "Entered",
            add_lot: "Add Lot",
            lot_no: "Lot No.",
            save: "Save receipt",
            saved: "Receipt saved (partially received)",
            saved_full: "Receipt saved — everything received",
            server_rejected: "Could not save — please fix the flagged rows",
            badge_partial: "Partially received {received}/{ordered}",
            badge_full: "Fully received",
            err_blank_lot: "Enter a Lot No.",
            err_blank_expiry: "Pick an expiry date",
            err_bad_qty: "Quantity must be a whole number above 0",
            err_shelf_life_lt_1y: "Expiry must be at least 1 year after the receive date",
            err_exceeds_remaining: "Total of all lots exceeds the quantity to receive",
            err_duplicate_row: "This lot is entered twice for this product",
            err_lot_expiry_mismatch: "This lot is already in stock with a different expiry date",
            err_empty: "Enter at least one row",
            err_not_in_sale_order: "This product is not on this sale order",
            err_no_wms_mapping: "This product is not linked to a warehouse (WMS) product yet",
            err_unknown_product: "Product not found",
            err_bad_date: "Invalid date format",
            err_company_inactive: "The partner company is inactive",
        },
        menu: {
            companies: "Partner Companies",
            receipts: "Goods Receipts",
            sales_import: "Sales Data",
            consignment_payments: "Consignment Payments",
            stock: "MT Stock",
            expiry_report: "Expiry Report",
            expiry_returns: "Near-expiry Returns",
            products: "Products",
            price_templates: "Price Templates",
            sale_orders: "Purchase Orders",
            settings: "Settings",
            reports: "Reports",
            invoices: "Invoices",
            report_sales: "Sales Report",
            report_stock_value: "Stock Value Report",
            doc_format: "Document Format",
            audit: "Audit Log",
        },
        company: {
            title: "Partner Companies",
            create: "Add Company",
            edit: "Edit Company",
            name: "Company Name",
            tax_id: "Tax ID",
            branch_code: "Branch Code",
            address: "Address",
            contact_name: "Contact Name",
            contact_tel: "Contact Phone",
            contact_email: "Contact Email",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            delete_confirm: "Confirm delete this company?",
            has_stock_cannot_delete: "Cannot delete a company with stock movements. Set status to Inactive instead.",
            duplicate_tax_id: "Tax ID and branch code already exist for this enterprise",
            tax_id_locked_hint: "Tax ID cannot be edited because this company already has stock movements",
            has_movements_cannot_edit: "Cannot change Tax ID / branch code: this company already has stock movements",
            name_required: "Please enter the company name",
            tax_id_invalid: "Tax ID must be exactly 13 digits",
            price_profile: "Price Profile",
            vat_included: "Retail Price Includes VAT",
            gp_percent: "GP (%)",
            credit_term_days: "Credit Term (days)",
            price_template: "Price Template",
            no_template: "No template linked",
        },
        receipt: {
            title: "Goods Receipts",
            create: "Create Receipt",
            po_number: "PO Number",
            po_file: "PO File",
            upload_po: "Upload PO Document",
            download_po: "Download PO",
            status: "Status",
            status_draft: "Draft",
            status_received: "Received",
            status_canceled: "Canceled",
            note: "Note",
            received_at: "Received At",
            items: "Items",
            import_items: "Import Items",
            delete_draft_confirm: "Confirm delete this draft receipt?",
            company_required: "Please select a company",
            po_number_required: "Please enter the PO number",
            po_file_required: "Please select a PO file",
        },
        settings: {
            title: "Modern Trade Settings",
            min_shelf_life_days: "Min Shelf Life (days)",
            min_shelf_life_hint: "Items expiring sooner than this threshold will be rejected on receipt",
            min_shelf_life_invalid: "Minimum shelf life must be a whole number of 0 or more",
            // #512 — the two values the "Create packing order" button depends on
            sale_channel: "Sale channel for packing orders",
            sale_channel_hint: "Orders created from a delivery note are stamped with this sale channel (agent-type channels cannot be used — the packing round filters them out)",
            payment_method: "Payment method for packing orders",
            payment_method_hint: "Orders created from a delivery note are stamped with this payment method",
            select_placeholder: "Select from the list",
            // Wording for a value that IS set but cannot be used, chosen from the
            // reason code GET returns (sale_channel_issue / payment_method_issue):
            // the three reasons need three different actions from the operator —
            // not_selectable in particular is a row nobody deleted.
            // unusable_* is the fallback for a code this build does not know yet.
            issue: {
                deleted_option: "{name} (deleted)",
                deleted_warning: "Currently set to {name}, but that option has been deleted. The \"Create packing order\" button stays broken until a new one is selected and saved",
                missing_option: "{name} (not found)",
                missing_warning: "Currently set to {name}, but no such record exists any more (hard-deleted, or an id that never existed). The \"Create packing order\" button stays broken until a new one is selected and saved",
                not_selectable_option: "{name} (agent type — unusable for Modern Trade)",
                not_selectable_warning: "Currently set to {name}, which is an agent-type (Agent) sale channel. Nothing was deleted — the record is still there — but the packing round filters agent-type channels out, so the packing room would never see an order created with it. The \"Create packing order\" button refuses until a non-agent channel is selected and saved",
                unusable_option: "{name} (unusable)",
                unusable_warning: "Currently set to {name}, but the server reports it cannot be used for Modern Trade. The \"Create packing order\" button stays broken until a new one is selected and saved",
            },
            unset_warning: "Not configured yet — the \"Create packing order\" button will report a missing setting until one is selected and saved",
            options_failed: "Could not load the option lists. Please close this dialog and open it again",
            error: {
                invalid_sale_channel: "The selected sale channel was not found (it may have been deleted)",
                sale_channel_not_selectable: "This sale channel cannot be used for Modern Trade (agent-type channels are filtered out of the packing round)",
                invalid_payment_method: "The selected payment method was not found (it may have been deleted)",
                setting_retired: "A retired setting was sent to the server, so nothing was saved",
            },
            // The deduct_main_stock switch was retired (bo-api #505). These three
            // lines take its place so the rule change is visible where the switch was.
            stock_rule_title: "How Modern Trade cuts stock",
            stock_rule_do: "Issuing a delivery note is a paper act — it moves no stock at all",
            stock_rule_order: "Stock is held only when “Create packing order” is pressed on a delivery note; the packing room cuts it for real when the round is closed",
            stock_rule_manual: "A delivery note with no packing order never cuts stock — staff must cut it in WMS by hand",
            saved: "Settings saved successfully",
        },
        import: {
            pick_file: "Select File",
            template: "Download Template",
            validate: "Validate",
            preview: "Preview",
            confirm: "Confirm",
            cancel: "Cancel",
            row_no: "Row",
            status_ok: "OK",
            status_error: "Error",
            error_message: "Message",
            summary_total: "Total",
            summary_ok: "OK",
            summary_error: "Errors",
            download_report: "Download Report",
            confirm_note: "Click Confirm to commit data to the system",
            duplicate_file: "This file has already been imported",
            allocation: "FEFO Allocation",
            import_success: "Import successful",
        },
        sales: {
            title: "Sales Import",
            history: "Import History",
            sale_date: "Sale Date",
            import_success: "Sales data imported successfully",
        },
        sales_entry: {
            title: "Sales Data",
            doc_no: "Document No.",
            company: "Company",
            branch: "Branch",
            branch_code: "Branch Code",
            sold_at: "Sale Date",
            item_count: "Items",
            total_qty: "Total Qty",
            source: "Source",
            source_import: "Import",
            source_manual: "Manual",
            created_at: "Created At",
            search_placeholder: "Search document no.",
            date_from: "From Date",
            date_to: "To Date",
            btn_import: "Import",
            btn_add: "Add",
            detail_title: "Sales Data Detail",
            detail_items: "Items",
            sku_code: "SKU Code",
            barcode: "Barcode",
            product_name: "Product Name",
            lot_no: "Lot",
            qty: "Qty",
            deducted_lots: "Deducted Lots",
            import_title: "Import Sales Data",
            pick_company: "Select Company",
            add_title: "Add Sales Data",
            add_product: "Add Product",
            select_product: "Select Product",
            lot_auto_fefo: "Auto (FEFO)",
            lot_remaining: "remaining",
            lot_expire: "exp.",
            company_required: "Please select a company",
            sold_at_required: "Please select a sale date",
            add_item_required: "Please add at least one product",
            qty_required: "Please fill in quantity for all rows",
            save: "Save",
            save_success: "Sales data saved successfully",
            import_success: "Sales data imported successfully",
            file_format_title: "Import file format",
            file_format_hint_key: "Fill in sku_code or barcode — at least one per row (product code is no longer supported)",
            file_format_hint_date: "sale_date: format YYYY-MM-DD, must not be a future date",
            file_format_hint_lot: "lot_no: optional — leave blank to auto-allocate stock by FEFO",
            file_format_hint_qty: "qty: positive integer",
            col_sku_code: "SKU Code",
            col_barcode: "Barcode",
            col_sale_date: "Sale Date",
            col_lot_no: "Lot",
            col_qty: "Qty",
            err_missing_sku_or_barcode: "Either sku_code or barcode is required",
            err_unknown_product: "No product found for the given SKU code / barcode",
            import_errors_truncated: "Showing {shown} of {total} error rows — fix the ones shown and re-upload to see the rest",
        },
        stock: {
            title: "MT Stock",
            group_by_lot: "Group by Lot",
            group_by_product: "Group by Product",
            hide_zero: "Hide zero stock",
            lot_no: "Lot No.",
            expired_date: "Expiry Date",
            days_to_expire: "Days to Expiry",
            qty: "Qty",
            movements: "Movement Ledger",
            adjust: "Adjust Stock",
            adjust_qty: "Qty (signed +/-)",
            adjust_reason: "Reason",
            movement_type_receive: "Receive",
            movement_type_sale: "Sale",
            movement_type_adjust: "Adjust",
            movement_type_recall: "Expiry return",
            no_movements: "No data",
            fill_all_required: "Please fill in all required fields",
            qty_not_zero: "Please enter a quantity (not 0)",
            reason_required: "Please enter a reason",
            adjust_success: "Stock adjusted successfully",
        },
        report: {
            expiry_title: "Expiry Report",
            days_ahead: "Days Ahead",
            bucket_expired: "Expired",
            bucket_active: "Not expired",
            bucket_30: "≤ 30 days",
            bucket_60: "≤ 60 days",
            bucket_90: "≤ 90 days",
            export_xlsx: "Export Excel",
        },
        // spec 2026-11-03 §5 — near-expiry returns page
        expiry_return: {
            title: "Near-expiry Returns",
            candidates_title: "Pick a lot to return",
            history_title: "Return history",
            days_within: "Expiring within (days)",
            days_option: "{days} days",
            product: "Barcode – Name",
            days_left: "Days left",
            available: "Available",
            action: "Action",
            return_btn: "Return",
            dialog_title: "Near-expiry return",
            qty: "Qty to return",
            qty_hint: "Up to {max}",
            return_date: "Return date",
            note: "Note",
            confirm: "Confirm return",
            cancel: "Cancel",
            confirm_title: "Return {qty} pcs from lot {lot}?",
            confirm_text: "Only this lot is deducted from MT stock and this cannot be cancelled later. If it is wrong, use a stock adjustment.",
            saved: "Return recorded",
            insufficient_stock: "Not enough in this lot. Available now: {available}",
            err_not_positive_int: "Qty must be a whole number greater than 0",
            err_exceeds_available: "Qty must not exceed the available qty ({max})",
            err_return_date: "Select a return date",
            err_future_date: "The return date cannot be later than today",
            lot_empty: "This lot has nothing left (it was taken earlier) — removed from the list",
            err_history_range: "The start date cannot be after the end date",
            date_range: "Return date range",
            date_from: "From",
            date_to: "To",
            return_date_col: "Return date",
            recorded_by: "Recorded by",
            no_candidates: "No lots near expiry",
            no_history: "No returns yet",
        },
        // round-19 Dev-C — global document-number search (#363 §1)
        doc_search: {
            placeholder: "Search document no. (SO / MO / DO / PO / IV / receipt)",
            no_result: "No document found",
            type_sale_order: "Sale Order",
            type_po: "Customer PO",
            type_production_order: "Production Order",
            type_delivery: "Delivery Note",
            type_invoice: "Tax Invoice",
            type_receipt: "Goods Receipt",
        },
        validation: {
            unknown_tax_id: "Tax ID not found in the system",
            tax_id_mismatch: "Tax ID does not match the receipt company",
            company_inactive: "Company is inactive",
            unknown_product: "Product code not found (no barcode or man_pn match)",
            bad_date: "Invalid date format",
            expired_on_receive: "Item is already expired and cannot be received into stock",
            shelf_life_too_short: "Item shelf life is below the configured minimum",
            lot_expiry_mismatch: "Lot expiry date does not match the existing record",
            bad_qty: "Invalid qty (must be a positive integer)",
            duplicate_row: "Duplicate row within the file",
            future_sale_date: "Sale date is in the future",
            unknown_lot: "Lot not found for this company and product",
            insufficient_stock: "Insufficient stock",
            bad_header: "Invalid or missing file header columns",
            file_too_large: "File exceeds the size limit (max 5,000 rows / 10 MB)",
            all_or_nothing_blocked: "Fix all error rows before confirming",
        },
        product: {
            title: "MT Products",
            create: "Add Product",
            edit: "Edit Product",
            code: "Product Code",
            name: "Product Name",
            category: "Category",
            manufacturer: "Manufacturer",
            unit_buy: "Buy Unit",
            unit_sell: "Sell Unit",
            unit_stock: "Stock Unit",
            size_value: "Size",
            size_unit: "Size Unit",
            sku_code: "SKU Code",
            sku_mapped: "Mapped",
            sku_unmapped: "Not mapped",
            category_manage: "Manage Categories",
            category_name: "Category Name",
            category_add: "Add",
            category_add_placeholder: "New category name",
            category_delete_confirm: "Delete this category?",
            wms_product: "WMS Product",
            default_retail_price: "Default Retail Price",
            account_code: "Account Code",
            note: "Note",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            import: "Import Products",
            import_template: "Download Template",
            search_placeholder: "Search by code or name",
            delete_confirm: "Confirm delete this product?",
            has_reference_cannot_delete: "Cannot delete a product referenced in a purchase order. Set it to Inactive instead.",
            code_required: "Please enter the product code",
            name_required: "Please enter the product name",
            code_duplicate: "Product code already exists",
            sku_not_resolved: "SKU code does not match any WMS product (barcode / man_pn)",
            saved: "Product saved successfully",
            import_success: "Products imported successfully",
        },
        price_template: {
            title: "Price Templates",
            create: "Add Template",
            edit: "Edit Template",
            rename: "Rename",
            name: "Template Name",
            note: "Note",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            items: "Price Items",
            items_count: "Items",
            select_for_pricing: "Select this template to edit its price items",
            add_item: "Add Item",
            product: "Product",
            retail_price: "Special Retail Price",
            save_items: "Save Price Items",
            delete_confirm: "Confirm delete this template?",
            has_company_cannot_delete: "Cannot delete a template linked to a company",
            name_required: "Please enter the template name",
            price_required: "Please enter the retail price",
            product_required: "Please select a product",
            saved: "Template saved successfully",
            items_saved: "Price items saved successfully",
            select_hint: "Select a template on the left to edit its price items",
            empty_templates: "No price templates yet — click \"Add Template\" (top right) to create one",
            empty_items: "No price items in this template yet — pick a product, set a price, then click \"Add Item\"",
            no_products: "No products in Modern Trade yet",
            no_products_hint: "Add products on the \"MT Products\" page first, then you can set special prices here",
            no_products_match: "No product matches your search",
            go_products: "Go to MT Products",
            price_positive: "Retail price must be greater than 0",
            product_duplicate: "This product is already in the template",
            read_only: "You have read-only access — Modern Trade write permission is required to add/edit/delete price templates",
            load_failed: "Could not load price templates",
            products_load_failed: "Could not load MT products",
            products_load_failed_hint: "Check your connection, then click \"Retry\"",
            retry: "Retry",
        },
        sale_order: {
            title: "Purchase Orders",
            detail_title: "Purchase Order Detail",
            create: "Create Purchase Order",
            so_no: "SO No.",
            created_at: "Created",
            company: "Company",
            sale_type: "Sale Type",
            sale_type_consignment: "Consignment",
            sale_type_outright: "Outright",
            shipping_type: "Shipping Type",
            shipping_type_pack: "From Pack Room",
            shipping_type_factory: "From Factory",
            shipping_type_express: "Pack Room Drop-ship (MDF Express)",
            po_number: "PO Number",
            po_file: "PO File",
            upload_po: "Upload PO Document",
            download_po: "Download PO",
            note: "Note",
            items: "Items",
            product: "Product",
            qty: "Qty",
            retail_price: "Retail Price",
            unit_price: "Unit Price",
            estimate: "Estimated",
            estimate_note: "Prices are estimated; the system will calculate the actual price after saving",
            price_source_template: "Company template price",
            price_source_default: "Product default price",
            gp_percent: "GP %",
            discount: "Discount",
            bill_discount: "Bill Discount",
            amount: "Amount",
            sub_total: "Sub Total",
            vat_amount: "VAT",
            net_amount: "Net Amount",
            status: "Status",
            status_draft: "Draft",
            status_confirmed: "Confirmed",
            status_in_production: "In Production",
            status_goods_received: "Goods Received",
            status_delivered: "Delivered",
            status_closed: "Closed",
            status_cancelled: "Cancelled",
            tracking: "Tracking No.",
            bo_order: "BO Order",
            shipping_team_note: "This shipment type can produce a packing order from its delivery note — open the delivery note and press \"Create packing order\"; the pack room cuts the stock and the tracking number comes back on the order. If you choose not to create the order, cut the stock in WMS yourself and enter the tracking number on the delivery note.",
            confirm: "Confirm Order",
            cancel: "Cancel Order",
            confirm_confirm: "Confirm this purchase order? Prices will be locked.",
            cancel_confirm: "Confirm cancel this purchase order?",
            close: "Close Order",
            close_confirm: "Confirm close this sale order? \"Closed\" is final — no further edits, cancellation, payments or documents are allowed afterwards.",
            closed: "Sale order closed successfully",
            closed_banner: "This sale order is closed.",
            closed_banner_hint: "It can no longer be modified (viewing and printing still work).",
            production_orders: "Production Orders",
            gen_production_orders: "Generate Production Orders",
            production_order_pdf: "MO PDF",
            mo_status_issued: "Issued",
            mo_status_received: "Received",
            lot_template: "Lot/Expiry Excel",
            goods_import: "Import Goods (Lot/Expiry)",
            received_lots: "Received Lots",
            qty_received: "Received",
            qty_delivered: "Delivered",
            qty_available: "Available",
            deliveries: "Deliveries",
            create_delivery: "Create Delivery",
            delivery_date: "Delivery Date",
            delivery_pdf: "Delivery Note PDF",
            lot_no: "Lot No.",
            expired_date: "Expiry Date",
            available: "Available",
            consignment_invoice_info: "Consignment invoices are issued from the Invoices page based on actual sales",
            company_required: "Please select a company",
            sale_type_required: "Please select a sale type",
            shipping_type_required: "Please select a shipping type",
            po_number_required: "Please enter the PO number",
            po_file_required: "Please select a PO file",
            po_file_too_large: "File exceeds 10MB",
            items_required: "Please add at least one item",
            no_price: "No price found for this product; cannot add to the order",
            unmapped_sku_block: "Some products have no WMS mapping; cannot create a BO order",
            edit_draft_only: "Only draft purchase orders can be edited",
            saved: "Sale order saved successfully",
            confirmed: "Sale order confirmed",
            cancelled: "Sale order cancelled",
            po_date: "PO Date",
            customer: "Customer",
            view_customer: "Customer Detail",
            created_from: "Created From",
            created_to: "Created To",
            created_date_range: "Created Date Range",
            view_pdf: "View PDF",
            product_detail: "Product Detail",
            tab_items: "Items",
            tab_warehouse: "Warehouse",
            tab_finance: "Finance",
            // The warehouse tab of a draft / cancelled sale order has no cards at all.
            warehouse_empty: "Draft or cancelled sale orders have no warehouse data yet",
            no_sku_badge: "No SKU code",
            no_sku_hint: "Products with no SKU code (not linked to the warehouse) are flagged in red",
            no_sku_confirm_title: "This product has no SKU code",
            no_sku_confirm_text: "This product is not linked to the warehouse (WMS). Add it to the sale order anyway? Please link its SKU code on the Modern Trade products page before delivery.",
            // Task 9 (2026-11-03 spec §2): full-page PO editor + drafts
            edit_title: "Edit sale order",
            save_draft: "Save draft",
            save_and_confirm: "Save and confirm",
            draft_saved: "Draft saved",
            draft_hint: "A draft can be saved without a PO number or PO file — both are required before Save and confirm",
            search_product: "Search barcode or product name",
            select_company_first: "Choose a company first — prices depend on the company",
            no_product_found: "No products found",
            lines_empty: "No items yet — press + on a product on the left to add it",
            no_price_badge: "No price",
            current_po_file: "Current file",
            po_file_replace_hint: "Choose a new file only to replace the current one",
            unsaved_title: "You have unsaved changes",
            unsaved_text: "Leave this page without saving? Your changes will be lost.",
            unsaved_leave: "Leave without saving",
            unsaved_stay: "Stay",
            confirm_failed_saved: "Draft saved, but the order could not be confirmed",
            err_missing_po_number: "Cannot confirm: enter the PO number",
            err_missing_po_file: "Cannot confirm: attach the PO file",
            err_no_items: "Cannot confirm: add at least one item",
        },
        invoice: {
            title: "Invoices",
            tab_invoices: "Invoices",
            create: "Create Invoice",
            doc_no: "Invoice No.",
            company: "Company",
            invoice_date: "Invoice Date",
            due_date: "Due Date",
            credit_term_days: "Credit Term (days)",
            sale_order: "Purchase Order",
            sales_batch: "Sales Batch",
            source: "Source",
            source_outright: "Outright",
            source_consignment: "Consignment",
            sub_total: "Sub Total",
            bill_discount: "Bill Discount",
            vat_amount: "VAT",
            net_amount: "Net Amount",
            paid_amount: "Paid",
            outstanding: "Outstanding",
            status: "Status",
            status_unpaid: "Unpaid",
            status_partial: "Partial",
            status_paid: "Paid",
            status_cancelled: "Cancelled",
            pdf: "Invoice PDF",
            cancel: "Cancel Invoice",
            cancel_confirm: "Confirm cancel this invoice? The number will not be reused.",
            issue: "Issue Invoice",
            date_from: "From",
            date_to: "To",
            created: "Invoice created successfully",
            cancelled: "Invoice cancelled",
            // #303: this invoice's sale order is already closed — no more edits
            so_closed_hint: "This invoice's sale order is closed — it can no longer be cancelled or have its payments edited.",
            // round-19 §2 — issue invoice from payment history + cancel with reason
            issue_confirm: "Issue a tax invoice for the un-invoiced payments of {amount}?",
            issued: "Invoice issued successfully",
            cancel_hint: "An invoice can be cancelled even after payments — the payments are unlinked back to the un-invoiced pool (history is never deleted).",
            cancel_reason_placeholder: "Cancellation reason (optional)",
            cancel_reason: "Cancellation reason",
            cancel_no_so_warning: "This is a consignment invoice not linked to any sale order — its payments will be unlinked but will NOT return to any sale order's un-invoiced pool (payment history is never deleted).",
            // spec 2026-11-03 §3 — invoice before payment
            source_payment: "From payments",
            delivery_invoice_col: "Tax invoice",
            issue_from_delivery: "Issue tax invoice",
            from_delivery_confirm: "Issue a tax invoice for delivery note {doc_no}?",
            from_delivery_confirm_hint: "The invoice carries the items and quantities of this delivery note at the sale-order prices. Payments already received and not yet linked are linked to it automatically (oldest first, up to the invoice amount).",
            from_delivery_issued: "Tax invoice {doc_no}, net {net} THB — {linked} THB of payments already received was linked",
            tab_consignment_unbilled: "Unbilled consignment sales",
            range_hint: "Pick the partner company and the sale-date range, preview, then press \"Issue\". Each sale line can be invoiced only once; cancelling the invoice makes its sales billable again.",
            range_from: "Sale date from",
            range_to: "Sale date to",
            range_preview: "Preview",
            range_issue: "Issue",
            range_need_params: "Select the partner company and both sale dates",
            range_bad_dates: "The start date must not be after the end date",
            range_empty: "No unbilled consignment sales in this range",
            range_col_product: "Product (barcode – name)",
            range_col_qty: "Qty",
            range_col_unit_price: "Unit price",
            range_col_amount: "Amount",
            range_unpriced_title: "{count} product(s) have no price — map the products / set prices before issuing",
            range_issue_confirm: "Issue a tax invoice for {company}, sale dates {from} to {to}, net {amount} THB?",
            range_issued: "Tax invoice {doc_no}, net {amount} THB",
            err_delivery_already_invoiced: "This delivery note already has a tax invoice",
            err_has_source3_invoice: "This sale order already has an invoice issued from payments — keep using that flow; invoicing per delivery note is not available",
            err_nothing_to_bill: "There are no unbilled sales left in this date range",
            err_unpriced_sales: "Some products in this range have no price — map the products / set prices before issuing",
            err_not_outright: "Invoicing per delivery note is only for outright sale orders",
            err_use_delivery_invoice: "Issue outright invoices from the button in the delivery-note table instead",
            err_use_sales_range_invoice: "Consignment invoices are now issued by sale-date range on the Tax Invoices page",
            err_invoice_exists: "This sale order already has a tax invoice issued another way — it cannot be invoiced from a delivery",
            err_discount_exceeds_subtotal: "The sale order discount is larger than this delivery's total — cannot issue the invoice",
            err_delivery_cancelled: "This delivery note has been cancelled",
            err_sale_order_closed: "This sale order is closed — this action is not allowed",
            err_payment_state_changed: "A payment was just changed by someone else — the data has been reloaded, please try again",
            err_preview_stale: "Totals changed since the preview — please review the new preview before issuing",
        },
        payment: {
            title: "Payments",
            record: "Record Payment",
            after_delivery_hint: "Payments can be recorded after delivery — recorded as payment history; issue the tax invoice later",
            closed_no_more: "This sale order is closed — no further payments can be recorded.",
            // spec 2026-08-13: the destination is now the "Consignment Payments" page
            // (money is tied to the partner company, not to an invoice or sale order)
            // and the tax invoice is issued from the selected payments on that page
            consignment_hint: "Consignment: issue tax invoices by sale-date range on the Tax Invoices page, then record and link payments on the \"Consignment Payments\" page.",
            consignment_link: "Go to consignment payments",
            auto_invoice_hint: "Recording a payment auto-creates the tax invoice for the full delivered amount",
            history_hint: "Recorded as payment history first — when ready, click \"Issue Invoice\" to raise a tax invoice from the received amount.",
            slip: "Slip",
            slip_choose: "Attach Slip",
            slip_view: "View Slip",
            slip_hint: "Accepts JPG / PNG / WEBP / PDF up to 10MB",
            slip_bad_type: "Unsupported file type — must be JPG / PNG / WEBP or PDF",
            slip_too_big: "File exceeds 10MB",
            slip_upload_failed: "Slip upload failed",
            amount: "Amount",
            paid_date: "Paid Date",
            method: "Method",
            method_cash: "Cash",
            method_transfer: "Transfer",
            method_cheque: "Cheque",
            method_other: "Other",
            note: "Note",
            history: "Payment History",
            delete: "Delete Payment",
            delete_confirm: "Confirm delete this payment?",
            amount_required: "Please enter the amount",
            amount_positive: "Amount must be greater than 0",
            date_required: "Please select the paid date",
            over_net: "Total payments exceed the invoice net amount",
            outstanding: "Outstanding",
            exceeds_outstanding: "Amount exceeds the outstanding balance (max {amount})",
            recorded: "Payment recorded successfully",
            deleted: "Payment deleted successfully",
        },
        // spec 2026-08-13 (afternoon) — consignment: payments are tied to the partner
        // company and the tax invoice is issued for the money actually received
        consignment_payment: {
            title: "Consignment Payments",
            subtitle: "Partners pay the invoices sent to them — record each payment against the company, then link it to a tax invoice.",
            company: "Partner Company",
            all_companies: "All companies",
            date_from: "Paid From",
            date_to: "To",
            link_status: "Invoice Link Status",
            status_all: "All",
            status_unlinked: "Awaiting invoice",
            status_linked: "Linked to invoice",
            total_received: "Total Received",
            unlinked_amount: "Awaiting Invoice (pool)",
            unbilled_sales_amount: "Sales Available to Invoice",
            unbilled_hint: "Actual sales not yet invoiced, VAT included so it compares directly with the money received — it caps invoicing, not the recording of payments",
            last_paid_date: "Last payment",
            summary_all_hint: "All companies with activity",
            record: "Record Payment",
            record_title: "Record Consignment Payment",
            paid_date: "Paid Date",
            amount: "Amount",
            method: "Method",
            note: "Note",
            slip: "Slip",
            invoice: "Linked Invoice",
            pending_invoice: "Awaiting invoice",
            created_by: "Recorded By",
            no_cap_hint: "Record whatever the partner actually transferred — there is no cap.",
            no_data: "No data",
            company_required: "Please select a partner company",
            amount_required: "Please enter an amount greater than 0",
            date_required: "Please select the paid date",
            recorded: "Payment recorded successfully",
            link: "Link Invoice",
            link_title: "Link Payment to a Tax Invoice",
            link_hint: "Pick a consignment invoice of the same company that is not cancelled and not fully paid, then enter the amount to link (partial links are allowed).",
            link_amount: "Amount to link",
            link_none: "This company has no consignment invoice with an outstanding balance.",
            linked: "Payment linked successfully",
            unlink: "Unlink",
            unlink_confirm: "Unlink this payment from its invoice? The money returns to the company's awaiting-invoice pool.",
            unlinked: "Payment unlinked successfully",
            invoice_remaining: "Remaining",
            invoice_select_required: "Please select a tax invoice",
            delete_confirm: "Confirm delete this payment?",
            deleted: "Payment deleted successfully",
            exceeds: "Cannot link — the total linked amount would exceed the invoice net amount.",
            wrong_type: "This payment is not a consignment payment, so it cannot be linked or unlinked here.",
            // ── Issue a tax invoice from the selected payments (money-driven) ──────
            issue_selected: "Issue tax invoice from selection",
            selected_count: "{count} selected",
            selected_amount: "Selected total",
            selectable_sales: "Sales available to invoice",
            issue_hint: "Tick the payments of one company that are not linked to an invoice yet, then issue — the invoice is raised for exactly the selected amount.",
            issue_ready: "Line items are taken from actual sales not yet invoiced, oldest first.",
            issue_cross_company: "Payments from different companies cannot be combined — one invoice covers one company. Select payments of a single company.",
            issue_need_selection: "Select at least one payment.",
            issue_over_sales: "The selected total is higher than the sales available to invoice ({amount}) — reduce the selection, otherwise the invoice will be refused.",
            issue_confirm_title: "Issue a tax invoice from the selection?",
            issue_confirm: "Issue a tax invoice for {company} of {amount} THB from {count} payment(s) — line items are taken from actual sales not yet invoiced, oldest first.",
            issued_title: "Tax invoice issued",
            issued: "Invoice {doc_no}, net amount {amount} THB — the selected payments are now linked to it.",
            insufficient_sales_title: "Not enough sales to invoice",
            insufficient_sales: "The sales available to invoice do not cover the selected amount. Reduce the selection and try again.",
            max_issuable: "Maximum issuable amount: {amount} THB.",
            no_sales_yet: "This partner has no billable sales yet — record or import its sales data first.",
            over_invoiced: "All of this partner's sales have already been invoiced (sales {sales} THB / invoiced {invoiced} THB) — if prices were edited retroactively, review or cancel the invoices already issued.",
            skipped_unpriced_note: "{count} product(s) are not mapped to an MT product or have no price, so their sales are not counted: {products}",
            skipped_unpriced_badge: "{count} unpriced",
            skipped_unpriced_card_hint: "{count} product(s) are not mapped to an MT product or have no price, so this figure is lower than the partner's real sales.",
            unpriced_blocked_title: "Price these products before issuing",
            unpriced_blocked: "This partner has sales of products that are not mapped to an MT product or have no price, and it already has issued invoices — map/price those products first, then issue the tax invoice.",
            payment_not_eligible: "The selected payments cannot be invoiced — some are already linked to an invoice, belong to another company, or are not consignment payments. Select again.",
            reason_already_linked: "already linked to an invoice",
            reason_wrong_company: "belongs to another company",
            reason_wrong_payment_type: "belongs to a sale order (outright sale)",
            reason_no_company: "no partner company set",
            reason_not_found: "payment not found",
            reason_bad_amount: "invalid amount",
            no_company: "(no company)",
            no_company_short: "No company — cannot link",
            state_changed: "This payment was just changed by someone else — refresh and try again.",
            no_company_hint: "Legacy payment with no partner company — it cannot be invoiced or linked until the data is repaired.",
            // spec 2026-11-03 §3B — invoice by sale-date range + partial link
            range_moved_hint: "Consignment tax invoices are issued by sale-date range on the Tax Invoices page; come back here to link payments to them (row menu → Link invoice).",
            range_moved_link: "Issue by sale-date range",
            link_amount_input: "Amount to link",
            link_amount_hint: "Defaults to the smaller of this payment and the invoice outstanding — the unlinked part ({remainder} THB) is split off as a new payment still waiting to be linked",
            link_amount_required: "Enter an amount to link greater than 0",
            link_amount_over_payment: "The amount to link exceeds this payment",
            link_amount_over_outstanding: "The amount to link exceeds the invoice outstanding",
            record_invoice: "Link to tax invoice (optional)",
            record_invoice_none: "Don't link — keep it in the unlinked pool",
            record_invoice_hint: "{linked} THB is linked to this invoice right after saving; the rest ({remainder} THB) waits in the unlinked pool",
            record_link_failed: "Payment recorded, but linking it to the invoice failed — link it again from the row menu",
        },
        report_sales: {
            title: "Sales Report",
            date_from: "From",
            date_to: "To",
            company: "Company",
            group_by: "Group By",
            group_by_company: "By Company",
            group_by_product: "By Product",
            group_by_invoice: "By Invoice",
            overall: "Overall",
            sub_total: "Before VAT",
            vat_amount: "VAT",
            net_amount: "Net",
            paid_amount: "Received",
            outstanding: "Outstanding",
            invoice_count: "Invoices",
            export_xlsx: "Export Excel",
            no_data: "No data",
        },
        report_stock_value: {
            title: "Stock Value Report",
            company: "Company",
            product: "Product",
            lot_no: "Lot No.",
            expired_date: "Expiry Date",
            qty: "Qty",
            unit_price: "Unit Price",
            value: "Value",
            total_value: "Total Value",
            no_price: "No price",
            drill_down: "Product breakdown",
            export_xlsx: "Export Excel",
            no_data: "No data",
        },
        // #166 — Document format settings (production/delivery/invoice)
        doc_format: {
            title: "Document Format Settings",
            subtitle: "Customize the printed PDF layout (A4 paper)",
            doc_type: "Document type",
            doc_type_production: "Production Order",
            doc_type_delivery: "Delivery Note",
            doc_type_invoice: "Tax Invoice",
            section_appearance: "Appearance",
            header_color: "Table header color",
            show_logo: "Show logo",
            show_stamp: "Show stamp / signature",
            section_header_fields: "Header fields",
            section_columns: "Product table columns",
            section_summary: "Summary rows",
            show_summary: "Show summary rows",
            section_footer: "Footer",
            footer_note: "Footer note",
            sign_left_label: "Left signature label",
            sign_right_label: "Right signature label",
            col_show: "Show",
            col_label: "Display label",
            field: "Field",
            column: "Column",
            reset: "Reset to default",
            save: "Save",
            saved: "Document format saved",
            load_error: "Failed to load settings",
            save_error: "Failed to save",
            f_doc_no: "Document No.",
            f_doc_date: "Document date",
            f_date: "Document date",
            f_do_no: "Delivery No.",
            f_credit_term: "Credit term",
            f_seller: "Seller",
            f_customer: "Customer",
            f_tax_id: "Tax ID",
            f_branch: "Branch",
            f_po_no: "PO No.",
            f_po_ref: "PO reference No.",
            f_po_number: "PO No.",
            f_ship_method: "Shipping method",
            f_tracking: "Tracking No.",
            f_due_date: "Due date",
            c_no: "No.",
            c_code: "Code",
            c_barcode: "Barcode",
            c_name: "Product name",
            c_size: "Size",
            c_unit: "Unit",
            c_lot: "Lot No",
            c_exp: "Expiry date",
            c_qty: "Qty",
            c_unit_price: "Unit price",
            c_discount: "Discount",
            c_amount: "Amount",
            // #304 — invoice: product code is no longer its own column
            c_code_invoice: "Show product code before the item name",
            c_code_invoice_hint: "No display label — untick to print the item name without the code prefix",
            invoice_merged_hint: "The tax invoice merges \"Code\" and \"Product name\" into a single column (e.g. P-075 - Product name). Rename it on the \"Product name\" row.",
            s_subtotal: "Subtotal",
            s_discount: "Discount",
            s_vat: "VAT",
            s_grand_total: "Grand total",
        },
        // #183 — full-screen print preview page (SO/MO/DO/IV, original/copy + copies count)
        print_preview: {
            title: "Document Preview",
            close_window: "Close window",
            print: "Print",
            download: "Download",
            original: "Original",
            copy: "Copy",
            copies: "Copies",
            document: "Document",
            loading: "Loading...",
            no_docs: "Please select a document to print",
            // Shown when the requested document does not exist yet on this sale order.
            doc_not_available: "This sale order has no {doc} yet — showing {fallback} instead",
            doc_so: "Sale Order",
            doc_invoice: "Tax Invoice",
            doc_delivery: "Delivery Note",
            doc_production: "Production Order",
        },
        // round-19 Dev-B — delivery ship status (pack room)
        delivery: {
            // #504/#505 — create a packing-room order from a delivery note.
            // Issuing a DO cuts no stock; stock is reserved only by this button.
            bo_order: {
                column: "Packing Order",
                create_action: "Create packing order",
                view_action: "View order #{id}",
                dialog_title: "Create packing order",
                loading: "Checking...",
                recipient: "Recipient",
                recipient_phone: "Phone",
                recipient_empty: "(no recipient data)",
                shipping_provider: "Carrier",
                shipping_provider_placeholder: "Select a carrier",
                shipping_provider_required: "Please select a carrier first",
                shipping_provider_locked: "Drop-ship sale order — this carrier is enforced",
                lines_title: "Items to be reserved from stock",
                lines_note: "These quantities come from the server, not from this screen — they are what will actually be held",
                col_product: "WMS product",
                col_barcode: "Barcode",
                col_qty: "Qty",
                col_mt_codes: "MT codes",
                no_lines: "No items to reserve",
                // #240 — the lines whose LOT / expiry is incomplete (from the BE's missing_lots)
                missing_lots_title: "Lines to fix before the order can be created",
                missing_lots_count: "{count} line(s)",
                col_line: "Line",
                col_product: "Product",
                col_lot: "LOT",
                col_problem: "What to fix",
                lot_empty: "(no LOT yet)",
                problem_missing_lot: "No LOT",
                problem_missing_expire: "No expiry date",
                fix_missing_lot: "Fix this line on the delivery note — a lot must be picked first",
                fix_missing_expire: "Fix the received lot — fill in the expiry date of this LOT",
                confirm_warning: "Once confirmed, these quantities are held out of the stock published to the platforms immediately",
                confirm_action: "Confirm and create order",
                created: "Packing order created",
                created_detail: "Order #{id} · {status}",
                tracking_pending: "Requesting tracking number",
                status_111: "Awaiting shipping round",
                manual_ship_warning: "The system does NOT cut stock for you — cut it in WMS yourself",
                manual_ship_hint: "A delivery note with no packing order never cuts stock: staff must cut it in WMS by hand",
                locked_by_order: "This delivery ships through order #{id} — the tracking number and ship status belong to the order",
                reason: {
                    ok: "Ready to create",
                    already_created: "This delivery already has an order",
                    stock_already_cut: "The previous order already cut stock — cannot create another",
                    shipped_manually: "This delivery is already marked as shipped",
                    missing_wms_mapping: "Some products are not mapped to a WMS product",
                    missing_lot_expire: "Some lines have no LOT or expiry date",
                    not_applicable: "This delivery is not eligible for a packing order",
                    setting_missing: "Modern Trade sale channel / payment method is not configured",
                    legacy_bo_order: "This sale order is already linked to a legacy order",
                    unknown: "Cannot create the order",
                },
            },
            ship_status: {
                label: "Ship Status",
                pending: "Pending",
                shipped: "Shipped",
                edit_action: "Edit Status / Tracking",
                dialog_title: "Update Ship Status / Tracking",
                tracking_number: "Tracking No.",
                tracking_placeholder: "Enter tracking number (optional)",
                shipped_by: "Marked by",
                shipped_at: "Shipped at",
                saved: "Ship status updated",
                confirm_shipped: "Confirm this delivery has been shipped?",
            },
        },
        // round-19 Dev-B — Audit Log
        audit: {
            title: "Audit Log",
            menu: "Audit Log",
            filter_entity_type: "Entity Type",
            filter_action: "Action",
            filter_actor: "Actor (ID)",
            filter_doc_no: "Document No.",
            date_from: "From",
            date_to: "To",
            search: "Search",
            reset: "Reset",
            all: "All",
            col_time: "Time",
            col_actor: "Actor",
            col_action: "Action",
            col_entity: "Entity",
            col_doc_no: "Document No.",
            col_detail: "Detail",
            view_detail: "View Detail",
            diff_title: "Change Detail",
            diff_field: "Field",
            diff_old: "Old",
            diff_new: "New",
            no_change: "No field changes",
            created_label: "Created",
            deleted_label: "Deleted/Cancelled",
            no_data: "No records found",
            empty_value: "(empty)",
            entity_sale_order: "Sale Order",
            entity_invoice: "Tax Invoice",
            entity_payment: "Payment",
            entity_delivery: "Delivery Note",
            entity_product: "Product",
            entity_price_template: "Price Template",
            entity_company: "Partner Company",
            entity_setting: "Setting",
            action_so_create: "Create sale order",
            action_so_update: "Edit sale order",
            action_so_confirm: "Confirm sale order",
            action_so_cancel: "Cancel sale order",
            action_so_close: "Close sale order",
            action_delivery_create: "Create delivery note",
            action_delivery_ship_status: "Change ship status",
            action_invoice_create: "Issue tax invoice",
            action_invoice_cancel: "Cancel tax invoice",
            action_payment_create: "Record payment",
            action_payment_link: "Link payment to invoice",
            action_payment_unlink: "Unlink payment from invoice",
            action_payment_delete: "Delete payment",
            action_product_create: "Create product",
            action_product_update: "Edit product",
            action_product_delete: "Delete product",
            action_product_import: "Import products",
            action_price_template_update: "Edit price template",
            action_price_template_items: "Edit template prices",
            action_company_update: "Edit partner company",
            action_setting_update: "Edit setting",
        },
    },
    // Round-3 shared MT components (PdfFullscreenModal / CustomerDetailModal / ProductDetailPopup)
    mt_shared: {
        pdf_title: "PDF Document",
        download: "Download",
        close: "Close",
        loading: "Loading...",
        pdf_error: "Unable to load PDF file",
        no_pdf: "No PDF file",
        no_data: "No data",
        yes: "Yes",
        no: "No",
        days: "days",
        customer_detail: "Customer Detail",
        product_detail: "Product Detail",
        name: "Name",
        tax_id: "Tax ID",
        branch_code: "Branch Code",
        address: "Address",
        contact_name: "Contact",
        contact_phone: "Phone",
        contact_email: "Email",
        credit_term_days: "Credit Term",
        gp_percent: "GP (%)",
        vat_included: "VAT Included",
        product_name: "Product Name",
        wms_name: "WMS Name",
        sku_code: "SKU",
        barcode: "Barcode",
        wms_not_linked: "Not linked to WMS",
    },
    // #169 — BO admin promo notification composer
    promo_notification: {
        title: "Promo Notifications",
        compose: "Compose Notification",
        compose_hint: "Broadcast to all members",
        field_title: "Title",
        field_icon: "Icon",
        field_body: "Details",
        field_image: "Image",
        field_link_type: "Link to",
        field_link_ref: "Link reference",
        url_placeholder: "Paste URL or upload",
        link_none: "None",
        link_product: "Product",
        link_coupon: "Coupon",
        link_ref_product: "Product ID",
        link_ref_coupon: "Coupon code",
        audience_all: "Audience: all members",
        send: "Send",
        sent_ok: "Notification sent",
        sent_list: "Sent history",
        col_title: "Title",
        col_link: "Link",
        col_recipients: "Recipients",
        col_sent_at: "Sent at",
        confirm_title: "Confirm send",
        confirm_body: "Send this notification to all members?",
        err_title_required: "Please enter a title",
        err_link_ref_required: "Please enter a link reference",
    },
    // shopee_to_seller — #260 "send to seller" on /admin/product_platform
    // (spec docs/specs/2026-09-22-shopee-master-product-sync-design.md §6A)
    // amaze_push — #263 "sync to platform" + the platform category mapping page
    amaze_push: {
        btn_open: "Sync to Platform",
        title: "Sync product to Platform",
        product: "Product",
        platform_label: "Destination",
        btn_check: "Check",
        btn_confirm: "Confirm sync",
        btn_retry: "Try again",
        go_category_map: "Go to platform category mapping",
        summary_name: "Name to send",
        summary_action: "Action",
        summary_images: "Images",
        summary_models: "Variants",
        summary_category: "Destination category",
        summary_brand: "Brand",
        summary_parcel: "Parcel size · weight",
        sku_table: "SKUs",
        col_sku_code: "SKU code",
        col_sent_code: "Code actually sent",
        col_action: "Send/skip",
        col_reason: "Reason",
        warnings_title: "Warnings",
        warnings_dry_run: "from the check — nothing was sent yet",
        rejected_title: "Cannot be sent — fix these first",
        // A 200 with rejects still pushes; these SKUs are left out (§6B.3 rule 7).
        skipped_title: "SKUs that will be skipped",
        job_title: "Sync job",
        platform_product_id: "Product id on the platform",
        badge_column: "Amaze status",
        badge_synced: "Synced to Amaze",
        badge_edited_since_sync: "Edited since last sync",
        action: {
            create: "Create new",
            update: "Update existing"
        },
        platform: {
            amaze: "Amaze",
            makro: "Makro (Mirakl)",
            shopee: "Shopee",
            disabled_phase4: "Not supported yet (Phase 4)",
            disabled_source_only: "A product source, not a destination",
            disabled_unknown: "Not supported yet"
        },
        state: {
            none: "Never synced",
            pushing: "Sending…",
            reviewing: "Sent, waiting for the platform's review",
            live: "Live on the platform",
            rejected: "The platform rejected this product",
            failed: "Sync failed",
            unknown: "Unrecognised state"
        },
        step: {
            queued: "Queued",
            images: "Upload images",
            create: "Create product",
            link: "Link SKU codes",
            poll: "Wait for review",
            unknown: "Unrecognised step"
        },
        sku_action: {
            send: "Send",
            skip: "Skip",
            unknown: "Unknown"
        },
        reject: {
            sku_code_too_long_for_platform: "The SKU code is longer than the platform accepts (over 100 characters)",
            sku_code_invalid_chars: "The SKU code contains characters that cannot be sent (newline, control character or leading/trailing space)",
            category_not_mapped: "This product's category is not mapped to a platform category yet",
            missing_required_attribute: "A mandatory platform attribute of this category has no value",
            no_active_sku: "No sendable SKU is left",
            unknown: "Rejected for a reason this screen does not recognise"
        },
        warning: {
            image_not_uploaded: "An image could not be uploaded to the platform and was left out",
            sku_skipped: "An inactive SKU was left out",
            attribute_defaulted: "An attribute fell back to the category default",
            unknown: "Unrecognised warning"
        },
        error: {
            in_flight: "A sync job for this product is already running — reattaching to it",
            rejected: "Cannot be sent to the platform",
            payload_not_buildable: "The payload could not be built — fix the product data first",
            category_not_mapped: "This product's category is not mapped to a platform category yet",
            platform_not_supported: "Pushing to this platform is not supported yet",
            bad_request: "The request was not valid",
            amaze_disabled: "The Amaze integration is switched off (platform.amaze.enabled = false)",
            amaze_not_configured: "No Amaze username/password is configured",
            amaze_env_unset: "Amaze env is not set to prod (uat is unusable — the UAT host is down)",
            amaze_shop_unresolved:
                "The Amaze shop for this push cannot be determined — set platform.amaze.shop_id, or press Test connection once so the shop identity is cached",
            unavailable: "Amaze cannot be reached right now",
            upstream: "The platform returned an error; nothing was sent",
            generic: "Sync to platform failed"
        },
        map: {
            hint: "Map each store category to a platform category once; every sync then reuses these defaults.",
            auto_approve_warning: "This shop has auto approve on — pushed products go on sale immediately, without review.",
            col_seller_category: "Store category",
            col_platform_category: "Platform category",
            col_updated_at: "Last updated",
            unmapped: "Not mapped",
            editor_title: "Map category",
            platform_category: "Platform category",
            category_hint: "Pick down to the last sub-category — the leaf is used as category_group_id automatically.",
            category_required: "Pick a platform category before saving",
            brand: "Brand",
            warehouse: "Warehouse address",
            warehouse_name: "Warehouse name on the platform",
            shipping: "Shipping method",
            attributes: "Mandatory attributes",
            payment_configs: "Payment channels",
            payment_configs_hint: "The platform has no API that lists payment channels; this value must be copied from an existing product per runbook §6B.6.",
            weight: "Weight (g)",
            parcel_width: "Width (cm)",
            parcel_length: "Length (cm)",
            parcel_height: "Height (cm)",
            btn_save: "Save mapping",
            saved: "Category mapping saved",
            error: {
                path_mismatch: "The category path does not end with the chosen leaf — pick the category again",
                platform_not_supported: "Category mapping is not supported for this platform yet",
                bad_request: "The request was not valid",
                generic: "Saving the category mapping failed"
            }
        }
    },
    shopee_to_seller: {
        btn_send: "Send to seller",
        title: "Send Shopee product to seller",
        item_id: "Shopee item id",
        shop_id: "Shop id",
        model_id: "model_id",
        category: "Seller category",
        category_hint: "Category used when the seller product is created (chosen once — later syncs keep it).",
        category_required_hint: "Pick a category to enable the confirm button.",
        update_category_kept: "This item is already in the seller catalogue; re-syncing keeps its current category.",
        btn_check: "Check",
        btn_confirm: "Confirm send to seller",
        preview_name: "Product name",
        image_count: "Images",
        description_image_count: "Description images",
        option_groups: "Options",
        sku_table: "SKUs",
        col_sku_code: "SKU code",
        col_sku_name: "SKU name",
        col_price: "Price",
        col_action: "Action",
        warnings_title: "Warnings",
        warnings_dry_run: "from the check — nothing has been saved yet",
        rejected_title: "Cannot be sent to seller — fix it on Shopee first",
        success: "Sent to seller successfully",
        open_in_catalog: "Open in product management",
        badge_linked: "In seller",
        disabled_not_shopee: "Available for Shopee products only",
        disabled_item_status: "This Shopee listing status cannot be sent (must be NORMAL or UNLIST)",
        disabled_no_item_id: "No Shopee item id on this row",
        sku_action: {
            create: "Create",
            update: "Update",
            deactivate: "Deactivate",
            reactivate: "Reactivate",
            unknown: "Unknown"
        },
        reject: {
            model_sku_empty: "This variation has no SKU code (model_sku) on Shopee",
            sku_code_too_long: "The SKU code is longer than the seller catalogue allows",
            item_status_not_allowed: "This Shopee listing status cannot be sent (must be NORMAL or UNLIST)",
            no_price: "This variation has no price",
            model_list_empty: "This item says it has variations, but Shopee returned no model list",
            unknown: "Rejected for a reason this screen does not recognise yet"
        },
        error: {
            category_required: "Pick a seller category before creating the product",
            cover_image_failed: "The cover image could not be imported, so nothing was saved. Please try again.",
            upstream: "Shopee could not be read, so nothing was saved. Please try again.",
            rejected: "Cannot be sent to seller",
            bad_request: "The request was not valid",
            generic: "Sending to seller failed"
        }
    },
    // shopee_bulk_sync — #280 "sync the whole shop into seller" on
    // /admin/product_platform (spec §6C.6). Runs as a background job: start -> poll ->
    // per-item results.
    shopee_bulk_sync: {
        btn_toolbar: "Sync whole shop to seller",
        btn_toolbar_disabled: "Available once a Shopee shop is selected",
        title: "Sync the whole Shopee shop into seller",
        shop: "Shop",
        // #284: two names, two sources — shop_name is what Shopee calls this shop
        // (GET .../shops/:id/info), seller_name is what the Backoffice calls it
        // (bo_seller.seller_name). Both are shown so the operator can see they
        // agree before starting a whole-shop sync.
        shop_name: "Shop name on Shopee",
        seller_name: "Shop name in Backoffice",
        shop_id: "Shop id",
        open_in_shopee: "Open this listing in Shopee Seller Centre",
        settings_title: "1. Settings",
        category: "Seller category for new products",
        category_hint:
            "Used only for items that do not exist in seller yet; existing products keep the category they already have.",
        category_required_hint: "Pick a category to enable the real run (the check does not need one).",
        item_status_label: "Shopee listing statuses to read",
        item_status_hint:
            "NORMAL only by default; tick UNLIST yourself to include hidden listings. Other statuses are skipped anyway (they cannot be sent to seller).",
        item_status_required_hint: "Pick at least one status.",
        only_unlinked: "Skip items already in seller",
        only_unlinked_hint:
            "On = only items missing from seller (faster, no extra Shopee calls). Off = refresh every item from Shopee.",
        btn_dry_run: "Check whole shop",
        btn_real: "Start real sync",
        btn_dry_run_hint: "Check only — nothing is written to seller.",
        confirm_title: "Start the real sync for the whole shop?",
        confirm_text:
            "Seller products will be created and updated from Shopee for the whole shop. This takes a while and can be cancelled midway.",
        confirm_ok: "Start real sync",
        confirm_cancel: "Cancel",
        progress_title: "2. Progress",
        job_label: "Job",
        mode_dry_run: "Check (nothing saved)",
        mode_real: "Real sync",
        listing_hint: "Counting the shop's items…",
        queued_hint: "Queued, waiting to start…",
        processed_of: "{processed} of {total} items done",
        total: "Total",
        processed: "Done",
        created_count: "Created",
        updated_count: "Updated",
        attached_existing: "A job for this shop is already running — showing its progress.",
        btn_cancel_job: "Cancel job",
        cancel_confirm_title: "Cancel the sync job?",
        cancel_confirm_text: "Items already processed stay as they are; the rest will not be processed.",
        cancel_requested: "Cancellation requested — stopping after the current item…",
        results_title: "3. Results",
        tab_all: "All",
        tab_ok: "Succeeded",
        tab_rejected: "Rejected",
        tab_failed: "Failed",
        tab_skipped: "Skipped",
        col_item_id: "Shopee item id",
        // #642: the listing's name as Shopee has it (from the raw store's
        // item_base_info). Empty for an item that was skipped and therefore
        // never fetched.
        col_item_name: "Name on Shopee",
        col_status: "Status",
        col_action: "Action",
        col_product: "Seller product",
        col_reason: "Reason",
        // #286: download the whole job as a 3-sheet .xlsx (summary / items /
        // SKUs to fix on Shopee). export_excel_short is the one-word link in
        // the "Recent jobs" table, which has no room for the full label.
        export_excel: "Export Excel",
        export_excel_short: "Excel",
        export_failed: "Exporting the file failed",
        open_in_catalog: "Open in product management",
        empty_items: "No items in this group",
        sku_summary: "SKUs created {create} · updated {update}",
        btn_recent: "Recent jobs",
        recent_title: "Recent sync jobs for this shop",
        recent_empty: "No sync job for this shop yet",
        recent_open: "View",
        col_created_at: "Started",
        col_mode: "Mode",
        col_result: "Result",
        last_error: "Job error",
        finished_done: "The sync job finished",
        finished_failed: "The sync job failed",
        finished_cancelled: "The sync job was cancelled",
        job_status: {
            queued: "Queued",
            listing: "Counting items",
            running: "Running",
            done: "Done",
            failed: "Failed",
            cancelled: "Cancelled",
            unknown: "Unknown status"
        },
        item_status: {
            pending: "Not processed",
            ok: "Succeeded",
            rejected: "Rejected",
            failed: "Failed",
            skipped: "Skipped",
            unknown: "Unknown status"
        },
        action: {
            create: "Create",
            update: "Update",
            none: "-",
            unknown: "Unknown"
        },
        reason: {
            item_status_not_allowed: "This Shopee listing status cannot be sent (must be NORMAL or UNLIST)",
            already_linked: "Already in seller, and the run was set to skip linked items",
            fetch_failed: "Reading this item from Shopee failed",
            cover_image_failed: "The cover image could not be imported, so this item was not saved",
            category_required: "No seller category was available to create the product",
            save_failed: "Saving into seller failed",
            unknown: "A reason this screen does not recognise yet"
        },
        error: {
            shop_required: "Select a Shopee shop first",
            category_required: "Pick a seller category before starting the real sync",
            bad_item_status: "One of the selected listing statuses is not valid",
            bad_request: "The request was not valid",
            already_finished: "This job has already finished and cannot be cancelled",
            not_found: "This sync job was not found",
            poll_failed: "Reading the progress failed; the job keeps running in the background — reopen \"Recent jobs\" to see the result.",
            generic: "Starting the sync job failed"
        }
    },
    // shopee_category_map — #282 "Shopee -> seller category map" (spec §6D.6).
    // New products take their category from Shopee automatically; this page is
    // where that guess is corrected.
    shopee_category_map: {
        menu: "Shopee category mapping",
        title: "Map Shopee categories to seller categories",
        hint:
            "New products synced from Shopee take their category from this table. An unmapped Shopee category creates a seller category with the same name.",
        retroactive_hint: "Changes here apply to the NEXT sync only — products already synced are not moved.",
        shop: "Shopee shop",
        shop_placeholder: "Select a Shopee shop",
        no_shop: "No Shopee shop is connected yet",
        fetched_at: "Shopee category names last read",
        fetched_at_never: "never",
        col_shopee_category: "Shopee category",
        col_product_count: "Products in shop",
        col_seller_category: "Seller category",
        col_source: "Source",
        auto_option: "Create automatically",
        auto_placeholder: "Follow the Shopee category (automatic)",
        btn_save: "Save",
        btn_refresh: "Refresh names from Shopee",
        saved: "Category mapping saved",
        saved_text: "{count} categories changed. Products already synced are not moved.",
        refreshed: "Category names refreshed from Shopee",
        refreshed_text: "{count} categories read",
        no_changes: "Nothing has been changed yet",
        empty: "No category for this shop yet — refresh the names from Shopee, or sync some products first",
        modal_hint: "Optional — leave it empty and the Shopee category is used automatically.",
        modal_link: "Shopee category mapping",
        would_create: "A new category will be created",
        preview_category: "Seller category to be used",
        col_category: "Seller category",
        source: {
            auto: "Automatic",
            manual: "Set by hand",
            none: "Not mapped"
        },
        resolution: {
            override: "Chosen by hand",
            map: "From the mapping",
            existing_name: "Reused an existing category with the same name",
            auto_new: "A new category was created from Shopee",
            unknown_name: "The Shopee category name was not found; a placeholder name was used",
            unchanged: "Kept its existing category (update does not move it)",
            unknown: "The category source is unknown"
        },
        error: {
            shop_required: "Select a Shopee shop first",
            bad_category: "One of the chosen seller categories no longer exists. Please reload this page.",
            upstream: "Reading the categories from Shopee failed. Please try again.",
            generic: "The request failed"
        }
    },
    // shopee_promotion — B7 "Shopee promotions -> seller" (spec
    // 2026-10-02-shopee-promotions-to-seller-design §6).
    // The shop's Shopee Discounts and Shop Flash Sales are mirrored into the
    // app's per-SKU flash window at the same price. One direction only: the
    // promotion itself is edited on Shopee.
    shopee_promotion: {
        menu_title: "Shopee promotions",
        page_title: "Promotions from Shopee",
        hint:
            "Discounts and Flash Sales set up on Shopee are mirrored into the app as a per-SKU flash price at the same price. They can only be edited in Shopee Seller Centre.",
        shop: "Shopee shop",
        shop_placeholder: "Select a Shopee shop",
        shop_on_shopee: "Shop name on Shopee",
        no_shop: "No Shopee shop is connected yet",
        fetched_at: "Read from Shopee at",
        fetched_at_never: "never",
        last_run: "Last run",
        last_run_never: "never run",
        last_run_line: "{at} · {promotions} promotions applied · {set} SKUs priced · {cleared} cleared",
        link_at: "at {at}",
        col_type: "Type",
        col_name: "Promotion",
        col_window: "Window",
        col_status: "Status on Shopee",
        col_item_count: "Products",
        col_app_state: "State in the app",
        type_discount: "Discount",
        type_flash_sale: "Flash Sale",
        type_unknown: "Unknown type",
        status_upcoming: "Not started",
        status_ongoing: "Running",
        status_expired: "Expired",
        status_unsupported: "Not supported",
        status_unknown: "Unknown status",
        app_state_synced: "{count} SKUs synced",
        app_state_ended: "Ended",
        app_state_skipped: "Skipped",
        app_state_failed: "Failed",
        app_state_none: "Not synced yet",
        btn_dry_run: "Check (dry run)",
        btn_sync_now: "Sync now",
        btn_dry_run_hint: "A check writes no price at all. Tick single promotions, or leave them all unticked for the whole shop.",
        btn_view_result: "Per-SKU result",
        btn_view_result_hint: "Per-SKU results exist only for a run started from this page — press dry-run or sync first",
        btn_close: "Close",
        btn_cancel: "Cancel",
        selected_count: "{count} promotions selected",
        selected_none: "Nothing selected = the whole shop",
        confirm_title: "Sync the promotions from Shopee?",
        confirm_text:
            "The app's flash prices will be set to the Shopee promotion prices ({count} selected; 0 = the whole shop). Flash prices set by staff are not touched.",
        running: "A promotion sync is running — the buttons come back when it finishes",
        result_title: "Per-SKU result",
        result_dry_run: "Check result (nothing was written)",
        result_applied: "Promotions synced",
        result_summary:
            "{total} promotions · {applied} applied · {set} SKUs priced · {cleared} cleared · {skipped} skipped",
        result_empty: "This promotion has no SKU",
        col_sku: "SKU",
        col_price_before: "Price before",
        col_price_after: "Promotion price",
        col_action: "Outcome",
        col_reason: "Reason",
        action_set: "Priced",
        action_keep: "Unchanged",
        action_clear: "Cleared",
        action_skip: "Skipped",
        action_unknown: "Unknown outcome",
        promo_action_apply: "Applied",
        promo_action_end: "Ended",
        promo_action_skip: "Skipped",
        promo_action_noop: "Nothing changed",
        promo_action_unknown: "Unknown outcome",
        warnings_title: "Warnings",
        warn_sku_not_synced: "This listing has not been synced into the app yet (there is no SKU to price)",
        warn_manual_flash_exists: "This SKU has a flash price set by staff; it was left alone",
        warn_app_price_already_lower: "The app already charges the same or less than the Shopee promotion, so nothing was written",
        warn_platform_promotion_skipped: "Shopee created this promotion itself (platform campaign); it is not supported",
        warn_base_price_mismatch: "Shopee's regular price differs from the app's regular price (informational only)",
        warn_item_level_price_spread: "Shopee sent an item-level price, so it was spread over every option in the promotion",
        warn_model_not_active: "This option is closed, deleted or rejected on Shopee",
        warn_no_promotion_price: "This promotion carried no usable price",
        warn_promotion_ended: "The promotion ended or was disabled on Shopee, so the prices we set were cleared",
        warn_sku_inactive: "This SKU is deleted or closed",
        warn_ownership_columns_missing: "The flash-ownership columns are missing from the database (the SQL has not been run)",
        warn_duplicate_sku_mapping: "Two Shopee options of this promotion are mapped to the same SKU; only the first price was applied — re-map the listing",
        warn_remote_expired_window_open: "Shopee reports this promotion as expired although the dates it sent have not ended, so no price was written",
        warn_unknown: "There is a warning this build does not recognise",
        disabled_state: "The Shopee promotion sync is turned off (enable it in the API config)",
        mode_shadow_hint: "Shadow mode: the result is computed but no price is written",
        show_upcoming_state: "Show not-yet-started promotions on the storefront",
        show_upcoming_on: "On",
        show_upcoming_off: "Off",
        setting_label: "Show promotions that have not started (\"coming soon\")",
        setting_help:
            "On: the storefront and the app show the price of a promotion that has not started yet, with a \"coming soon\" badge. Off: only running promotions are shown (the default).",
        flash_from_shopee: "From Shopee",
        flash_from_shopee_hint: "This price comes from a Shopee promotion. Change it in Shopee Seller Centre.",
        empty: "This shop has no promotion yet — create one in Shopee Seller Centre, then press Check",
        err_shop_required: "Select a Shopee shop first",
        err_shop_not_found: "This Shopee shop was not found",
        err_in_flight: "A promotion sync of this shop is already running — its result will be picked up here",
        err_bad_promotion_type: "Invalid promotion type (only Discount and Flash Sale are supported)",
        err_shop_not_master: "Promotions are mirrored from the master Shopee shop only",
        err_fetch_failed: "Reading the promotions from Shopee failed. Please try again.",
        err_disabled: "The Shopee promotion sync is turned off",
        err_generic: "The request failed"
    },
    product_platform_v2: {
        map_wms_btn: "Map SKU to warehouse (WMS)",
        mdfstore_hint: "These products are synced from the Storefront — map each SKU to a warehouse (WMS) product, otherwise orders will not deduct stock.",
        makro_hint: "These products are synced from Makro (Mirakl) offers — map each SKU to a warehouse (WMS) product, otherwise orders will not deduct stock."
    },
    // makro_order — mirakl Dev-B2 (Makro PRO / Mirakl order actions)
    makro_order: {
        sync_now: "Sync Makro",
        sync_started: "Makro order sync started",
        sync_running: "A Makro sync is already running",
        accept: "Accept order (Makro)",
        accept_success: "Makro order accepted",
        ship_to_makro: "Notify shipment to Makro",
        ship_success: "Shipment notified to Makro",
        tracking_required: "Please enter a tracking number before notifying shipment",
        action_failed: "Makro action failed"
    },
    // ── keys referenced by call sites but never defined (added 2026-08-21) ──
    // Until now vue-i18n rendered the raw key on screen, e.g. a column header
    // reading "order_id" or an error dialog titled "error". Find them by
    // resolving every $t() against the real language files. Never reuse a name
    // that already exists (see the note on platform_integration).
    error: "Error",
    warning: "Warning",
    no_data: "No data",
    loading: "Loading...",
    clear: "Clear",
    remove: "Remove",
    Export: "Export",
    continue: "Continue",
    confirm_delete: "Confirm delete",
    please_fill_required: "Please fill in all required fields",
    save_failed: "Save failed",
    create_failed: "Create failed",
    webcam_not_found: "Webcam not found",
    Barcode: "Barcode",
    size: "Size",
    address: "Address",
    code: "Code",
    number: "Number",
    order_id: "Order ID",
    tracking: "Tracking Number",
    sku: "SKU",
    storage: "Storage",
    staff: "Staff",
    date_from: "From Date",
    date_to: "To Date",
    po_number: "PO Number",
    partner_name: "Partner Name",
    coupon_id: "Coupon ID",
    coupon_prefix: "Coupon Prefix",
    coupon_start: "Start Number",
    coupon_end: "End Number",
    bc_coupon_deail: "Coupon Detail",

    // coupon_event — the create-a-coupon-event screen (spec 2026-09-23 §4).
    // The right to create comes from config.yml coupon_event.emails, not a role.
    coupon_event: {
        enabled: "Enabled",
        enabled_hint: "Off = codes are generated but not yet usable",
        title: "Create coupon event",
        create_button: "Create coupon event",
        subtitle: "Create a new coupon batch — the codes are generated in the background after saving",

        // fields, in the order of the §3 table
        name: "Event name",
        name_placeholder: "e.g. Songkran 2026",
        prefix: "Code prefix",
        prefix_placeholder: "A-Z and 0-9, up to 10 characters",
        prefix_hint: "Uppercased automatically",
        url_prefix: "QR URL",
        url_prefix_placeholder: "https://www.madamefin.com/c/",
        url_prefix_hint: "Must be a full URL starting with http:// or https://",
        valid_from: "Valid from",
        valid_to: "Valid to",
        running_from: "Running number from",
        running_to: "Running number to",
        running_digit: "Running number digits",
        running_digit_hint: "Must be at least as wide as the last running number",
        random_digit: "Random number digits",
        random_digit_hint: "Use 0 for no random part",
        random_round: "Random rounds",
        random_round_hint: "How many times the running range is repeated, each round behind its own random number (0 or 1 = one pass, up to 200). Needs random digits.",
        condition: "Condition",
        condition_placeholder: "Free text (optional)",

        quantity: "Coupon quantity",
        quantity_hint: "(Running to − running from + 1) × random rounds (recomputed server-side)",
        // {max} comes from COUPON_EVENT_MAX_QUANTITY — never hard-code the
        // number in the translation.
        quantity_max: "Maximum {max} per event",
        quantity_over_cap: "That is more coupons than one event can generate — please narrow the running range or use fewer random rounds",

        submit: "Save",
        cancel: "Cancel",
        back: "Back",

        created: "Coupon event created",
        created_detail: "The codes are being generated in the background — this may take a moment",

        // Delete an event + the "All" button (spec §8.3).
        // delete_confirm takes {name} · deleted_detail takes {codes} ·
        // all_count takes {n}.
        delete: "Delete event",
        delete_confirm: "Delete the event \"{name}\"?",
        delete_confirm_detail: "Every coupon code of this event is deleted with it, and this screen cannot undo it",
        delete_confirm_ok: "Delete",
        deleted: "Coupon event deleted",
        deleted_detail: "{codes} coupon code(s) were deleted with it",
        all: "All",
        all_count: "{n} in total",
        all_loading: "Loading every coupon",
        exporting: "Building the export file",

        forbidden: "You are not allowed to create coupon events",

        forbidden_title: "Not allowed to create coupon events",
        forbidden_detail: "This permission is set by email in the server config — please contact an administrator",

        // errors — the key IS the code the API sends in Msg (spec §3);
        // the operator must never be shown the raw code.
        errors: {
            coupon_event_bad_name: "Please enter an event name",
            coupon_event_bad_prefix: "Prefix must be 1-10 characters of A-Z or 0-9",
            coupon_event_bad_url: "Invalid URL — it must start with http:// or https://",
            coupon_event_bad_dates: "Invalid date range — the end must be after the start",
            coupon_event_bad_running: "Invalid running numbers — the first must be 0 or more, the last must not be lower than the first, and the total must not exceed 200,000",
            coupon_event_bad_digits: "Invalid digit counts — running 1-10 digits (wide enough for the last number), random 0-10 digits, rounds 0-5",
            coupon_event_name_taken: "An event with this name already exists — please use another name",
            coupon_event_forbidden: "You are not allowed to create coupon events",
            // §8.1 — refused because somebody holds the codes
            // ({registered} registered / {used} sent out with an order).
            coupon_event_in_use: "Cannot delete — {registered} code(s) are registered and {used} went out with an order",
            coupon_event_in_use_registered: "Cannot delete — {registered} code(s) of this event are registered to a member",
            coupon_event_in_use_used: "Cannot delete — {used} code(s) of this event went out with an order",
            coupon_event_not_found: "That event does not exist, or has already been deleted",
            // unknown = the create form · unknown_delete = the delete icon ·
            // unknown_all = the All button. The verb has to match what the
            // operator just pressed, or a failed delete reports that a creation
            // they never attempted did not work.
            unknown: "Could not create the coupon event",
            unknown_delete: "Could not delete the coupon event",
            unknown_all: "Could not load every coupon"
        }
    },
    // #437 /wms/inventory/shipped-no-deduct (spec 2026-10-09 §5)
    shipped_no_deduct: {
        title: "Shipped without stock deduction",
        hint: "Orders shipped without a packing close; use as input for stock-out",
        date_hint: "Order date range, max 31 days",
        filter_date: "Order date",
        filter_platform: "Platform",
        filter_status: "Status",
        all: "All",
        platform_self: "Self (BO)",
        tab_summary: "By product",
        tab_orders: "Orders",
        col_code: "Code",
        col_name: "Name",
        col_barcode: "Barcode",
        col_qty: "Qty to withdraw",
        col_qty_short: "Qty",
        col_order_count: "Orders",
        col_order_id: "Order",
        col_platform_order_id: "Platform order",
        col_platform: "Platform",
        col_shop: "Shop",
        col_status: "Status",
        col_created_at: "Order date",
        col_reason: "Reason",
        col_items: "Items",
        total: "Total",
        product_deleted: "(deleted)",
        reason: {
            no_packing_close: "No packing close",
            closed_without_items: "Closed with no stock lines",
        },
        reason_no_packing_close: "No packing close",
        reason_closed_without_items: "Closed with no stock lines",
        mapping_missing: "No product mapping",
        mapping_missing_banner: "{n} orders have no product mapping — not in the summary, check manually",
        mapping_missing_link: "Show orders",
        mapping_missing_only: "Showing only orders with no product mapping",
        clear_filter: "Clear filter",
        returning_badge: "Returning",
        empty: "Nothing shipped without deduction in this range",
        as_of: "As of {time}",
        retry: "Retry",
        sheet_summary: "By product",
        sheet_orders: "Orders",
        errors: {
            range_too_wide: "Date range must be 31 days or less",
            too_many_rows: "More than 5,000 orders — narrow the range or platforms",
            report_index_missing: "Report unavailable — admin must run the index SQL first",
            invalid_status: "Invalid status selection",
            invalid_request: "Invalid request",
        },
    },
    // POS หน้าร้าน (#443, spec 2026-10-10-pos-module-design §7) — keep th/en keys identical
    pos: {
        menu: {
            root: "POS",
            bills: "POS bills",
            reports: "POS reports",
            report_sales: "Sales summary",
            report_top_spenders: "Top spenders",
            report_products: "Best products",
            report_promotions: "Best promotions",
            manage: "POS setup",
            devices: "POS devices",
            events: "Events",
            bundles: "Bundles",
            settings: "Settings",
            products: "POS products",
            report_event_members: "Buyers by event ID",
        },
        role: {
            label: "POS permission",
            none: "None",
            seller: "Seller",
            supervisor: "Supervisor",
            admin: "Admin",
            bo_menu: "POS menu in the BO",
            bo_menu_hint: "Opens the POS pages of the Backoffice (bills/reports; supervisor = devices; admin = events/products/settings) — selling in the app does not need it",
            from_group: "Granted by the user group",
        },
        not_installed: "POS tables are not installed — ask an administrator to run sql/2026-10-10-pos-module.sql, then try again",
        not_installed_phase3: "POS phase 3 tables are not installed — ask an admin to run sql/2026-10-10-pos-phase3.sql, then try again",
        common: {
            save: "Save",
            cancel: "Cancel",
            delete: "Delete",
            close: "Close",
            back: "Back",
            search: "Search",
            export: "Export Excel",
            confirm: "Confirm",
            saved: "Saved",
            deleted: "Deleted",
            active: "Active",
            inactive: "Inactive",
            total_rows: "{n} rows",
            export_capped: "Export is limited to 20,000 rows",
            menu: "Menu",
            move_up: "Move up",
            move_down: "Move down",
            remove: "Remove",
        },
        filter: {
            range: "Date range",
            event: "Event",
            event_all: "All events",
            event_default: "Device default set",
            device: "Device",
            device_all: "All devices",
            include_test: "Include test devices",
            range_invalid: "Please choose a valid date range",
            range_too_long: "The date range can be at most 92 days",
            status: "Status",
            status_all: "All",
            status_paid: "Paid",
            status_voided: "Voided",
            payment: "Payment method",
            payment_all: "All methods",
            search: "Search (bill no. / phone / name)",
        },
        device: {
            add: "Add device",
            apk: "APK",
            apk_title: "Download the POS app",
            apk_hint: "Scan with the POS device (Sunmi V3) to download the latest app, then tap Install — if it says the app was blocked, tap More details → Install anyway",
            apk_copy: "Copy link",
            apk_copied: "Link copied",
            apk_copy_failed: "Could not copy the link",
            code: "Device code",
            name: "Device name",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            paired: "Paired",
            not_paired: "Not paired",
            last_seen: "Last seen",
            last_user: "Last user",
            is_test: "Test device",
            is_test_form: "Test device (excluded from reports)",
            bills: "Bills",
            note: "Note",
            edit: "Edit",
            pairing_code_create: "Create pairing code",
            unpair: "Unpair",
            default_set: "Default product set",
            delete: "Delete",
            form_title_add: "Add POS device",
            form_title_edit: "Edit POS device",
            code_locked_hint: "This device already has bills, so its code cannot change",
            pairing_title: "Pairing code",
            pairing_expires: "Expires in {time}",
            pairing_expired: "The code has expired; create a new one",
            pairing_hint: "Enter this code on the POS pairing screen of device {code}",
            confirm_unpair: "Unpair device {code}?",
            confirm_delete: "Delete device {code}?",
            unpaired_ok: "Device unpaired",
            default_set_title: "Default product set — {code}",
            default_products: "Products",
            default_bundles: "Bundles",
            product_search: "Search a product to add",
            eligible_no: "Not sellable",
            mode: "Mode",
            mode_app: "App (permanent sign-in)",
            mode_web: "Web",
            session_user: "Device user",
            passcode: "Unlock code",
            passcode_set: "Set",
            passcode_cooldown: "Cooling down",
            passcode_hard_locked: "Locked",
            passcode_none: "—",
            passcode_reset: "Reset code to 123456",
            passcode_reset_title: "Reset code to 123456 — {code}",
            passcode_new: "New 6-digit code",
            passcode_confirm: "Confirm code",
            passcode_mismatch: "The two codes do not match",
            passcode_shape: "The code must be 6 digits",
            passcode_weak_hint: "No repeated digits or straight runs such as 123456 / 654321",
            passcode_reset_ok: "New code set — tell the staff at device {code}",
            lock_idle: "Auto lock",
            lock_idle_hint: "5 / 10 / 15 minutes or never (default 5 minutes)",
            app_version: "App version",
            staff: "Staff allowed on this device",
            staff_title: "Staff allowed on this device — {code}",
            staff_hint: "Anyone in the company can be picked — nobody selected = nobody can use this device (unless its event sets staff)",
            staff_all: "Pick the staff who can use this device",
            staff_count: "{n} people",
            pos_product_search: "Search POS products to add",
            lock_idle_col: "Auto lock",
            lock_idle_300: "5 minutes",
            lock_idle_600: "10 minutes",
            lock_idle_900: "15 minutes",
            lock_idle_0: "Never",
            lock_idle_other: "Old value (set again)",
            passcode_reset_confirm: "Reset the unlock code of device {code} to 123456? The old code and any lock are cleared; the device must unlock again",
            passcode_reset_done: "The new unlock code is 123456",
        },
        event: {
            add: "Create event",
            name: "Event name",
            location: "Location",
            date_range: "Dates",
            start_date: "Start date",
            end_date: "End date",
            end_before_start: "The end date cannot be before the start date",
            status: "Status",
            active_today: "Open today",
            devices: "POS devices",
            products: "Products",
            bundles: "Bundles",
            bills: "Bills",
            cap_pct: "Staff discount cap (%)",
            cap_amount: "Staff discount cap (THB)",
            cap_hint: "Both empty = sellers cannot give a discount without supervisor approval",
            note: "Note",
            tab_products: "Products and special prices",
            tab_bundles: "Bundles",
            tab_receipt: "Receipt",
            product: "Product",
            code: "Code",
            retail_price: "Retail price",
            special_price: "Special price (empty = retail)",
            receipt_override: "Use a receipt header/footer for this event only",
            copy_default: "Copy from default",
            title_new: "Create event",
            title_edit: "Edit event",
            confirm_delete: "Delete this event?",
            image: "Image",
            board_card: "Top Spender board",
            board_enabled: "Public buyer ranking board",
            board_url: "Board link",
            board_copy: "Copy link",
            board_open: "Open",
            board_copied: "Link copied",
            board_hint: "Receipts of this event print a QR code to the board",
            board_no_url: "The board link shows after saving (and once the server sets pos.board_base_url)",
            tab_payment: "Receiving account",
            payment_override: "Use a receiving account for this event only",
            staff_title: "Event staff",
            staff_hint: "Anyone in the company can be picked — nobody selected = the device's staff list; if the device has none, nobody can sell",
            staff_placeholder: "Choose the staff selling at this event",
            staff_not_installed: "The event staff table is not installed — ask an admin to run sql/2026-10-10-pos-phase3c-event-staff.sql",
            staff_after_save: "Save the event first, then choose its staff",
            staff_load_error: "Could not load the event staff",
            staff_retry: "Retry",
        },
        bundle: {
            add: "Add bundle",
            name: "Bundle name",
            code: "Code",
            price: "Bundle price",
            retail_total: "Retail total",
            item_count: "Items",
            used_in: "Used in events",
            status: "Status",
            product: "Product",
            qty: "Qty",
            retail_price: "Retail price",
            line_total: "Total",
            summary: "Retail total {retail} · customer saves {saving}",
            title_add: "Add bundle",
            title_edit: "Edit bundle",
            confirm_delete: "Delete this bundle?",
        },
        settings: {
            promptpay_card: "PromptPay",
            promptpay_id: "PromptPay ID (10-digit phone / 13-digit tax ID)",
            promptpay_name: "Account name shown under the QR",
            cap_card: "Discount cap when no event applies",
            cap_pct: "(%)",
            cap_amount: "(THB)",
            receipt_card: "Receipt header/footer (default)",
            logo: "Logo",
            logo_upload: "Upload png/jpg",
            logo_remove: "Remove logo",
            logo_hint: "Resized to at most 384 px wide, grayscale, at most 200 KB",
            logo_too_big: "The logo is over 200 KB after resizing; please use a simpler image",
            shop_name: "Shop name",
            address: "Address",
            phone: "Phone",
            header_note: "Header note",
            footer_text: "Footer text",
            footer_qr_text: "Footer QR (link or text)",
            footer_qr_caption: "QR caption",
            show_customer_address: "Show the customer address on the receipt",
            preview: "80 mm receipt preview",
        },
        bill: {
            bill_no: "Bill no.",
            datetime: "Date/time",
            device: "Device",
            event: "Event",
            seller: "Seller",
            customer: "Customer",
            phone: "Phone",
            qty: "Qty",
            subtotal: "Subtotal",
            discount: "Discount",
            net: "Net",
            payment: "Paid by",
            status: "Status",
            void_reason: "Void reason",
            reprint_count: "Reprints",
            view: "View bill",
            reprint: "Reprint",
            void: "Void bill",
            voided_tag: "Voided",
            paid_tag: "Paid",
            cash: "Cash",
            transfer: "Transfer / PromptPay",
            sum_bills: "Bills",
            sum_net: "Net",
            sum_cash: "Cash",
            sum_transfer: "Transfer",
            void_title: "Void bill",
            void_reason_label: "Reason for voiding",
            void_reason_min: "Please enter a reason of at least 3 characters",
            voided_ok: "Bill voided",
            detail_title: "Bill detail",
            mid: "Buyer ID",
            mid_filter: "Buyer ID",
            mid_needs_event: "Choose an event to filter by buyer ID",
        },
        report: {
            group_by: "Group by",
            by_day: "Day",
            by_device: "Device",
            by_seller: "Seller",
            by_event: "Event",
            bills: "Bills",
            items: "Items",
            gross: "Before discount",
            discount: "Discount",
            net: "Net",
            cash: "Cash (bills)",
            transfer: "Transfer (bills)",
            cash_amount: "Cash",
            cash_count: "Cash bills",
            transfer_amount: "Transfer",
            transfer_count: "Transfer bills",
            company_transfer: "Transfer/QR to company (bills)",
            company_transfer_amount: "Transfer/QR to company",
            company_transfer_count: "Transfer/QR to company bills",
            qr_thqr: "THQR 2C2P (bills)",
            qr_thqr_amount: "THQR 2C2P",
            qr_thqr_count: "THQR 2C2P bills",
            qr_wechat: "WeChat 2C2P (bills)",
            qr_wechat_amount: "WeChat 2C2P",
            qr_wechat_count: "WeChat 2C2P bills",
            qr_truemoney: "TrueMoney QR 2C2P (bills)",
            qr_truemoney_amount: "TrueMoney QR 2C2P",
            qr_truemoney_count: "TrueMoney QR 2C2P bills",
            qr_shopee: "ShopeePay QR 2C2P (bills)",
            qr_shopee_amount: "ShopeePay QR 2C2P",
            qr_shopee_count: "ShopeePay QR 2C2P bills",
            total: "Total",
            voided_note: "{n} voided bills ({amount} THB) are excluded from the totals",
            chart_net: "Net sales (cash + transfer/QR to company + THQR + WeChat)",
            chart_top: "Top 10",
            rank: "Rank",
            phone: "Phone",
            name: "Name",
            phone_prefix: "Phone starts with",
            bill_count: "Bills",
            total_spent: "Total spent",
            avg_bill: "Average per bill",
            first_bill: "First purchase",
            last_bill: "Last purchase",
            customer_title: "Customer",
            customer_profile: "Customer profile",
            address: "Address",
            bills_of_customer: "Customer bills",
            product: "Product",
            code: "Code",
            qty_single: "Sold alone (pcs)",
            qty_in_bundle: "In bundles (pcs)",
            qty_total: "Total (pcs)",
            amount: "Sales",
            amount_single: "Sales alone",
            amount_bundle: "Sales in bundles",
            qty_special: "At special price (pcs)",
            sort_by: "Sort by",
            sort_qty: "Quantity",
            sort_amount: "Sales",
            products_note: "Sales are before the end-of-bill discount",
            section_bundles: "Bundles",
            section_special: "Special prices",
            section_discount: "End-of-bill discounts",
            bundle: "Bundle",
            qty: "Qty",
            retail_value: "Retail value",
            savings: "Customer savings",
            event: "Event",
            discount_given: "Discount given",
            discount_total: "Total discount",
            approved_count: "Approved over cap (bills)",
            approved_total: "Approved discount",
            no_data: "No data",
            level: "Level",
            level_pos: "POS products",
            level_wms: "WMS products",
            wms_product: "WMS product",
            wms_code: "WMS code",
            qty_pieces: "Qty (pcs)",
            mid: "Buyer ID",
            mid_search: "Search (buyer ID / phone)",
            mid_bills: "Bills of buyer {mid}",
            mid_event: "Event",
            mid_event_pick: "Choose an event",
            mid_event_required: "Choose an event first",
            members: "Buyers",
            open_board: "Open public board",
            top_spenders_day: "Top buyers of the day (by buyer ID)",
            top_spenders_day_hint: "Top 10 of the chosen event on the chosen day, voided bills excluded",
        },
        product: {
            add: "Add POS product",
            search: "Search name / code",
            status_all: "All statuses",
            image: "Image",
            image_label: "Product image",
            image_upload: "Upload png/jpg",
            image_remove: "Remove image",
            image_hint: "Resized to at most 800 px on the long side (JPEG)",
            image_too_big: "The image is over 1 MB after resizing; use another one",
            name: "Product name",
            code: "Code",
            price: "Price",
            price_baht: "Price (THB)",
            wms: "WMS products",
            used_in_events: "Used in events",
            device_sets: "Device default sets",
            status: "Status",
            note: "Note",
            edit: "Edit",
            delete: "Delete",
            sold_hint: "Already sold; set it inactive instead",
            wms_section: "WMS products in this item",
            wms_search: "Search WMS products (code / name / barcode)",
            wms_qty: "Qty",
            wms_add: "+ Add WMS product",
            wms_footer: "{n} lines · {q} pieces",
            wms_hint: "For reports only; stock is not deducted",
            wms_missing: "This WMS product was deleted or disabled",
            title_add: "Add POS product",
            title_edit: "Edit POS product",
            confirm_delete: "Delete this POS product?",
            picker: "Search POS products to add",
            inactive_tag: "Inactive",
            pieces: "{n} pcs",
        },
        payment_account: {
            card: "Transfer receiving account",
            mode: "How customers pay",
            mode_promptpay: "PromptPay (QR with the amount)",
            mode_static_qr_image: "Bank merchant QR (image, e.g. K SHOP)",
            mode_bank_account_only: "Account number only (no QR)",
            mode_helper: "A bank account number cannot make a QR with the amount — for that, use PromptPay linked to the company tax ID, or upload the bank's merchant QR",
            bank: "Bank",
            account_no: "Account number",
            account_name: "Account name",
            promptpay_type: "PromptPay type",
            promptpay_type_phone: "Phone number",
            promptpay_type_tax_id: "Tax ID (13 digits)",
            promptpay_type_ewallet: "e-Wallet (15 digits)",
            promptpay_id: "PromptPay number",
            tax_id_invalid: "Invalid tax ID",
            promptpay_id_invalid: "This PromptPay number does not fit the selected type",
            account_no_invalid: "The account number must be 10–15 digits",
            account_name_required: "Enter the account name",
            qr_image: "QR image",
            qr_upload: "Upload png/jpg",
            qr_change: "Change image",
            qr_hint: "Resized to at most 600 px and 300 KB",
            qr_too_big: "The QR image is over 300 KB after resizing",
            qr_required: "Upload the QR image",
            show_on_receipt: "Print the receiving account on transfer receipts",
            save: "Save receiving account",
            preview: "Transfer screen preview",
            preview_amount: "Amount to transfer",
            preview_dynamic_qr: "PromptPay QR with the amount (made on the POS device)",
            preview_no_amount: "This QR has no amount — the customer types it",
            preview_no_qr: "No QR — the customer transfers to the account below",
            receipt_line: "Receipt line",
            none: "No receiving account yet",
            banks: {
                KBANK: "Kasikornbank",
                SCB: "Siam Commercial Bank",
                BBL: "Bangkok Bank",
                KTB: "Krungthai Bank",
                BAY: "Bank of Ayudhya (Krungsri)",
                TTB: "TMBThanachart Bank",
                GSB: "Government Savings Bank",
                BAAC: "BAAC",
                GHB: "Government Housing Bank",
                UOB: "UOB",
                CIMB: "CIMB Thai",
                KKP: "Kiatnakin Phatra Bank",
                LHB: "Land and Houses Bank",
                TISCO: "TISCO Bank",
            },
        },
        errors: {
            generic: "Something went wrong, please try again",
            pos_address_invalid: "Invalid address",
            pos_approval_bad_request: "Incomplete approval request",
            pos_approval_failed: "Incorrect email or password",
            pos_approval_invalid: "The approval has expired or was already used",
            pos_approval_not_supervisor: "This account cannot approve",
            pos_bad_request: "Invalid request",
            pos_bill_already_voided: "This bill is already voided",
            pos_bill_invalid: "Invalid bill",
            pos_bill_not_found: "Bill not found",
            pos_bill_other_device: "This bill belongs to another device",
            pos_bundle_has_bills: "This bundle has been sold and cannot be deleted — set it inactive instead",
            pos_bundle_invalid: "Invalid bundle (needs at least one item and a price above 0)",
            pos_bundle_not_found: "Bundle not found",
            pos_cash_insufficient: "Cash received is less than the total",
            pos_device_code_invalid: "The device code must be 2–10 characters of A–Z or 0–9",
            pos_device_code_locked: "This device has bills; its code cannot change",
            pos_device_code_taken: "This device code is already used",
            pos_device_disabled: "This device is disabled",
            pos_device_has_bills: "This device has bills and cannot be deleted — disable it instead",
            pos_device_not_found: "POS device not found",
            pos_device_unpaired: "This device is not paired",
            pos_device_wrong_enterprise: "This device belongs to another shop",
            pos_discount_exceeds_subtotal: "The discount exceeds the subtotal",
            pos_discount_invalid: "Invalid discount",
            pos_discount_needs_approval: "The discount is over the cap and needs supervisor approval",
            pos_event_has_bills: "This event has bills and cannot be deleted — set it inactive instead",
            pos_event_inactive: "This event is closed; please choose another",
            pos_event_invalid: "Invalid event (check the dates and discount caps)",
            pos_event_not_found: "Event not found",
            pos_export_too_large: "More than 20,000 rows; please narrow the date range",
            pos_forbidden: "You do not have permission for this",
            pos_internal: "System error, please try again",
            pos_item_not_available: "Some items can no longer be sold",
            pos_logo_invalid: "The logo must be a png/jpg of at most 200 KB",
            pos_no_catalog: "This device has nothing to sell yet; contact an administrator",
            pos_not_installed: "POS is not ready yet (database not installed)",
            pos_pairing_invalid: "The pairing code is wrong or expired",
            pos_pairing_locked: "Too many wrong attempts; create a new code",
            pos_phone_invalid: "Invalid phone number",
            pos_product_ineligible: "Some products cannot be sold on POS (must be active Backoffice products)",
            pos_promptpay_invalid: "The PromptPay ID must be 10, 13 or 15 digits",
            pos_range_invalid: "Invalid date range",
            pos_range_too_long: "The date range can be at most 92 days",
            pos_total_mismatch: "Prices have changed; please check the bill again",
            pos_transfer_unconfirmed: "Please confirm the transfer was received",
            pos_void_needs_approval: "Voiding needs supervisor approval",
            pos_void_reason_required: "Please enter a reason of at least 3 characters",
            pos_zipcode_invalid: "The postcode must be 5 digits",
            pos_phase3_not_installed: "POS phase 3 tables are not installed",
            pos_device_session_disabled: "This device is not in app mode",
            pos_session_user_invalid: "The user who paired this device can no longer use POS — pair it again",
            pos_device_locked: "The device is locked — unlock it with the code",
            pos_passcode_invalid: "The code must be 6 digits",
            pos_passcode_weak: "The code is too simple (all the same digit or a straight run)",
            pos_passcode_wrong: "Wrong code",
            pos_passcode_cooldown: "Too many wrong codes; please wait",
            pos_passcode_hard_locked: "More than 10 wrong codes — a supervisor must set a new one in the BO",
            pos_passcode_not_set: "No unlock code is set on this device",
            pos_device_not_app: "This device is not paired as an app, so it has no unlock code",
            pos_device_invalid: "Invalid device data (lock 30–3600 seconds / staff must have a POS role)",
            pos_product_invalid: "Invalid POS product data",
            pos_product_code_taken: "This product code is already used",
            pos_product_has_bills: "This product was sold and cannot be deleted — set it inactive instead",
            pos_product_not_found: "POS product not found",
            pos_image_invalid: "The image must be png/jpg, at most 1 MB",
            pos_mid_invalid: "Invalid buyer ID",
            pos_mid_not_found: "This buyer ID does not exist in the event",
            pos_mid_no_event: "Choose an event before searching a buyer ID",
            pos_event_required: "Choose an event",
            pos_board_not_found: "Board not found",
            pos_rate_limited: "Too many requests; please wait",
            pos_payment_account_invalid: "Invalid receiving account",
            pos_qr_image_invalid: "The QR image must be png/jpg, at most 300 KB",
            pos_staff_not_allowed: "This staff member may not use this device",
            pos_lock_idle_invalid: "Choose 5 / 10 / 15 minutes or never",
            pos_event_staff_not_installed: "The event staff table is not installed",
        },
    },
    // การตลาด — หน้า Landing (โฆษณา) + รายงานที่มาของออเดอร์ (Phase 1 ads §6.6)
    marketing: {
        menu: {
            root: "Marketing",
            landing_pages: "Landing pages (ads)",
            attribution: "Order sources / ads",
            referral_codes: "Referral codes",
            referral_report: "Referral report",
            affiliate_settings: "Affiliate: settings",
            affiliate_members: "Affiliate: members",
            affiliate_commissions: "Affiliate: commissions",
            affiliate_payouts: "Affiliate: payouts",
            affiliate_report: "Affiliate report",
        },
        role_label: "Marketing (landing pages / source report / referral codes / affiliate)",
        referral: {
            create: "Create code",
            bulk_create: "Bulk create",
            edit: "Edit",
            disable: "Disable",
            enable: "Enable",
            copy_link: "Copy link",
            download_qr: "Download QR",
            view_report: "View report",
            generate: "Generate",
            export_csv: "Export CSV",
            copied: "Copied",
            search: "Search code or name",
            tab_all: "All",
            filter_owner: "Staff",
            filter_team: "Team",
            filter_campaign: "Campaign",
            none_label: "(none)",
            no_reward: "None",
            always: "No time limit",
            batch_filter: "Showing codes from one bulk run",
            clear_filter: "Clear filter",
            save: "Save",
            cancel: "Cancel",
            close: "Close",
            confirm: "Confirm",
            reload: "Reload",
            done: "Done",
            created: "Code created",
            saved: "Saved",
            disabled_ok: "Code disabled",
            enabled_ok: "Code enabled",
            confirm_disable: "Disable code {code}? The link and code stop working for signups until you enable it again.",
            link_card: "Link and QR",
            code_blank_hint: "Leave blank to get a random code on save (with the prefix, if any)",
            code_readonly: "The code cannot change after creation (it is printed on QR codes and links)",
            prefix_hint: "Optional, up to 8 characters (A–Z, 0–9)",
            lp_placeholder: "Pick a live landing page",
            custom_placeholder: "e.g. /p/12 or /products?x=1",
            owner_placeholder: "Type a staff name to search",
            template_placeholder: "Pick a coupon template",
            datetime_placeholder: "Not set",
            code_status: {
                checking: "Checking…",
                available: "Available",
                taken: "Code already taken",
                format: "Code must be 4–16 of A–Z, 0–9",
            },
            state: {
                active: "Active",
                scheduled: "Scheduled",
                expired: "Expired",
                full: "Full",
                disabled: "Disabled",
            },
            col: {
                code: "Code",
                name: "Name",
                owner: "Staff",
                team: "Team",
                campaign: "Campaign",
                reward: "Reward",
                used: "Used",
                window: "Window",
                state: "Status",
                actions: "Menu",
                link: "Link",
            },
            field: {
                code: "Code",
                prefix: "Prefix",
                name: "Name",
                owner: "Owner (staff)",
                team: "Team",
                campaign: "Campaign",
                landing: "Page after the link",
                landing_home: "Home",
                landing_lp: "Landing page",
                landing_custom: "Custom",
                reward: "Signup reward",
                reward_none: "None",
                reward_coupon: "Auto coupon",
                template: "Coupon template",
                max_uses: "Max uses",
                unlimited: "Unlimited",
                starts_at: "Starts",
                ends_at: "Ends",
                note: "Note",
            },
            bulk: {
                mode_owner: "One code per staff",
                mode_count: "N codes",
                count: "Count",
                result: "Created codes",
                view_in_list: "View in list",
                owners: "Staff",
                create: "Create",
                download_csv: "Download CSV",
                name_hint: "Leave blank for an automatic name (campaign or team + staff / number)",
                created_n: "{n} codes created",
                mode: "Mode",
            },
            hint: {
                link: "This link opens {landing} and prefills the code",
                reward_future: "Applies to future signups only",
                welcome_dup: "New members already get the welcome coupon — this one is extra",
                template_dead: "Coupon unusable",
            },
            err: {
                code_taken: "Code already taken",
                code_format: "Code must be 4–16 of A–Z, 0–9",
                template_invalid: "Coupon template unusable",
                invalid_landing: "Path must start with /",
                below_used: "Below uses so far",
                stale: "Someone else edited this code — reload",
                too_many: "At most 200 codes per run",
                required: "Required",
                max_length: "Too long",
                range: "Out of range",
                format: "Invalid format",
                owner_not_found: "Staff not found",
                not_found: "Code not found",
                not_retryable: "This grant cannot be retried",
                generic: "Something went wrong",
                load: "Could not load data",
            },
            tpl: {
                discount: "{v} off",
                expiry: "expires {n} days after issue",
                left: "{n} left",
                unlimited: "unlimited",
            },
            reward_status: {
                none: "No reward",
                pending: "Awaiting phone verification",
                granted: "Granted",
                failed: "Failed",
                retry: "Retry coupon",
                retried: "Coupon granted",
                coupon_used: "Coupon used",
                error: {
                    template_inactive: "Template disabled",
                    template_missing: "Template missing",
                    template_expired: "Template expired",
                    quota_exhausted: "Quota exhausted",
                    error: "Error",
                },
            },
            report: {
                title: "Referral report",
                range: "Date range",
                cohort: "Members",
                cohort_all: "Everyone referred by the code",
                cohort_range: "Only those who signed up in the range",
                group_by: "Group by",
                group: {
                    code: "Code",
                    owner: "Staff",
                    team: "Team",
                    campaign: "Campaign",
                },
                owner: "Staff",
                team: "Team",
                campaign: "Campaign",
                code: "Code",
                search: "Search",
                export: "Export CSV",
                all: "All",
                card: {
                    signups: "Signups",
                    signups_rewarded: "Got the coupon",
                    members_ordered: "Members who ordered",
                    orders: "Orders",
                    revenue_placed: "Ordered",
                    revenue_completed: "Completed (130)",
                    revenue_cancelled_returned: "Cancelled / returned",
                },
                col: {
                    code: "Code",
                    name: "Name",
                    owner_name: "Staff",
                    team: "Team",
                    campaign: "Campaign",
                    signups: "Signups",
                    signups_rewarded: "Got coupon",
                    members_ordered: "Members ordered",
                    conversion: "% bought",
                    orders: "Orders",
                    open: "In progress",
                    completed: "Completed",
                    cancelled: "Cancelled",
                    returned: "Returned",
                    revenue_placed: "Ordered",
                    revenue_completed: "Completed",
                    revenue_cancelled_returned: "Cancelled / returned",
                    aov: "AOV",
                },
                total: "Total",
                empty: "No data",
                truncated: "Showing the first 1,000 rows — export CSV for all",
                invalid_range: "Invalid date range (max 366 days)",
                load_error: "Could not load the report",
                footnote: "Counts only confirmed MadameFin store orders (web / app / chat) — COD when placed, transfer / card once paid · current status",
                drawer_title: "Referred members",
                export_members: "Export CSV",
                deleted: "(account deleted)",
                source: {
                    link: "Link",
                    typed: "Typed",
                    unknown: "Unknown",
                },
                channel: {
                    phone: "Phone",
                    line: "LINE",
                    facebook: "Facebook",
                    email: "Email",
                },
                m: {
                    name: "Name",
                    phone: "Phone",
                    signed_up_at: "Signed up",
                    channel: "Channel",
                    source: "Came from",
                    code: "Code",
                    coupon: "Coupon",
                    orders: "Orders",
                    completed: "Completed",
                    cancelled_returned: "Cancelled / returned",
                    revenue_placed: "Ordered",
                    revenue_completed: "Completed",
                    last_order: "Last order",
                },
            },
        },
        schema_missing: "This feature's database is not installed yet (SQL pending)",
        // Phase 3 affiliate (spec 2026-10-13 §5.7)
        affiliate: {
            env_off: "This server has affiliate disabled (affiliate.env_enabled) — settings save, but the store does not show it yet",
            save: "Save",
            saved: "Saved",
            cancel: "Cancel",
            confirm: "Confirm",
            reload: "Reload",
            edit: "Edit",
            search: "Search",
            export_csv: "Export CSV",
            actions: "Actions",
            all: "All",
            empty: "No data",
            copy: "Copy",
            copied: "Copied",
            on: "On",
            off: "Off",
            reason: "Reason",
            reason_required: "Please enter a reason",
            reason_too_long: "Reason is longer than 300 characters",
            updated_by: "Last changed by {name} at {at}",
            settings: {
                tab_program: "Program settings",
                tab_rates: "Commission rates",
                enabled: "Enable program",
                click_window_days: "Click window (days)",
                maturity_days: "Confirmation delay after completion (days)",
                min_payout: "Minimum payout (THB)",
                wht: "3% withholding tax",
                terms_th: "Terms (Thai)",
                terms_en: "Terms (English)",
                bump_terms: "Save as a new terms version (members must accept again)",
                confirm_on: "Members granted affiliate eligibility (in Member management) with a verified phone will see the share button and can earn right away",
                confirm_off: "Links stop earning and share buttons are hidden; existing commission is still paid",
                stale: "Someone else changed the settings — reload",
                terms_version: "Current terms: version {v}",
            },
            rule: {
                add: "Add rate",
                edit_title: "Edit rate",
                scope: "Scope",
                scope_default: "Default",
                scope_category: "Category",
                scope_product: "Product",
                scope_promotion: "Bundle",
                all_scopes: "All scopes",
                target: "Target",
                target_placeholder: "Type to search",
                all_products: "All products",
                rate_type: "Type",
                rate_type_percent: "Percent",
                rate_type_fixed: "THB per item",
                rate: "Rate",
                per_item: "per item",
                starts_at: "Starts",
                ends_at: "Ends",
                note: "Note",
                zero_hint: "Enter 0 to exclude this product",
                no_default: "No default rate — products without their own rate earn nothing",
                window: "Window",
                always: "Always",
                state: "State",
                updated_by: "Changed by",
                disable: "Disable",
                enable: "Enable",
                state_active: "Active",
                state_scheduled: "Scheduled",
                state_expired: "Expired",
                state_disabled: "Disabled",
                precedence: "Precedence: product > category > default · bundle > default · a rate change applies to new orders only",
            },
            eligibility: {
                title: "Affiliate eligibility",
                status: "Eligibility",
                status_eligible: "Eligible",
                status_revoked: "Revoked",
                status_never: "Not eligible",
                row_not_eligible: "Not eligible",
                joined_as: "Joined, code {code}",
                hint: "The Affiliate menu on the website and LINE is shown only to eligible members. Revoking stops existing links from earning; past commissions are kept.",
                program_off: "The affiliate program is currently off — members see the menu once it is switched on in Affiliate: settings",
                granted_by: "Granted by {name} on {at}",
                revoked_by: "Revoked by {name} on {at}",
                note: "Note",
                note_placeholder: "Note (optional)",
                note_too_long: "Note is longer than 300 characters",
                grant: "Grant",
                revoke: "Revoke",
                confirm_grant: "Grant affiliate eligibility to this member? They will see the Affiliate menu and can join the program.",
                confirm_revoke: "Revoke affiliate eligibility? The menu disappears and shared links stop earning (past commissions are kept).",
                granted: "Eligibility granted",
                revoked: "Eligibility revoked",
                history: "Eligibility history",
                when: "When",
                action: "Action",
                by: "By",
                audit_grant: "Granted",
                audit_revoke: "Revoked",
                schema_missing: "The affiliate eligibility table is not installed yet (run sql/postgres/2026-10-16-affiliate-eligibility.sql) — until then no member is eligible",
                list_title: "Eligible affiliates",
                list_hint: "Grant new members from Member management → open the member → Affiliate tab",
                filter_true: "Eligible",
                filter_false: "Revoked",
                filter_all: "All",
                search: "Search name / phone / code / member no.",
                not_joined: "Not joined",
                changed: "Last change",
            },
            member: {
                code: "Code",
                name: "Name",
                phone: "Phone",
                joined: "Joined",
                status: "Status",
                docs: "Documents",
                status_active: "Active",
                status_suspended: "Suspended",
                status_deleted: "Account deleted",
                tab_all: "All",
                tab_active: "Active",
                tab_suspended: "Suspended",
                tab_deleted: "Account deleted",
                hold: "Payout on hold",
                suspend: "Suspend",
                unsuspend: "Unsuspend",
                hold_on: "Hold payouts",
                hold_off: "Release payouts",
                suspend_reason: "Reason",
                suspend_hold: "Also hold payouts",
                clicks_30d: "Clicks 30 d",
                orders_30d: "Orders 30 d",
                pending: "Pending",
                approved: "Ready",
                in_payout: "In payout",
                paid_total: "Paid total",
                tab_commissions: "Commissions",
                tab_profile: "Payout details",
                tab_audit: "History",
                search: "Search code / name / phone",
                docs_all: "Documents: all",
                view: "View details",
                deleted_name: "(account deleted)",
                confirm_unsuspend: "Unsuspend {code}? (payout hold is unchanged)",
                totals: "Clicks total {clicks} · orders total {orders}",
                open_ledger: "Open in the commission ledger",
            },
            profile: {
                status_none: "Not filled",
                status_submitted: "Awaiting review",
                status_verified: "Verified",
                status_rejected: "Rejected",
                view_id_card: "View ID card",
                view_bookbank: "View bank book",
                verify: "Verify",
                reject: "Reject",
                reject_reason: "Rejection reason",
                not_submitted: "This profile is not awaiting review",
                full_name: "Full name",
                national_id: "National ID",
                address: "Address",
                bank: "Bank",
                account_no: "Account number",
                account_name: "Account name",
                pdpa: "PDPA consent",
                link_expiry: "File links work for 5 minutes and every view is logged",
                confirm_verify: "Confirm that the payout details of {name} match the documents?",
            },
            commission: {
                kind: "Kind",
                kind_order: "Order",
                kind_adjustment: "Adjustment",
                status_pending: "Pending",
                status_approved: "Confirmed",
                status_paid: "Paid",
                status_cancelled: "Cancelled",
                status_reversed: "Reversed",
                zero_paid_ad: "Our ad",
                zero_self_purchase: "Own purchase",
                zero_rule_zero: "Excluded (0)",
                zero_no_rule: "No rate",
                zero_reason: "No-commission reason",
                cancel: "Cancel commission",
                cancel_reason: "Reason",
                not_cancellable: "Cannot cancel (in a payout or wrong status)",
                adjust: "Adjust",
                adjust_amount: "Amount",
                adjust_amount_hint: "Negative = claw back",
                adjust_order_no: "Order no. (optional)",
                adjust_note: "Note",
                mature_at: "Confirms on",
                partial_return_note: "Partial returns are not deducted automatically — finance enters a negative adjustment for the returned value",
                range: "Date range",
                status: "Status",
                order_no: "Order no.",
                payout: "Payout",
                date: "Date",
                order: "Order",
                order_status: "Order status",
                product: "Product",
                qty: "Qty",
                base: "Commission base",
                amount: "Commission",
                reason_order_cancelled: "Order cancelled",
                reason_order_returned: "Order returned",
                reason_unpaid: "Never paid",
                reason_bo_cancel: "Cancelled in BO",
            },
            payout: {
                create: "Create payout",
                cutoff: "Cutoff date",
                preview_eligible: "{n} affiliates will be paid",
                preview_skipped_min: "{n} below minimum",
                preview_skipped_profile: "{n} payout details not verified",
                preview_skipped_hold: "{n} on hold",
                create_draft: "Create (draft)",
                draft_exists: "A draft already exists — open it",
                open_draft: "Open the draft",
                submit: "Submit",
                cancel: "Cancel round",
                transfer_csv: "Transfer CSV",
                wht_csv: "WHT (PND3) CSV",
                pay: "Record payment",
                unpay: "Undo payment",
                view_slip: "View slip",
                payment_date: "Transfer date",
                slip: "Slip",
                payment_note: "Note",
                remove_item: "Remove from round",
                below_min: "Below minimum (clawed back during the round)",
                below_min_short: "Below minimum",
                details: "Details",
                not_found: "This payout round was not found",
                back_to_list: "Back to payout rounds",
                status_draft: "Draft",
                status_submitted: "Submitted",
                status_paid: "Paid",
                status_cancelled: "Cancelled",
                item_unpaid: "Unpaid",
                item_paid: "Paid",
                has_paid_items: "Cannot cancel: some items are paid",
                nothing_to_pay: "Nothing to pay up to this date",
                code: "Round",
                status: "Status",
                people: "Affiliates",
                paid_of: "Paid",
                gross: "Gross",
                wht: "Withholding tax",
                wht_short: "WHT 3%",
                net: "Net transfer",
                created: "Created by / at",
                note: "Note",
                tax_id: "Tax ID",
                count: "Items",
                slip_hint: "JPG, PNG or PDF up to 10 MB",
                confirm_submit: "Submit {code}? Items cannot be changed after submitting",
                confirm_remove: "Remove {code} from this round? Their commission returns to the next round",
                submitted_hint: "Download the transfer file and transfer outside the system, then record each payment with its slip. Never transfer real money for a TEST round",
                view_commissions: "Commissions in this round",
            },
            report: {
                group: "Group by",
                group_day: "Daily",
                group_month: "Monthly",
                export_which: "Export report",
                export_series: "Daily / monthly series",
                top_affiliates: "Top affiliates",
                top_targets: "Top shared products",
                chart_title: "Clicks and orders",
                card: {
                    affiliates_active: "Active affiliates",
                    affiliates_with_sales: "Affiliates with sales",
                    clicks: "Clicks",
                    orders: "Orders",
                    base_total: "Commission base",
                    commission_pending: "Commission pending",
                    commission_approved: "Commission confirmed",
                    commission_paid: "Commission paid",
                    zero_paid_ad_orders: "Orders without commission (our ad)",
                    zero_self_orders: "Orders without commission (own purchase)",
                    reversed_total: "Clawed back",
                },
                col: {
                    clicks: "Clicks",
                    orders: "Orders",
                    base: "Commission base",
                    commission: "Commission",
                    zero: "Ad / own",
                },
                footnote: "Counts MadameFin store orders from the website (www) that came from an affiliate link only · commission applies to the shared product only",
            },
            audit: {
                action: "Action",
                by: "By",
                detail: "Detail",
                settings_update: "Settings changed",
                join: "Joined",
                terms_accept: "Terms accepted",
                suspend: "Suspended",
                unsuspend: "Unsuspended",
                hold: "Payout hold",
                profile_submit: "Payout details submitted",
                profile_verify: "Payout details verified",
                profile_reject: "Payout details rejected",
                file_view: "Document viewed",
                commission_cancel: "Commission cancelled",
                adjust: "Adjustment",
                payout_create: "Payout created",
                payout_item_remove: "Removed from round",
                payout_submit: "Payout submitted",
                payout_cancel: "Payout cancelled",
                payout_item_pay: "Payment recorded",
                payout_item_unpay: "Payment undone",
                slip_view: "Slip viewed",
            },
            err: {
                generic: "Something went wrong. Please try again",
                load: "Could not load data",
                stale: "Someone else changed this — reload",
                not_found: "Not found",
                invalid_body: "Invalid data — check the fields in red",
                required: "Required",
                range: "Value out of range",
                max_length: "Too long",
                format: "Invalid format",
                amount: "Amount must be non-zero, between -100,000 and 100,000, with up to 2 decimals",
                target_not_found: "Product / bundle / category not found",
                not_submitted: "This profile is not awaiting review",
                not_cancellable: "Cannot cancel (in a payout or wrong status)",
                affiliate_not_found: "Affiliate not found",
                no_file: "No file uploaded",
                invalid_range: "Invalid date range (max 366 days)",
                draft_exists: "A draft already exists — open it",
                nothing_to_pay: "Nothing to pay up to this date",
                not_draft: "This round is no longer a draft",
                has_paid_items: "Cannot cancel: some items are paid",
                already_paid: "Already paid",
                not_paid: "This item is not paid",
                slip_required: "Attach the slip (JPG, PNG or PDF up to 10 MB)",
                no_slip: "No slip",
                member_not_found: "Member not found",
                schema_missing: "This feature's database is not installed yet (SQL pending)",
            },
        },
        lp: {
            create: "Create page",
            save_draft: "Save draft",
            publish: "Publish",
            unpublish: "Unpublish",
            archive: "Archive",
            duplicate: "Duplicate",
            delete: "Delete",
            history: "Version history",
            restore: "Restore to draft",
            rotate_preview: "New preview link",
            open_preview_tab: "Open preview in new tab",
            edit: "Edit",
            open_page: "Open page",
            search: "Search title or slug",
            tab_all: "All",
            state: {
                published: "Published",
                live: "Live",
                scheduled: "Scheduled",
                ended: "Ended",
                draft: "Draft",
                archived: "Archived",
                unpublished_changes: "Unpublished changes",
            },
            col: {
                page: "Page",
                state: "State",
                window: "Window",
                version: "Version",
                updated: "Updated",
                actions: "Actions",
            },
            always: "Always",
            from: "From",
            until: "Until",
            field: {
                title: "Title",
                slug: "Slug",
                starts_at: "Starts",
                ends_at: "Ends",
                fallback_url: "Fallback URL",
                seo_title: "SEO title",
                seo_description: "Description",
                og_image: "Share image",
                noindex: "Hide from Google (noindex)",
            },
            slug_hint: "a-z, 0-9 and - only, 3–60 characters",
            slug_status: {
                checking: "Checking…",
                available: "Available",
                format: "Invalid format",
                taken: "Slug already used",
                reserved: "Reserved slug",
                old_slug: "Slug was used by another page before",
            },
            card_page: "Page",
            card_seo: "SEO / sharing",
            ad_link: "Ad link",
            copy_ad_link: "Copy ad link",
            copy_params: "Copy parameters only",
            ad_link_hint: "Paste into the Meta ad URL — Meta fills the {{…}} values",
            copied: "Copied",
            sections: "Sections",
            add_section: "Add section",
            visible: "Visible",
            move_up: "Move up",
            move_down: "Move down",
            remove_section: "Remove section",
            empty_sections: "No sections yet — press + Add section",
            type: {
                hero: "Hero + CTA",
                product_grid: "Product grid",
                featured_product: "Featured product (Buy now)",
                promotion: "Bundles/promotions",
                countdown: "Countdown",
                coupon: "Coupon claim",
                rich_text: "Rich text",
                faq: "FAQ",
                line_chat: "LINE chat button",
                sticky_cta: "Sticky bottom CTA",
            },
            type_desc: {
                hero: "Big image or video with a button; must be the first section",
                product_grid: "Up to 24 products, 2 columns on phones",
                featured_product: "One product with Add to cart / Buy now (max 3 per page)",
                promotion: "Cards of active bundles/promotions, max 6",
                countdown: "Clock counting down to a time",
                coupon: "Button that puts a code in the customer's wallet",
                rich_text: "Formatted text, images, lists",
                faq: "Expandable questions and answers",
                line_chat: "Green button opening the LINE OA chat",
                sticky_cta: "Button pinned to the bottom on phones (1 per page)",
            },
            f: {
                image: "Desktop image",
                image_mobile: "Mobile image",
                video: "Video (optional)",
                video_poster: "Video poster",
                title: "Title",
                subtitle: "Subtitle",
                cta_label: "Button text",
                cta_action: "Button action",
                cta_scroll: "Scroll to section",
                cta_link: "Link",
                cta_target: "Choose section",
                text_theme: "Text colour",
                theme_light: "Light (white text)",
                theme_dark: "Dark (black text)",
                overlay: "Overlay opacity (%)",
                products: "Products",
                product: "Product",
                title_override: "Display name (optional)",
                badge_text: "Badge",
                show_description: "Show product description",
                promotions: "Bundles/promotions",
                ends_at: "Ends at",
                ended_text: "Text after the end",
                hide_when_ended: "Hide when ended",
                theme: "Theme",
                description: "Description",
                code: "Coupon code",
                button_label: "Button text",
                html: "Content",
                faq_q: "Question",
                faq_a: "Answer",
                add_faq: "Add question",
                label: "Button text",
                url: "LINE URL",
                note: "Note under the button",
                sublabel: "Sub-label",
                search_product: "Search product (code or name)",
                search_promotion: "Pick bundles/promotions",
            },
            hint: {
                video_drop: "Click or drop a file (MP4, max 15 MB)",
                image: "Recommended 1920×800",
                image_mobile: "Recommended 1080×1350 (4:5)",
                og_image: "Recommended 1200×630",
                video: "mp4 up to 15 MB, autoplays muted",
                fallback_url: "e.g. / or /products",
                window: "Bangkok time. Empty = immediately / no end",
            },
            preview: "Phone preview",
            preview_desktop: "Desktop",
            preview_none: "Save a draft to see the preview",
            saved: "Draft saved",
            published: "Published",
            unpublished: "Unpublished",
            archived_ok: "Archived",
            deleted: "Deleted",
            restored: "Restored to draft",
            rotated: "New preview link created; old links stop working",
            duplicated: "Duplicated",
            created: "Page created",
            confirm_unpublish: "Unpublish this page? Ad links stop working until it is published again.",
            confirm_archive: "Archive this page?",
            confirm_delete: "Delete this page?",
            confirm_restore: "Replace the current draft with this version?",
            confirm_rotate: "Create a new preview link? The old one stops working.",
            confirm_leave: "You have unsaved changes. Leave this page?",
            confirm_remove_section: "Remove this section?",
            duplicate_title: "Duplicate page",
            history_empty: "Never published",
            version: "Version",
            published_at: "Published at",
            published_by: "By",
            reload: "Reload",
            read_only: "You have view-only access",
            cancel: "Cancel",
            confirm: "Confirm",
            close: "Close",
            unsaved: "Unsaved",
            err: {
                slug_taken: "Slug already used",
                stale_draft: "Someone else edited this page — reload",
                publish_invalid: "Cannot publish yet, fix the marked fields",
                unavailable_product: "Not shown on storefront",
                invalid_slug: "Invalid slug",
                invalid_link: "Links must be /path or https://*.madamefin.com",
                is_published: "Unpublish it first",
                invalid_body: "Invalid data",
                invalid_content_type: "File type not supported",
                generic: "Something went wrong",
                load: "Could not load",
                file_too_large: "File too large (max {mb} MB)",
            },
            rule: {
                required: "Required",
                max_length: "Too long",
                invalid_link: "Link not allowed",
                too_many: "Too many",
                duplicate: "Duplicate section id",
                hero_first: "The hero must be the first visible section",
                invalid_target: "Target section not found",
                in_past: "Must be in the future",
                range: "End must be after start",
                format: "Invalid format",
            },
        },
        report: {
            title: "Order sources / ads",
            range: "Date range",
            model: "Model",
            model_last: "Last touch before purchase",
            model_first: "First touch",
            group_by: "Group by",
            group: {
                source: "Source",
                source_medium: "Source + medium",
                campaign: "Campaign",
                content: "Ad (utm_content)",
                term: "Ad set (utm_term)",
                landing_page: "Landing page",
            },
            source: "Source",
            medium: "Medium",
            campaign: "Campaign",
            lp: "Landing page",
            channel: "Channel",
            channel_all: "All channels",
            channels: {
                shop: "Website",
                member: "Member web",
                app: "App",
                guest: "Guest",
                chat: "Chat",
            },
            search: "Search",
            export: "Export CSV",
            card: {
                orders: "Orders",
                revenue_placed: "Placed revenue",
                revenue_completed: "Completed revenue (130)",
                completion: "Completion %",
                aov: "AOV",
                new_members: "New members",
            },
            chart_title: "Daily orders (top 5 sources)",
            other: "Other",
            col: {
                source: "Source",
                medium: "Medium",
                campaign: "Campaign",
                content: "Ad",
                term: "Ad set",
                lp_slug: "Landing page",
                orders: "Orders",
                open: "Open",
                completed: "Completed",
                cancelled: "Cancelled",
                returned: "Returned",
                revenue_placed: "Placed revenue",
                revenue_completed: "Completed revenue",
                revenue_cancelled_returned: "Cancelled/returned revenue",
                aov: "AOV",
                customers: "Customers",
                new_members: "New members",
            },
            total: "Total",
            truncated: "Showing the first 500 rows (by orders)",
            footnote: "Counts only MadameFin web/app orders already in the back office — no visit/click data (see Meta Ads Manager)",
            drawer_title: "Orders in this group",
            order_no: "Order no.",
            ordered_at: "Ordered at",
            status: "Status",
            amount: "Paid",
            invalid_range: "Invalid date range (max 366 days)",
            empty: "No data in this range",
            load_error: "Could not load the report",
            new_members_na: "New-member data not available yet (SQL pending)",
        },
    },
    // Phase 3 affiliate §5.1 — users-page role label (`user` is already a string key)
    // spec 2026-10-16 §6 (bo-api #980): the old "ผู้ขาย" role checkbox is read-only
    seller_perm: {
        managed_in_seller_center: "Managed in the Seller Center",
    },
    user_role: {
        affiliate_finance: "Affiliate finance (documents / payouts)",
    },
    // spec 2026-10-14 §5.3/§5.4 — BO tracking failures, recipient edit, stuck-112 revert
    // bo-api #931: admin set / change of an order's tracking number
    tracking_change: {
        action: "Change tracking number",
        title: "Change tracking number: order #{id}",
        current: "Current tracking number",
        none: "No tracking number yet",
        new: "New tracking number",
        hint: "Nothing is booked with the carrier; only the number you enter is saved",
        replace_warning: "This order already has tracking number {tn}; it will be replaced",
        cancelled_warning: "This order is cancelled. Make sure before saving a tracking number",
        confirm_title: "Confirm tracking number",
        confirm_replace: "Change the tracking number from {old} to {new}?",
        confirm_cancelled: "This order is cancelled. Save tracking number {new} anyway?",
        has_tracking_now: "This order just got a tracking number. Replace it with {new}?",
        has_tracking: "This order already has a tracking number",
        same: "The new number is the same as the current one",
        saved: "Tracking number {tn} saved"
    },
    tracking_failure: {
        skipped_barcode_not_saved: "Skipped {n} (barcode issued but not saved)",
        attach_tracking: "Enter issued tracking number",
        attach_title: "Enter issued tracking number: order #{id}",
        attach_label: "Tracking number already issued by the carrier",
        attach_hint: "Use the number in the message above or the ORPHAN BARCODE log. No new barcode is booked",
        attach_saved: "Tracking number {tn} saved",
        attach_has_tracking: "This order already has a tracking number",
        revert_has_tracking: "This order already has a tracking number, so it cannot return to awaiting cut-off",
        badge: "No tracking {n}",
        title: "Tracking generation failed: round #{id}",
        title_all: "Tracking generation failed (last 14 days)",
        banner: "{n} orders failed to get a tracking number",
        view: "View",
        retry: "Generate Thailand Post tracking again ({n})",
        retry_result: "Succeeded {ok} / failed {fail}",
        edit_recipient: "Edit recipient",
        edit_title: "Edit recipient: order #{id}",
        edit_saved: "Recipient saved",
        edited: "Edited by {name}",
        edited_me: "you",
        select_all: "Select all failed",
        total: "{n} orders",
        empty: "No orders are missing a tracking number",
        table_not_ready: "The failure log table is not installed yet (SQL not applied). Only orders without a tracking number are listed",
        round_no: "Round #{id}",
        col_order: "Order",
        col_recipient: "Recipient",
        col_phone: "Phone",
        col_postcode: "Postcode",
        col_reason: "Reason",
        col_attempts: "Attempts",
        col_last: "Last attempt",
        f_name: "Recipient name",
        f_phone: "Phone",
        f_address: "Address",
        f_area_search: "Search subdistrict / district / province / postcode",
        f_area_search_hint: "Type a subdistrict or postcode, e.g. \"Lumphini\" or \"10330\"",
        phone_mobile_invalid: "The recipient phone must be a 10-digit mobile number starting with 06, 08 or 09",
        cod_phone_warning: "COD order: Thailand Post calls this number to collect the payment",
        detail_line: "Tracking generation failed: {reason}",
        stuck_banner: "{n} orders are awaiting collection but belong to no round",
        revert: "Return to awaiting cut-off",
        revert_confirm: "Return {n} orders to awaiting cut-off so they can be cut again?",
        revert_done: "Returned {n} / {total} orders",
        reason: {
            barcode_not_saved: "Carrier issued a barcode but it wasn't saved — don't retry, contact an admin",
            phone_invalid: "Recipient phone is invalid (must be a 10-digit mobile)",
            recipient_name_invalid: "Recipient name is missing or invalid",
            address_invalid: "Recipient address is incomplete or invalid",
            area_invalid: "Subdistrict/district/province is invalid",
            postcode_invalid: "Postcode is invalid",
            carrier_rejected: "Thailand Post rejected the data",
            carrier_auth: "Cannot authenticate with Thailand Post. Contact an admin",
            carrier_unavailable: "Thailand Post did not respond. Try again later",
            no_tracking_returned: "Thailand Post returned no tracking number",
            no_provider: "This order's carrier cannot auto-generate tracking",
            internal: "System error",
            unknown: "No tracking yet (unknown reason, try again)",
        },
    },
};
